import img_0 from '../../assets/puzzle-anim/images/img_0.png';


export default {
    "v": "5.9.0",
    "fr": 29.9700012207031,
    "ip": 0,
    "op": 600.000024438501,
    "w": 2560,
    "h": 2880,
    "nm": "Final 2 File",
    "ddd": 0,
    "assets": [{"id": "image_0", "w": 849, "h": 212, "u": "", "p": img_0, "e": 0}, {
        "id": "comp_0",
        "nm": "Puzzles",
        "fr": 29.9700012207031,
        "layers": [{
            "ddd": 0,
            "ind": 1,
            "ty": 0,
            "nm": "Group 11",
            "refId": "comp_1",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 300,
                        "s": [1280, -392, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"t": 330.000013441176, "s": [1280, 1440, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [1280, 1440, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "w": 2560,
            "h": 2880,
            "ip": 0,
            "op": 450.000018328876,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 2,
            "ty": 0,
            "nm": "Group 10",
            "refId": "comp_2",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 270,
                        "s": [1280, -392, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"t": 300.00001221925, "s": [1280, 1440, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [1280, 1440, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "w": 2560,
            "h": 2880,
            "ip": 0,
            "op": 450.000018328876,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 3,
            "ty": 0,
            "nm": "Group 9",
            "refId": "comp_3",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 240,
                        "s": [1280, -392, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"t": 270.000010997325, "s": [1280, 1440, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [1280, 1440, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "w": 2560,
            "h": 2880,
            "ip": 0,
            "op": 450.000018328876,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 4,
            "ty": 0,
            "nm": "Group 8",
            "refId": "comp_4",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 210,
                        "s": [1280, -392, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"t": 240.0000097754, "s": [1280, 1440, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [1280, 1440, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "w": 2560,
            "h": 2880,
            "ip": 0,
            "op": 450.000018328876,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 5,
            "ty": 0,
            "nm": "Group 7",
            "refId": "comp_5",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 180,
                        "s": [1280, -394, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"t": 210.000008553475, "s": [1280, 1438, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [1280, 1440, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "w": 2560,
            "h": 2880,
            "ip": 0,
            "op": 450.000018328876,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 6,
            "ty": 0,
            "nm": "Group 6",
            "refId": "comp_6",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 150,
                        "s": [1280, -394, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"t": 180.00000733155, "s": [1280, 1438, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [1280, 1440, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "w": 2560,
            "h": 2880,
            "ip": 0,
            "op": 450.000018328876,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 7,
            "ty": 0,
            "nm": "Group 5",
            "refId": "comp_7",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 120,
                        "s": [1280, -392, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"t": 150.000006109625, "s": [1280, 1440, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [1280, 1440, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "w": 2560,
            "h": 2880,
            "ip": 0,
            "op": 450.000018328876,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 8,
            "ty": 0,
            "nm": "Group 4",
            "refId": "comp_8",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 90,
                        "s": [1280, -392, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"t": 120.0000048877, "s": [1280, 1440, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [1280, 1440, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "w": 2560,
            "h": 2880,
            "ip": 0,
            "op": 450.000018328876,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 9,
            "ty": 0,
            "nm": "Group 3",
            "refId": "comp_9",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 60,
                        "s": [1280, -392, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"t": 90.0000036657751, "s": [1280, 1440, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [1280, 1440, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "w": 2560,
            "h": 2880,
            "ip": 0,
            "op": 450.000018328876,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 10,
            "ty": 0,
            "nm": "Group 2",
            "refId": "comp_10",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 30,
                        "s": [1276, -398, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"t": 60.0000024438501, "s": [1276, 1434, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [1280, 1440, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "w": 2560,
            "h": 2880,
            "ip": 0,
            "op": 450.000018328876,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 11,
            "ty": 0,
            "nm": "Group 1",
            "refId": "comp_11",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 0,
                        "s": [1301.5, -402.5, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"t": 30.0000012219251, "s": [1301.5, 1429.5, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [1280, 1440, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "w": 2560,
            "h": 2880,
            "ip": 0,
            "op": 450.000018328876,
            "st": 0,
            "bm": 0
        }]
    }, {
        "id": "comp_1",
        "nm": "Group 11",
        "fr": 29.9700012207031,
        "layers": [{
            "ddd": 0,
            "ind": 1,
            "ty": 5,
            "nm": "Event",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1163.014, 766.829, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [0.557, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 32,
                            "f": "Roboto-Bold",
                            "t": "Event",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 38.4000015258789,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 2,
            "ty": 5,
            "nm": "Alias",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1630.014, 766.829, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [0.557, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 35,
                            "f": "Roboto-Bold",
                            "t": "Alias",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 42,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 3,
            "ty": 5,
            "nm": "Runtime",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1866.014, 767.829, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [0.557, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Runtime",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 4,
            "ty": 5,
            "nm": "Gateway",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1401.014, 766.829, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [0.557, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Gateway",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 5,
            "ty": 5,
            "nm": "Lambda",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [936.014, 766.829, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [0.557, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Lambda",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 6,
            "ty": 4,
            "nm": "a15 Outlines 5",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 90, "ix": 10},
                "p": {"a": 0, "k": [930.101, 768.315, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.453, 167.925, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[2.037, 21.889], [5.117, -2.713], [6.678, -0.538], [5.949, 11.768], [-9.353, 10.487], [-17.03, -8.256], [-0.687, 8.048], [-0.604, 20.639], [5.663, -0.069], [17.889, 0.113], [4.356, 0.842], [-3.485, 6.527], [-0.536, 6.702], [15.675, 1.628], [1.866, -15.731], [-4.291, -7.721], [7.603, -1.406], [4.239, -0.029], [17.887, 0.237], [-0.217, -6.29], [-0.103, -10.86], [-1.294, -9.745], [-6.676, 3.467], [-7.829, -0.298], [-2.521, -15.919], [15.14, -5.277], [10.13, 5.04], [1.182, -7.969], [0.005, -1.481], [0.121, -19.593], [-4.405, 0.034], [-10.649, 0], [-11.252, -1.142], [4.528, -8.153], [-0.179, -7.205], [-15.266, -2.402], [-4.586, 13.457], [5.03, 9.374], [-8.613, 0.808], [-7.446, 0.08], [-14.695, 0.003], [0.068, 4.759]],
                            "o": [[-0.542, -5.823], [-5.935, 3.147], [-13.409, 1.081], [-6.327, -12.518], [10.626, -11.913], [7.17, 3.476], [1.758, -20.621], [0.175, -5.966], [-17.887, 0.219], [-4.45, -0.028], [-7.284, -1.406], [3.167, -5.93], [1.237, -15.489], [-16.328, -1.697], [-1.041, 8.78], [3.773, 6.789], [-4.159, 0.77], [-17.889, 0.12], [-5.936, -0.078], [0.374, 10.848], [0.092, 9.787], [1.023, 7.703], [6.983, -3.628], [16.042, 0.61], [2.471, 15.601], [-10.95, 3.816], [-7.095, -3.531], [-0.218, 1.472], [-0.069, 19.593], [-0.029, 4.746], [10.648, -0.082], [11.285, 0.021], [9.453, 0.959], [-3.529, 6.353], [0.376, 15.061], [13.664, 2.151], [3.55, -10.416], [-4.115, -7.669], [7.408, -0.695], [14.694, -0.158], [3.745, 0], [-0.311, -21.922]],
                            "v": [[103.167, 31.429], [95.683, 27.357], [76.866, 33.025], [44.122, 14.941], [49.055, -22.562], [94.372, -28.555], [103.332, -33.654], [104.232, -95.589], [96.31, -103.322], [42.642, -103.269], [29.315, -104.397], [23.846, -115.806], [29.62, -134.569], [3.196, -165.978], [-29.609, -140.64], [-24.399, -116.104], [-30.001, -104.316], [-42.699, -103.249], [-96.367, -103.264], [-104.638, -95.217], [-104.536, -62.637], [-103.91, -33.284], [-95.065, -28.462], [-72.882, -33.382], [-41.203, -5.194], [-63.174, 31.065], [-94.687, 28.077], [-103.93, 33.05], [-104.42, 37.489], [-104.588, 96.268], [-97.866, 102.616], [-65.92, 102.589], [-32.088, 103.468], [-24.871, 116.549], [-29.734, 136.753], [-4.083, 165.524], [28.025, 145.706], [24.241, 116.238], [30.761, 103.674], [53.086, 102.688], [97.171, 102.598], [104.085, 97.191]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.953160125134, 0.998431396484, 0.702425728592, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.454, 167.925], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 7,
            "ty": 4,
            "nm": "a15 Outlines 6",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 90, "ix": 10},
                "p": {"a": 0, "k": [1861.101, 769.315, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.453, 167.925, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[2.037, 21.889], [5.117, -2.713], [6.678, -0.538], [5.949, 11.768], [-9.353, 10.487], [-17.03, -8.256], [-0.687, 8.048], [-0.604, 20.639], [5.663, -0.069], [17.889, 0.113], [4.356, 0.842], [-3.485, 6.527], [-0.536, 6.702], [15.675, 1.628], [1.866, -15.731], [-4.291, -7.721], [7.603, -1.406], [4.239, -0.029], [17.887, 0.237], [-0.217, -6.29], [-0.103, -10.86], [-1.294, -9.745], [-6.676, 3.467], [-7.829, -0.298], [-2.521, -15.919], [15.14, -5.277], [10.13, 5.04], [1.182, -7.969], [0.005, -1.481], [0.121, -19.593], [-4.405, 0.034], [-10.649, 0], [-11.252, -1.142], [4.528, -8.153], [-0.179, -7.205], [-15.266, -2.402], [-4.586, 13.457], [5.03, 9.374], [-8.613, 0.808], [-7.446, 0.08], [-14.695, 0.003], [0.068, 4.759]],
                            "o": [[-0.542, -5.823], [-5.935, 3.147], [-13.409, 1.081], [-6.327, -12.518], [10.626, -11.913], [7.17, 3.476], [1.758, -20.621], [0.175, -5.966], [-17.887, 0.219], [-4.45, -0.028], [-7.284, -1.406], [3.167, -5.93], [1.237, -15.489], [-16.328, -1.697], [-1.041, 8.78], [3.773, 6.789], [-4.159, 0.77], [-17.889, 0.12], [-5.936, -0.078], [0.374, 10.848], [0.092, 9.787], [1.023, 7.703], [6.983, -3.628], [16.042, 0.61], [2.471, 15.601], [-10.95, 3.816], [-7.095, -3.531], [-0.218, 1.472], [-0.069, 19.593], [-0.029, 4.746], [10.648, -0.082], [11.285, 0.021], [9.453, 0.959], [-3.529, 6.353], [0.376, 15.061], [13.664, 2.151], [3.55, -10.416], [-4.115, -7.669], [7.408, -0.695], [14.694, -0.158], [3.745, 0], [-0.311, -21.922]],
                            "v": [[103.167, 31.429], [95.683, 27.357], [76.866, 33.025], [44.122, 14.941], [49.055, -22.562], [94.372, -28.555], [103.332, -33.654], [104.232, -95.589], [96.31, -103.322], [42.642, -103.269], [29.315, -104.397], [23.846, -115.806], [29.62, -134.569], [3.196, -165.978], [-29.609, -140.64], [-24.399, -116.104], [-30.001, -104.316], [-42.699, -103.249], [-96.367, -103.264], [-104.638, -95.217], [-104.536, -62.637], [-103.91, -33.284], [-95.065, -28.462], [-72.882, -33.382], [-41.203, -5.194], [-63.174, 31.065], [-94.687, 28.077], [-103.93, 33.05], [-104.42, 37.489], [-104.588, 96.268], [-97.866, 102.616], [-65.92, 102.589], [-32.088, 103.468], [-24.871, 116.549], [-29.734, 136.753], [-4.083, 165.524], [28.025, 145.706], [24.241, 116.238], [30.761, 103.674], [53.086, 102.688], [97.171, 102.598], [104.085, 97.191]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.953160125134, 0.998431396484, 0.702425728592, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.454, 167.925], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 8,
            "ty": 4,
            "nm": "a15 Outlines 3",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 90, "ix": 10},
                "p": {"a": 0, "k": [1396.101, 768.315, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.453, 167.925, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[2.037, 21.889], [5.117, -2.713], [6.678, -0.538], [5.949, 11.768], [-9.353, 10.487], [-17.03, -8.256], [-0.687, 8.048], [-0.604, 20.639], [5.663, -0.069], [17.889, 0.113], [4.356, 0.842], [-3.485, 6.527], [-0.536, 6.702], [15.675, 1.628], [1.866, -15.731], [-4.291, -7.721], [7.603, -1.406], [4.239, -0.029], [17.887, 0.237], [-0.217, -6.29], [-0.103, -10.86], [-1.294, -9.745], [-6.676, 3.467], [-7.829, -0.298], [-2.521, -15.919], [15.14, -5.277], [10.13, 5.04], [1.182, -7.969], [0.005, -1.481], [0.121, -19.593], [-4.405, 0.034], [-10.649, 0], [-11.252, -1.142], [4.528, -8.153], [-0.179, -7.205], [-15.266, -2.402], [-4.586, 13.457], [5.03, 9.374], [-8.613, 0.808], [-7.446, 0.08], [-14.695, 0.003], [0.068, 4.759]],
                            "o": [[-0.542, -5.823], [-5.935, 3.147], [-13.409, 1.081], [-6.327, -12.518], [10.626, -11.913], [7.17, 3.476], [1.758, -20.621], [0.175, -5.966], [-17.887, 0.219], [-4.45, -0.028], [-7.284, -1.406], [3.167, -5.93], [1.237, -15.489], [-16.328, -1.697], [-1.041, 8.78], [3.773, 6.789], [-4.159, 0.77], [-17.889, 0.12], [-5.936, -0.078], [0.374, 10.848], [0.092, 9.787], [1.023, 7.703], [6.983, -3.628], [16.042, 0.61], [2.471, 15.601], [-10.95, 3.816], [-7.095, -3.531], [-0.218, 1.472], [-0.069, 19.593], [-0.029, 4.746], [10.648, -0.082], [11.285, 0.021], [9.453, 0.959], [-3.529, 6.353], [0.376, 15.061], [13.664, 2.151], [3.55, -10.416], [-4.115, -7.669], [7.408, -0.695], [14.694, -0.158], [3.745, 0], [-0.311, -21.922]],
                            "v": [[103.167, 31.429], [95.683, 27.357], [76.866, 33.025], [44.122, 14.941], [49.055, -22.562], [94.372, -28.555], [103.332, -33.654], [104.232, -95.589], [96.31, -103.322], [42.642, -103.269], [29.315, -104.397], [23.846, -115.806], [29.62, -134.569], [3.196, -165.978], [-29.609, -140.64], [-24.399, -116.104], [-30.001, -104.316], [-42.699, -103.249], [-96.367, -103.264], [-104.638, -95.217], [-104.536, -62.637], [-103.91, -33.284], [-95.065, -28.462], [-72.882, -33.382], [-41.203, -5.194], [-63.174, 31.065], [-94.687, 28.077], [-103.93, 33.05], [-104.42, 37.489], [-104.588, 96.268], [-97.866, 102.616], [-65.92, 102.589], [-32.088, 103.468], [-24.871, 116.549], [-29.734, 136.753], [-4.083, 165.524], [28.025, 145.706], [24.241, 116.238], [30.761, 103.674], [53.086, 102.688], [97.171, 102.598], [104.085, 97.191]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.953160125134, 0.998431396484, 0.702425728592, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.454, 167.925], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 9,
            "ty": 4,
            "nm": "a15 Outlines 4",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1164.101, 769.315, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.453, 167.925, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[2.037, 21.889], [5.117, -2.713], [6.678, -0.538], [5.949, 11.768], [-9.353, 10.487], [-17.03, -8.256], [-0.687, 8.048], [-0.604, 20.639], [5.663, -0.069], [17.889, 0.113], [4.356, 0.842], [-3.485, 6.527], [-0.536, 6.702], [15.675, 1.628], [1.866, -15.731], [-4.291, -7.721], [7.603, -1.406], [4.239, -0.029], [17.887, 0.237], [-0.217, -6.29], [-0.103, -10.86], [-1.294, -9.745], [-6.676, 3.467], [-7.829, -0.298], [-2.521, -15.919], [15.14, -5.277], [10.13, 5.04], [1.182, -7.969], [0.005, -1.481], [0.121, -19.593], [-4.405, 0.034], [-10.649, 0], [-11.252, -1.142], [4.528, -8.153], [-0.179, -7.205], [-15.266, -2.402], [-4.586, 13.457], [5.03, 9.374], [-8.613, 0.808], [-7.446, 0.08], [-14.695, 0.003], [0.068, 4.759]],
                            "o": [[-0.542, -5.823], [-5.935, 3.147], [-13.409, 1.081], [-6.327, -12.518], [10.626, -11.913], [7.17, 3.476], [1.758, -20.621], [0.175, -5.966], [-17.887, 0.219], [-4.45, -0.028], [-7.284, -1.406], [3.167, -5.93], [1.237, -15.489], [-16.328, -1.697], [-1.041, 8.78], [3.773, 6.789], [-4.159, 0.77], [-17.889, 0.12], [-5.936, -0.078], [0.374, 10.848], [0.092, 9.787], [1.023, 7.703], [6.983, -3.628], [16.042, 0.61], [2.471, 15.601], [-10.95, 3.816], [-7.095, -3.531], [-0.218, 1.472], [-0.069, 19.593], [-0.029, 4.746], [10.648, -0.082], [11.285, 0.021], [9.453, 0.959], [-3.529, 6.353], [0.376, 15.061], [13.664, 2.151], [3.55, -10.416], [-4.115, -7.669], [7.408, -0.695], [14.694, -0.158], [3.745, 0], [-0.311, -21.922]],
                            "v": [[103.167, 31.429], [95.683, 27.357], [76.866, 33.025], [44.122, 14.941], [49.055, -22.562], [94.372, -28.555], [103.332, -33.654], [104.232, -95.589], [96.31, -103.322], [42.642, -103.269], [29.315, -104.397], [23.846, -115.806], [29.62, -134.569], [3.196, -165.978], [-29.609, -140.64], [-24.399, -116.104], [-30.001, -104.316], [-42.699, -103.249], [-96.367, -103.264], [-104.638, -95.217], [-104.536, -62.637], [-103.91, -33.284], [-95.065, -28.462], [-72.882, -33.382], [-41.203, -5.194], [-63.174, 31.065], [-94.687, 28.077], [-103.93, 33.05], [-104.42, 37.489], [-104.588, 96.268], [-97.866, 102.616], [-65.92, 102.589], [-32.088, 103.468], [-24.871, 116.549], [-29.734, 136.753], [-4.083, 165.524], [28.025, 145.706], [24.241, 116.238], [30.761, 103.674], [53.086, 102.688], [97.171, 102.598], [104.085, 97.191]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.953160125134, 0.998431396484, 0.702425728592, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.454, 167.925], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 10,
            "ty": 4,
            "nm": "a15 Outlines 2",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1630.101, 769.315, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.453, 167.925, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[2.037, 21.889], [5.117, -2.713], [6.678, -0.538], [5.949, 11.768], [-9.353, 10.487], [-17.03, -8.256], [-0.687, 8.048], [-0.604, 20.639], [5.663, -0.069], [17.889, 0.113], [4.356, 0.842], [-3.485, 6.527], [-0.536, 6.702], [15.675, 1.628], [1.866, -15.731], [-4.291, -7.721], [7.603, -1.406], [4.239, -0.029], [17.887, 0.237], [-0.217, -6.29], [-0.103, -10.86], [-1.294, -9.745], [-6.676, 3.467], [-7.829, -0.298], [-2.521, -15.919], [15.14, -5.277], [10.13, 5.04], [1.182, -7.969], [0.005, -1.481], [0.121, -19.593], [-4.405, 0.034], [-10.649, 0], [-11.252, -1.142], [4.528, -8.153], [-0.179, -7.205], [-15.266, -2.402], [-4.586, 13.457], [5.03, 9.374], [-8.613, 0.808], [-7.446, 0.08], [-14.695, 0.003], [0.068, 4.759]],
                            "o": [[-0.542, -5.823], [-5.935, 3.147], [-13.409, 1.081], [-6.327, -12.518], [10.626, -11.913], [7.17, 3.476], [1.758, -20.621], [0.175, -5.966], [-17.887, 0.219], [-4.45, -0.028], [-7.284, -1.406], [3.167, -5.93], [1.237, -15.489], [-16.328, -1.697], [-1.041, 8.78], [3.773, 6.789], [-4.159, 0.77], [-17.889, 0.12], [-5.936, -0.078], [0.374, 10.848], [0.092, 9.787], [1.023, 7.703], [6.983, -3.628], [16.042, 0.61], [2.471, 15.601], [-10.95, 3.816], [-7.095, -3.531], [-0.218, 1.472], [-0.069, 19.593], [-0.029, 4.746], [10.648, -0.082], [11.285, 0.021], [9.453, 0.959], [-3.529, 6.353], [0.376, 15.061], [13.664, 2.151], [3.55, -10.416], [-4.115, -7.669], [7.408, -0.695], [14.694, -0.158], [3.745, 0], [-0.311, -21.922]],
                            "v": [[103.167, 31.429], [95.683, 27.357], [76.866, 33.025], [44.122, 14.941], [49.055, -22.562], [94.372, -28.555], [103.332, -33.654], [104.232, -95.589], [96.31, -103.322], [42.642, -103.269], [29.315, -104.397], [23.846, -115.806], [29.62, -134.569], [3.196, -165.978], [-29.609, -140.64], [-24.399, -116.104], [-30.001, -104.316], [-42.699, -103.249], [-96.367, -103.264], [-104.638, -95.217], [-104.536, -62.637], [-103.91, -33.284], [-95.065, -28.462], [-72.882, -33.382], [-41.203, -5.194], [-63.174, 31.065], [-94.687, 28.077], [-103.93, 33.05], [-104.42, 37.489], [-104.588, 96.268], [-97.866, 102.616], [-65.92, 102.589], [-32.088, 103.468], [-24.871, 116.549], [-29.734, 136.753], [-4.083, 165.524], [28.025, 145.706], [24.241, 116.238], [30.761, 103.674], [53.086, 102.688], [97.171, 102.598], [104.085, 97.191]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.953160125134, 0.998431396484, 0.702425728592, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.454, 167.925], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }]
    }, {
        "id": "comp_2",
        "nm": "Group 10",
        "fr": 29.9700012207031,
        "layers": [{
            "ddd": 0,
            "ind": 1,
            "ty": 5,
            "nm": "Auth",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [2102.009, 1232.829, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [0.557, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Auth",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 2,
            "ty": 5,
            "nm": "AddOn",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [2102.019, 998.829, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [0.557, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "AddOn",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 3,
            "ty": 5,
            "nm": "Node",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1631.014, 998.829, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [0.557, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Node",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 4,
            "ty": 5,
            "nm": "SA",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1864.369, 1232.829, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [0.557, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "SA",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 5,
            "ty": 5,
            "nm": "IRSA",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1863.658, 998.829, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [0.557, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 38,
                            "f": "Roboto-Bold",
                            "t": "IRSA",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 45.6000022888184,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 6,
            "ty": 5,
            "nm": "EKS",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1398.014, 998.829, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [0.557, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "EKS",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 7,
            "ty": 4,
            "nm": "a7 Outlines 2",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 180, "ix": 10},
                "p": {"a": 0, "k": [2060.323, 1002.475, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [137.647, 103.294, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-5.35, 0.056], [-19.8, 0.221], [4.848, 10.465], [-20.244, 5.644], [-9.287, -10.836], [6.384, -14.025], [-10.218, -0.124], [-20.438, -0.203], [0.05, 5.144], [-0.052, 17.673], [-0.467, 3.788], [-7.881, -4.155], [-5.535, -0.742], [-3.403, 14.19], [14.25, 5.245], [8.582, -5.005], [0.349, 10.746], [0.006, 4.258], [-0.21, 15.754], [5.518, -0.059], [20.438, -0.252], [-4.554, -9.325], [-0.65, -4.222], [15.588, -5.486], [8.11, 14.629], [-6.137, 12.08], [6.961, 0.197], [10.857, 0], [0, 0.115], [10.43, 0.204], [-0.01, -5.517], [0.134, -63.665]],
                            "o": [[19.8, -0.206], [11.798, -0.132], [-9.496, -20.497], [13.811, -3.851], [10.485, 12.233], [-4.108, 9.025], [20.437, 0.25], [5.275, 0.052], [-0.168, -17.671], [0.011, -3.828], [1.106, -8.965], [4.974, 2.623], [15.114, 2.026], [3.611, -15.059], [-9.545, -3.512], [-12.632, 7.367], [-0.138, -4.255], [-0.021, -15.757], [0.072, -5.461], [-20.438, 0.221], [-10.175, 0.125], [1.89, 3.87], [2.596, 16.863], [-15.599, 5.49], [-6.796, -12.259], [3.149, -6.198], [-10.848, -0.307], [0, -0.115], [-10.433, 0], [-5.451, -0.107], [0.113, 63.664], [-0.012, 5.677]],
                            "v": [[-129.786, 102.987], [-70.382, 102.747], [-62.82, 90.971], [-42.671, 41.647], [-7.387, 51.945], [-3.647, 92.086], [3.077, 102.697], [64.396, 102.984], [71.457, 95.714], [71.433, 42.695], [71.899, 31.219], [84.887, 24.244], [100.576, 29.378], [133.785, 7.519], [115.495, -27.644], [87.694, -25.477], [71.563, -35.281], [71.396, -48.053], [71.456, -95.323], [63.996, -102.938], [2.678, -102.622], [-3.54, -91.909], [0.219, -79.75], [-21.66, -42.201], [-62.312, -57.451], [-61.223, -94.125], [-65.979, -102.451], [-98.548, -102.531], [-98.548, -102.878], [-129.847, -102.936], [-137.372, -95.38], [-137.385, 95.615]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.844705858418, 0.392871003992, 0.720318184647, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [137.647, 103.294], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 8,
            "ty": 4,
            "nm": "a15 Outlines 2",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1864.101, 1002.315, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.453, 167.925, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[2.037, 21.889], [5.117, -2.713], [6.678, -0.538], [5.949, 11.768], [-9.353, 10.487], [-17.03, -8.256], [-0.687, 8.048], [-0.604, 20.639], [5.663, -0.069], [17.889, 0.113], [4.356, 0.842], [-3.485, 6.527], [-0.536, 6.702], [15.675, 1.628], [1.866, -15.731], [-4.291, -7.721], [7.603, -1.406], [4.239, -0.029], [17.887, 0.237], [-0.217, -6.29], [-0.103, -10.86], [-1.294, -9.745], [-6.676, 3.467], [-7.829, -0.298], [-2.521, -15.919], [15.14, -5.277], [10.13, 5.04], [1.182, -7.969], [0.005, -1.481], [0.121, -19.593], [-4.405, 0.034], [-10.649, 0], [-11.252, -1.142], [4.528, -8.153], [-0.179, -7.205], [-15.266, -2.402], [-4.586, 13.457], [5.03, 9.374], [-8.613, 0.808], [-7.446, 0.08], [-14.695, 0.003], [0.068, 4.759]],
                            "o": [[-0.542, -5.823], [-5.935, 3.147], [-13.409, 1.081], [-6.327, -12.518], [10.626, -11.913], [7.17, 3.476], [1.758, -20.621], [0.175, -5.966], [-17.887, 0.219], [-4.45, -0.028], [-7.284, -1.406], [3.167, -5.93], [1.237, -15.489], [-16.328, -1.697], [-1.041, 8.78], [3.773, 6.789], [-4.159, 0.77], [-17.889, 0.12], [-5.936, -0.078], [0.374, 10.848], [0.092, 9.787], [1.023, 7.703], [6.983, -3.628], [16.042, 0.61], [2.471, 15.601], [-10.95, 3.816], [-7.095, -3.531], [-0.218, 1.472], [-0.069, 19.593], [-0.029, 4.746], [10.648, -0.082], [11.285, 0.021], [9.453, 0.959], [-3.529, 6.353], [0.376, 15.061], [13.664, 2.151], [3.55, -10.416], [-4.115, -7.669], [7.408, -0.695], [14.694, -0.158], [3.745, 0], [-0.311, -21.922]],
                            "v": [[103.167, 31.429], [95.683, 27.357], [76.866, 33.025], [44.122, 14.941], [49.055, -22.562], [94.372, -28.555], [103.332, -33.654], [104.232, -95.589], [96.31, -103.322], [42.642, -103.269], [29.315, -104.397], [23.846, -115.806], [29.62, -134.569], [3.196, -165.978], [-29.609, -140.64], [-24.399, -116.104], [-30.001, -104.316], [-42.699, -103.249], [-96.367, -103.264], [-104.638, -95.217], [-104.536, -62.637], [-103.91, -33.284], [-95.065, -28.462], [-72.882, -33.382], [-41.203, -5.194], [-63.174, 31.065], [-94.687, 28.077], [-103.93, 33.05], [-104.42, 37.489], [-104.588, 96.268], [-97.866, 102.616], [-65.92, 102.589], [-32.088, 103.468], [-24.871, 116.549], [-29.734, 136.753], [-4.083, 165.524], [28.025, 145.706], [24.241, 116.238], [30.761, 103.674], [53.086, 102.688], [97.171, 102.598], [104.085, 97.191]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.844705858418, 0.392871003992, 0.720318184647, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.454, 167.925], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 9,
            "ty": 4,
            "nm": "a16 Outlines 2",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1862.472, 1232.769, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [169.667, 103.299, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-13.823, 7.193], [-10.473, -11.934], [7.324, -14.669], [-8.642, -0.207], [-10.433, 0], [-0.001, -0.085], [-8.305, 0.001], [-0.041, 13.42], [-0.49, 18.728], [-9.564, -4.882], [-7.187, 0.318], [-1.107, 14.256], [15.221, 3.388], [8.153, -4.197], [0.913, 9.665], [0.018, 5.108], [-0.249, 15.968], [5.934, -0.081], [19.376, -0.18], [-4.809, -11.712], [10.395, -11.517], [13.543, 3.957], [-10.722, 21.676], [8.317, 0.131], [21.294, 0.147], [-0.018, -4.313], [0.055, -18.527], [0.413, -3.153], [7.962, 4.349], [5.734, 0.729], [2.915, -14.239], [-15.598, -4.268], [-7.757, 4.559], [-0.427, -11.911], [-0.004, -4.046], [0.231, -15.755], [-5.987, 0.078], [-20.23, 0.084], [-1.683, 0.23], [2.11, 4.011], [1.068, 4.393]],
                            "o": [[14.154, -7.365], [9.413, 10.725], [-3.812, 7.633], [10.427, 0.25], [0, 0.085], [8.305, 0], [13.663, -0.002], [0.056, -18.739], [0.287, -10.962], [6.408, 3.271], [14.838, -0.657], [1.238, -15.944], [-9.254, -2.059], [-8.524, 4.388], [-0.479, -5.076], [-0.055, -15.971], [0.088, -5.695], [-19.375, 0.265], [-12.981, 0.121], [5.681, 13.836], [-9.363, 10.374], [-21.114, -6.169], [3.695, -7.471], [-21.29, -0.335], [-4.9, -0.034], [0.078, 18.526], [-0.01, 3.19], [-1.171, 8.923], [-5.154, -2.814], [-14.954, -1.902], [-3.326, 16.243], [8.84, 2.419], [11.811, -6.943], [0.145, 4.042], [0.016, 15.758], [-0.082, 5.596], [20.227, -0.263], [1.7, -0.007], [4.11, -0.561], [-2.084, -3.963], [-3.906, -16.063]],
                            "v": [[-15.042, 44.178], [26.26, 51.842], [29.663, 93.217], [35.258, 102.588], [66.556, 102.646], [66.557, 102.902], [91.472, 102.902], [105.145, 89.479], [105.507, 33.266], [119.728, 24.856], [140.01, 29.585], [168.179, 3.187], [144.977, -28.782], [119.104, -24.387], [105.588, -31.773], [105.13, -47.09], [105.187, -95.004], [97.496, -102.968], [39.363, -102.752], [30.96, -90.177], [25.807, -51.318], [-9.121, -41.692], [-28.101, -92.846], [-33.659, -102.559], [-97.54, -102.896], [-103.598, -96], [-103.635, -40.421], [-104.054, -30.857], [-117.117, -24.257], [-133.477, -29.352], [-166.091, -6.753], [-145.074, 28.454], [-119.702, 25.476], [-103.703, 35.443], [-103.566, 47.58], [-103.635, 94.855], [-96.017, 102.971], [-35.329, 102.691], [-30.232, 102.368], [-26.627, 95.775], [-31.749, 83.417]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.844705858418, 0.392871003992, 0.720318184647, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [169.667, 103.3], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 10,
            "ty": 4,
            "nm": "a13 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 180, "ix": 10},
                "p": {"a": 0, "k": [2095.782, 1235.941, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.128, 167.783, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [],
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 11,
            "ty": 4,
            "nm": "a14 Outlines 3",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 90, "ix": 10},
                "p": {"a": 0, "k": [1396.601, 1000.277, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [169.936, 103.308, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-0.707, 3.733], [-6.485, -3.346], [-5.517, -0.874], [-2.35, 15.48], [17.36, 2.805], [7.341, -3.899], [0.926, 10.056], [0.019, 5.322], [-0.266, 15.756], [5.759, -0.072], [19.378, -0.183], [-4.938, -11.793], [18.82, -7.011], [9.044, 10.006], [-7.09, 14.535], [9.667, 0.117], [20.443, 0.238], [-0.057, -5.518], [0.073, -18.315], [0.503, -3.351], [7.323, 3.814], [5.767, 0.761], [2.172, -15.408], [-16.805, -2.493], [-7.403, 3.746], [-1.077, -10.068], [-0.009, -3.405], [0.279, -17.459], [-5.982, 0.08], [-18.316, 0.051], [-3.181, 0.263], [2.505, 4.682], [0.982, 3.015], [-15.104, 8.344], [-10.107, -12.904], [7.047, -14.032], [-7.298, -0.201], [-10.86, 0], [0, -0.1], [-9.797, 0.042], [-0.007, 8.408], [-0.084, 17.676]],
                            "o": [[1.364, -7.195], [4.981, 2.569], [16.639, 2.633], [2.658, -17.506], [-8.255, -1.334], [-8.976, 4.767], [-0.487, -5.287], [-0.055, -15.759], [0.099, -5.868], [-19.377, 0.244], [-12.867, 0.121], [8.481, 20.251], [-12.985, 4.838], [-9.73, -10.766], [4.194, -8.598], [-20.442, -0.248], [-5.506, -0.064], [0.186, 18.313], [-0.013, 3.401], [-1.24, 8.258], [-5.157, -2.686], [-16.093, -2.124], [-2.409, 17.089], [8.297, 1.231], [9.096, -4.602], [0.361, 3.377], [0.044, 17.463], [-0.099, 6.2], [18.313, -0.243], [3.191, -0.009], [4.787, -0.397], [-1.501, -2.805], [-5.636, -17.31], [13.793, -7.62], [10.099, 12.893], [-3.326, 6.621], [10.851, 0.299], [0, 0.101], [9.797, 0], [8.629, -0.036], [0.015, -17.677], [0.018, -3.818]],
                            "v": [[105.173, 29.425], [116.616, 23.764], [132.195, 29.252], [167.028, 5.642], [142.047, -29.183], [118.632, -24.638], [104.684, -31.927], [104.301, -47.886], [104.338, -95.164], [96.491, -102.986], [38.352, -102.767], [30.069, -90.143], [11.931, -42.314], [-25.024, -50.985], [-29.329, -92.238], [-35.666, -102.672], [-96.999, -102.97], [-104.49, -95.464], [-104.508, -40.518], [-105.054, -30.324], [-117.403, -23.91], [-133.656, -29.382], [-167.277, -4.898], [-142.274, 29.274], [-118.825, 24.748], [-104.847, 32.232], [-104.505, 42.442], [-104.551, 94.831], [-96.285, 102.978], [-41.339, 102.834], [-31.767, 102.424], [-27.724, 95.217], [-31.622, 86.489], [-15.906, 44.168], [26.155, 52.956], [28.36, 93.782], [33.171, 102.486], [65.748, 102.563], [65.748, 102.865], [95.138, 102.855], [104.287, 93.891], [104.334, 40.861]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.844705858418, 0.392871003992, 0.720318184647, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [169.936, 103.308], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 12,
            "ty": 4,
            "nm": "a14 Outlines 2",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1630.601, 1001.277, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [169.936, 103.308, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-0.707, 3.733], [-6.485, -3.346], [-5.517, -0.874], [-2.35, 15.48], [17.36, 2.805], [7.341, -3.899], [0.926, 10.056], [0.019, 5.322], [-0.266, 15.756], [5.759, -0.072], [19.378, -0.183], [-4.938, -11.793], [18.82, -7.011], [9.044, 10.006], [-7.09, 14.535], [9.667, 0.117], [20.443, 0.238], [-0.057, -5.518], [0.073, -18.315], [0.503, -3.351], [7.323, 3.814], [5.767, 0.761], [2.172, -15.408], [-16.805, -2.493], [-7.403, 3.746], [-1.077, -10.068], [-0.009, -3.405], [0.279, -17.459], [-5.982, 0.08], [-18.316, 0.051], [-3.181, 0.263], [2.505, 4.682], [0.982, 3.015], [-15.104, 8.344], [-10.107, -12.904], [7.047, -14.032], [-7.298, -0.201], [-10.86, 0], [0, -0.1], [-9.797, 0.042], [-0.007, 8.408], [-0.084, 17.676]],
                            "o": [[1.364, -7.195], [4.981, 2.569], [16.639, 2.633], [2.658, -17.506], [-8.255, -1.334], [-8.976, 4.767], [-0.487, -5.287], [-0.055, -15.759], [0.099, -5.868], [-19.377, 0.244], [-12.867, 0.121], [8.481, 20.251], [-12.985, 4.838], [-9.73, -10.766], [4.194, -8.598], [-20.442, -0.248], [-5.506, -0.064], [0.186, 18.313], [-0.013, 3.401], [-1.24, 8.258], [-5.157, -2.686], [-16.093, -2.124], [-2.409, 17.089], [8.297, 1.231], [9.096, -4.602], [0.361, 3.377], [0.044, 17.463], [-0.099, 6.2], [18.313, -0.243], [3.191, -0.009], [4.787, -0.397], [-1.501, -2.805], [-5.636, -17.31], [13.793, -7.62], [10.099, 12.893], [-3.326, 6.621], [10.851, 0.299], [0, 0.101], [9.797, 0], [8.629, -0.036], [0.015, -17.677], [0.018, -3.818]],
                            "v": [[105.173, 29.425], [116.616, 23.764], [132.195, 29.252], [167.028, 5.642], [142.047, -29.183], [118.632, -24.638], [104.684, -31.927], [104.301, -47.886], [104.338, -95.164], [96.491, -102.986], [38.352, -102.767], [30.069, -90.143], [11.931, -42.314], [-25.024, -50.985], [-29.329, -92.238], [-35.666, -102.672], [-96.999, -102.97], [-104.49, -95.464], [-104.508, -40.518], [-105.054, -30.324], [-117.403, -23.91], [-133.656, -29.382], [-167.277, -4.898], [-142.274, 29.274], [-118.825, 24.748], [-104.847, 32.232], [-104.505, 42.442], [-104.551, 94.831], [-96.285, 102.978], [-41.339, 102.834], [-31.767, 102.424], [-27.724, 95.217], [-31.622, 86.489], [-15.906, 44.168], [26.155, 52.956], [28.36, 93.782], [33.171, 102.486], [65.748, 102.563], [65.748, 102.865], [95.138, 102.855], [104.287, 93.891], [104.334, 40.861]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.844705858418, 0.392871003992, 0.720318184647, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [169.936, 103.308], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 13,
            "ty": 4,
            "nm": "a13 Outlines 2",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 180, "ix": 10},
                "p": {"a": 0, "k": [2095.782, 1233.941, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.128, 167.783, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-5.817, 0.117], [-12.35, 0.055], [-9.327, -1.023], [4.238, -7.876], [0.827, -5.313], [-18.053, -1.541], [-0.328, 17.124], [3.614, 6.329], [-9.029, 1.087], [-1.913, 0.02], [-19.799, -0.026], [0.194, 5.846], [0.147, 9.367], [1.567, 11.449], [6.49, -3.316], [6.226, -0.252], [6.968, 12.556], [-8.087, 11.209], [-18.252, -8.823], [-0.667, 8.051], [-0.286, 21.495], [3.699, -0.004], [14.053, 0.142], [8.238, 1.487], [-3.808, 7.056], [-0.426, 6.274], [10.565, 6.164], [10.448, -6.657], [-0.913, -11.808], [-2.962, -5.529], [7.098, -1.224], [4.24, -0.033], [17.035, -0.019], [0.002, -10.761], [-0.006, -30.664], [0.176, -31.727]],
                            "o": [[12.346, -0.249], [9.372, -0.041], [9.077, 0.996], [-2.56, 4.76], [-2.705, 17.377], [16.538, 1.411], [0.138, -7.189], [-4.454, -7.798], [1.9, -0.229], [19.799, -0.207], [5.735, 0.007], [-0.31, -9.359], [-0.179, -11.486], [-0.965, -7.045], [-5.58, 2.851], [-14.163, 0.574], [-6.735, -12.136], [10.288, -14.26], [7.466, 3.609], [1.778, -21.468], [0.065, -4.853], [-14.054, 0.013], [-8.291, -0.084], [-7.99, -1.441], [2.984, -5.529], [0.825, -12.118], [-10.609, -6.189], [-10.109, 6.442], [0.485, 6.283], [3.47, 6.478], [-4.175, 0.72], [-17.034, 0.134], [-11.083, 0.013], [-0.006, 30.664], [0, 31.728], [-0.031, 5.764]],
                            "v": [[-97.037, 103.069], [-59.987, 102.977], [-31.913, 103.897], [-24.91, 116.686], [-29.95, 131.738], [-2.087, 166.122], [29.12, 136.969], [24.166, 116.792], [30.991, 103.92], [36.726, 103.547], [96.124, 103.061], [103.991, 95.179], [103.882, 67.075], [103.118, 32.622], [94.481, 28.276], [76.826, 33.434], [44.403, 15.961], [46.802, -19.499], [93.994, -28.267], [103.1, -33.065], [103.86, -97.546], [96.904, -102.822], [54.742, -102.879], [29.88, -103.775], [23.819, -115.802], [29.289, -133.331], [15.173, -161.344], [-16.878, -160.775], [-30.063, -132.912], [-24.425, -115.437], [-29.864, -104.007], [-42.566, -102.914], [-93.671, -102.817], [-104.767, -92.039], [-104.763, -0.048], [-104.847, 95.136]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.844705858418, 0.392871003992, 0.720318184647, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.128, 167.783], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 14,
            "ty": 4,
            "nm": "a7 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 180, "ix": 10},
                "p": {"a": 0, "k": [2060.323, 1005.475, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [137.647, 103.294, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [],
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 15,
            "ty": 4,
            "nm": "a15 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1864.101, 1005.315, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.453, 167.925, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [],
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 16,
            "ty": 4,
            "nm": "a16 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1862.472, 1234.769, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [169.667, 103.299, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [],
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }]
    }, {
        "id": "comp_3",
        "nm": "Group 9",
        "fr": 29.9700012207031,
        "layers": [{
            "ddd": 0,
            "ind": 1,
            "ty": 5,
            "nm": "Public",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1395.876, 1234, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Public",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 2,
            "ty": 5,
            "nm": "Private",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1161.876, 1158, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Private",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 3,
            "ty": 5,
            "nm": "Record",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1161.876, 1009, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Record",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 4,
            "ty": 5,
            "nm": "Route54",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [693.876, 1009, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Route53",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 5,
            "ty": 5,
            "nm": "CNAME",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [925.876, 936, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "CNAME",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 6,
            "ty": 5,
            "nm": "DNS",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [455.876, 1009, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "DNS",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 7,
            "ty": 4,
            "nm": "a13 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [464.282, 1002.941, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.128, 167.783, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-5.817, 0.117], [-12.35, 0.055], [-9.327, -1.023], [4.238, -7.876], [0.827, -5.313], [-18.053, -1.541], [-0.328, 17.124], [3.614, 6.329], [-9.029, 1.087], [-1.913, 0.02], [-19.799, -0.026], [0.194, 5.846], [0.147, 9.367], [1.567, 11.449], [6.49, -3.316], [6.226, -0.252], [6.968, 12.556], [-8.087, 11.209], [-18.252, -8.823], [-0.667, 8.051], [-0.286, 21.495], [3.699, -0.004], [14.053, 0.142], [8.238, 1.487], [-3.808, 7.056], [-0.426, 6.274], [10.565, 6.164], [10.448, -6.657], [-0.913, -11.808], [-2.962, -5.529], [7.098, -1.224], [4.24, -0.033], [17.035, -0.019], [0.002, -10.761], [-0.006, -30.664], [0.176, -31.727]],
                            "o": [[12.346, -0.249], [9.372, -0.041], [9.077, 0.996], [-2.56, 4.76], [-2.705, 17.377], [16.538, 1.411], [0.138, -7.189], [-4.454, -7.798], [1.9, -0.229], [19.799, -0.207], [5.735, 0.007], [-0.31, -9.359], [-0.179, -11.486], [-0.965, -7.045], [-5.58, 2.851], [-14.163, 0.574], [-6.735, -12.136], [10.288, -14.26], [7.466, 3.609], [1.778, -21.468], [0.065, -4.853], [-14.054, 0.013], [-8.291, -0.084], [-7.99, -1.441], [2.984, -5.529], [0.825, -12.118], [-10.609, -6.189], [-10.109, 6.442], [0.485, 6.283], [3.47, 6.478], [-4.175, 0.72], [-17.034, 0.134], [-11.083, 0.013], [-0.006, 30.664], [0, 31.728], [-0.031, 5.764]],
                            "v": [[-97.037, 103.069], [-59.987, 102.977], [-31.913, 103.897], [-24.91, 116.686], [-29.95, 131.738], [-2.087, 166.122], [29.12, 136.969], [24.166, 116.792], [30.991, 103.92], [36.726, 103.547], [96.124, 103.061], [103.991, 95.179], [103.882, 67.075], [103.118, 32.622], [94.481, 28.276], [76.826, 33.434], [44.403, 15.961], [46.802, -19.499], [93.994, -28.267], [103.1, -33.065], [103.86, -97.546], [96.904, -102.822], [54.742, -102.879], [29.88, -103.775], [23.819, -115.802], [29.289, -133.331], [15.173, -161.344], [-16.878, -160.775], [-30.063, -132.912], [-24.425, -115.437], [-29.864, -104.007], [-42.566, -102.914], [-93.671, -102.817], [-104.767, -92.039], [-104.763, -0.048], [-104.847, 95.136]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.127540244308, 0.698203711416, 0.860392132927, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.128, 167.783], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 8,
            "ty": 4,
            "nm": "a15 Outlines 6",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": -90, "ix": 10},
                "p": {"a": 0, "k": [697.601, 1002.315, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.453, 167.925, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[2.037, 21.889], [5.117, -2.713], [6.678, -0.538], [5.949, 11.768], [-9.353, 10.487], [-17.03, -8.256], [-0.687, 8.048], [-0.604, 20.639], [5.663, -0.069], [17.889, 0.113], [4.356, 0.842], [-3.485, 6.527], [-0.536, 6.702], [15.675, 1.628], [1.866, -15.731], [-4.291, -7.721], [7.603, -1.406], [4.239, -0.029], [17.887, 0.237], [-0.217, -6.29], [-0.103, -10.86], [-1.294, -9.745], [-6.676, 3.467], [-7.829, -0.298], [-2.521, -15.919], [15.14, -5.277], [10.13, 5.04], [1.182, -7.969], [0.005, -1.481], [0.121, -19.593], [-4.405, 0.034], [-10.649, 0], [-11.252, -1.142], [4.528, -8.153], [-0.179, -7.205], [-15.266, -2.402], [-4.586, 13.457], [5.03, 9.374], [-8.613, 0.808], [-7.446, 0.08], [-14.695, 0.003], [0.068, 4.759]],
                            "o": [[-0.542, -5.823], [-5.935, 3.147], [-13.409, 1.081], [-6.327, -12.518], [10.626, -11.913], [7.17, 3.476], [1.758, -20.621], [0.175, -5.966], [-17.887, 0.219], [-4.45, -0.028], [-7.284, -1.406], [3.167, -5.93], [1.237, -15.489], [-16.328, -1.697], [-1.041, 8.78], [3.773, 6.789], [-4.159, 0.77], [-17.889, 0.12], [-5.936, -0.078], [0.374, 10.848], [0.092, 9.787], [1.023, 7.703], [6.983, -3.628], [16.042, 0.61], [2.471, 15.601], [-10.95, 3.816], [-7.095, -3.531], [-0.218, 1.472], [-0.069, 19.593], [-0.029, 4.746], [10.648, -0.082], [11.285, 0.021], [9.453, 0.959], [-3.529, 6.353], [0.376, 15.061], [13.664, 2.151], [3.55, -10.416], [-4.115, -7.669], [7.408, -0.695], [14.694, -0.158], [3.745, 0], [-0.311, -21.922]],
                            "v": [[103.167, 31.429], [95.683, 27.357], [76.866, 33.025], [44.122, 14.941], [49.055, -22.562], [94.372, -28.555], [103.332, -33.654], [104.232, -95.589], [96.31, -103.322], [42.642, -103.269], [29.315, -104.397], [23.846, -115.806], [29.62, -134.569], [3.196, -165.978], [-29.609, -140.64], [-24.399, -116.104], [-30.001, -104.316], [-42.699, -103.249], [-96.367, -103.264], [-104.638, -95.217], [-104.536, -62.637], [-103.91, -33.284], [-95.065, -28.462], [-72.882, -33.382], [-41.203, -5.194], [-63.174, 31.065], [-94.687, 28.077], [-103.93, 33.05], [-104.42, 37.489], [-104.588, 96.268], [-97.866, 102.616], [-65.92, 102.589], [-32.088, 103.468], [-24.871, 116.549], [-29.734, 136.753], [-4.083, 165.524], [28.025, 145.706], [24.241, 116.238], [30.761, 103.674], [53.086, 102.688], [97.171, 102.598], [104.085, 97.191]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.127540244308, 0.698203711416, 0.860392132927, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.454, 167.925], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 9,
            "ty": 4,
            "nm": "a15 Outlines 4",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": -90, "ix": 10},
                "p": {"a": 0, "k": [1162.601, 1000.315, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.453, 167.925, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[2.037, 21.889], [5.117, -2.713], [6.678, -0.538], [5.949, 11.768], [-9.353, 10.487], [-17.03, -8.256], [-0.687, 8.048], [-0.604, 20.639], [5.663, -0.069], [17.889, 0.113], [4.356, 0.842], [-3.485, 6.527], [-0.536, 6.702], [15.675, 1.628], [1.866, -15.731], [-4.291, -7.721], [7.603, -1.406], [4.239, -0.029], [17.887, 0.237], [-0.217, -6.29], [-0.103, -10.86], [-1.294, -9.745], [-6.676, 3.467], [-7.829, -0.298], [-2.521, -15.919], [15.14, -5.277], [10.13, 5.04], [1.182, -7.969], [0.005, -1.481], [0.121, -19.593], [-4.405, 0.034], [-10.649, 0], [-11.252, -1.142], [4.528, -8.153], [-0.179, -7.205], [-15.266, -2.402], [-4.586, 13.457], [5.03, 9.374], [-8.613, 0.808], [-7.446, 0.08], [-14.695, 0.003], [0.068, 4.759]],
                            "o": [[-0.542, -5.823], [-5.935, 3.147], [-13.409, 1.081], [-6.327, -12.518], [10.626, -11.913], [7.17, 3.476], [1.758, -20.621], [0.175, -5.966], [-17.887, 0.219], [-4.45, -0.028], [-7.284, -1.406], [3.167, -5.93], [1.237, -15.489], [-16.328, -1.697], [-1.041, 8.78], [3.773, 6.789], [-4.159, 0.77], [-17.889, 0.12], [-5.936, -0.078], [0.374, 10.848], [0.092, 9.787], [1.023, 7.703], [6.983, -3.628], [16.042, 0.61], [2.471, 15.601], [-10.95, 3.816], [-7.095, -3.531], [-0.218, 1.472], [-0.069, 19.593], [-0.029, 4.746], [10.648, -0.082], [11.285, 0.021], [9.453, 0.959], [-3.529, 6.353], [0.376, 15.061], [13.664, 2.151], [3.55, -10.416], [-4.115, -7.669], [7.408, -0.695], [14.694, -0.158], [3.745, 0], [-0.311, -21.922]],
                            "v": [[103.167, 31.429], [95.683, 27.357], [76.866, 33.025], [44.122, 14.941], [49.055, -22.562], [94.372, -28.555], [103.332, -33.654], [104.232, -95.589], [96.31, -103.322], [42.642, -103.269], [29.315, -104.397], [23.846, -115.806], [29.62, -134.569], [3.196, -165.978], [-29.609, -140.64], [-24.399, -116.104], [-30.001, -104.316], [-42.699, -103.249], [-96.367, -103.264], [-104.638, -95.217], [-104.536, -62.637], [-103.91, -33.284], [-95.065, -28.462], [-72.882, -33.382], [-41.203, -5.194], [-63.174, 31.065], [-94.687, 28.077], [-103.93, 33.05], [-104.42, 37.489], [-104.588, 96.268], [-97.866, 102.616], [-65.92, 102.589], [-32.088, 103.468], [-24.871, 116.549], [-29.734, 136.753], [-4.083, 165.524], [28.025, 145.706], [24.241, 116.238], [30.761, 103.674], [53.086, 102.688], [97.171, 102.598], [104.085, 97.191]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.127540244308, 0.698203711416, 0.860392132927, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.454, 167.925], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 10,
            "ty": 4,
            "nm": "a15 Outlines 3",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": -90, "ix": 10},
                "p": {"a": 0, "k": [1397.601, 1231.315, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.453, 167.925, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[2.037, 21.889], [5.117, -2.713], [6.678, -0.538], [5.949, 11.768], [-9.353, 10.487], [-17.03, -8.256], [-0.687, 8.048], [-0.604, 20.639], [5.663, -0.069], [17.889, 0.113], [4.356, 0.842], [-3.485, 6.527], [-0.536, 6.702], [15.675, 1.628], [1.866, -15.731], [-4.291, -7.721], [7.603, -1.406], [4.239, -0.029], [17.887, 0.237], [-0.217, -6.29], [-0.103, -10.86], [-1.294, -9.745], [-6.676, 3.467], [-7.829, -0.298], [-2.521, -15.919], [15.14, -5.277], [10.13, 5.04], [1.182, -7.969], [0.005, -1.481], [0.121, -19.593], [-4.405, 0.034], [-10.649, 0], [-11.252, -1.142], [4.528, -8.153], [-0.179, -7.205], [-15.266, -2.402], [-4.586, 13.457], [5.03, 9.374], [-8.613, 0.808], [-7.446, 0.08], [-14.695, 0.003], [0.068, 4.759]],
                            "o": [[-0.542, -5.823], [-5.935, 3.147], [-13.409, 1.081], [-6.327, -12.518], [10.626, -11.913], [7.17, 3.476], [1.758, -20.621], [0.175, -5.966], [-17.887, 0.219], [-4.45, -0.028], [-7.284, -1.406], [3.167, -5.93], [1.237, -15.489], [-16.328, -1.697], [-1.041, 8.78], [3.773, 6.789], [-4.159, 0.77], [-17.889, 0.12], [-5.936, -0.078], [0.374, 10.848], [0.092, 9.787], [1.023, 7.703], [6.983, -3.628], [16.042, 0.61], [2.471, 15.601], [-10.95, 3.816], [-7.095, -3.531], [-0.218, 1.472], [-0.069, 19.593], [-0.029, 4.746], [10.648, -0.082], [11.285, 0.021], [9.453, 0.959], [-3.529, 6.353], [0.376, 15.061], [13.664, 2.151], [3.55, -10.416], [-4.115, -7.669], [7.408, -0.695], [14.694, -0.158], [3.745, 0], [-0.311, -21.922]],
                            "v": [[103.167, 31.429], [95.683, 27.357], [76.866, 33.025], [44.122, 14.941], [49.055, -22.562], [94.372, -28.555], [103.332, -33.654], [104.232, -95.589], [96.31, -103.322], [42.642, -103.269], [29.315, -104.397], [23.846, -115.806], [29.62, -134.569], [3.196, -165.978], [-29.609, -140.64], [-24.399, -116.104], [-30.001, -104.316], [-42.699, -103.249], [-96.367, -103.264], [-104.638, -95.217], [-104.536, -62.637], [-103.91, -33.284], [-95.065, -28.462], [-72.882, -33.382], [-41.203, -5.194], [-63.174, 31.065], [-94.687, 28.077], [-103.93, 33.05], [-104.42, 37.489], [-104.588, 96.268], [-97.866, 102.616], [-65.92, 102.589], [-32.088, 103.468], [-24.871, 116.549], [-29.734, 136.753], [-4.083, 165.524], [28.025, 145.706], [24.241, 116.238], [30.761, 103.674], [53.086, 102.688], [97.171, 102.598], [104.085, 97.191]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.127540244308, 0.698203711416, 0.860392132927, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.454, 167.925], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 11,
            "ty": 4,
            "nm": "a15 Outlines 5",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [929.601, 1002.315, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.453, 167.925, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[2.037, 21.889], [5.117, -2.713], [6.678, -0.538], [5.949, 11.768], [-9.353, 10.487], [-17.03, -8.256], [-0.687, 8.048], [-0.604, 20.639], [5.663, -0.069], [17.889, 0.113], [4.356, 0.842], [-3.485, 6.527], [-0.536, 6.702], [15.675, 1.628], [1.866, -15.731], [-4.291, -7.721], [7.603, -1.406], [4.239, -0.029], [17.887, 0.237], [-0.217, -6.29], [-0.103, -10.86], [-1.294, -9.745], [-6.676, 3.467], [-7.829, -0.298], [-2.521, -15.919], [15.14, -5.277], [10.13, 5.04], [1.182, -7.969], [0.005, -1.481], [0.121, -19.593], [-4.405, 0.034], [-10.649, 0], [-11.252, -1.142], [4.528, -8.153], [-0.179, -7.205], [-15.266, -2.402], [-4.586, 13.457], [5.03, 9.374], [-8.613, 0.808], [-7.446, 0.08], [-14.695, 0.003], [0.068, 4.759]],
                            "o": [[-0.542, -5.823], [-5.935, 3.147], [-13.409, 1.081], [-6.327, -12.518], [10.626, -11.913], [7.17, 3.476], [1.758, -20.621], [0.175, -5.966], [-17.887, 0.219], [-4.45, -0.028], [-7.284, -1.406], [3.167, -5.93], [1.237, -15.489], [-16.328, -1.697], [-1.041, 8.78], [3.773, 6.789], [-4.159, 0.77], [-17.889, 0.12], [-5.936, -0.078], [0.374, 10.848], [0.092, 9.787], [1.023, 7.703], [6.983, -3.628], [16.042, 0.61], [2.471, 15.601], [-10.95, 3.816], [-7.095, -3.531], [-0.218, 1.472], [-0.069, 19.593], [-0.029, 4.746], [10.648, -0.082], [11.285, 0.021], [9.453, 0.959], [-3.529, 6.353], [0.376, 15.061], [13.664, 2.151], [3.55, -10.416], [-4.115, -7.669], [7.408, -0.695], [14.694, -0.158], [3.745, 0], [-0.311, -21.922]],
                            "v": [[103.167, 31.429], [95.683, 27.357], [76.866, 33.025], [44.122, 14.941], [49.055, -22.562], [94.372, -28.555], [103.332, -33.654], [104.232, -95.589], [96.31, -103.322], [42.642, -103.269], [29.315, -104.397], [23.846, -115.806], [29.62, -134.569], [3.196, -165.978], [-29.609, -140.64], [-24.399, -116.104], [-30.001, -104.316], [-42.699, -103.249], [-96.367, -103.264], [-104.638, -95.217], [-104.536, -62.637], [-103.91, -33.284], [-95.065, -28.462], [-72.882, -33.382], [-41.203, -5.194], [-63.174, 31.065], [-94.687, 28.077], [-103.93, 33.05], [-104.42, 37.489], [-104.588, 96.268], [-97.866, 102.616], [-65.92, 102.589], [-32.088, 103.468], [-24.871, 116.549], [-29.734, 136.753], [-4.083, 165.524], [28.025, 145.706], [24.241, 116.238], [30.761, 103.674], [53.086, 102.688], [97.171, 102.598], [104.085, 97.191]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.127540244308, 0.698203711416, 0.860392132927, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.454, 167.925], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 12,
            "ty": 4,
            "nm": "a15 Outlines 2",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1162.601, 1232.315, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.453, 167.925, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[2.037, 21.889], [5.117, -2.713], [6.678, -0.538], [5.949, 11.768], [-9.353, 10.487], [-17.03, -8.256], [-0.687, 8.048], [-0.604, 20.639], [5.663, -0.069], [17.889, 0.113], [4.356, 0.842], [-3.485, 6.527], [-0.536, 6.702], [15.675, 1.628], [1.866, -15.731], [-4.291, -7.721], [7.603, -1.406], [4.239, -0.029], [17.887, 0.237], [-0.217, -6.29], [-0.103, -10.86], [-1.294, -9.745], [-6.676, 3.467], [-7.829, -0.298], [-2.521, -15.919], [15.14, -5.277], [10.13, 5.04], [1.182, -7.969], [0.005, -1.481], [0.121, -19.593], [-4.405, 0.034], [-10.649, 0], [-11.252, -1.142], [4.528, -8.153], [-0.179, -7.205], [-15.266, -2.402], [-4.586, 13.457], [5.03, 9.374], [-8.613, 0.808], [-7.446, 0.08], [-14.695, 0.003], [0.068, 4.759]],
                            "o": [[-0.542, -5.823], [-5.935, 3.147], [-13.409, 1.081], [-6.327, -12.518], [10.626, -11.913], [7.17, 3.476], [1.758, -20.621], [0.175, -5.966], [-17.887, 0.219], [-4.45, -0.028], [-7.284, -1.406], [3.167, -5.93], [1.237, -15.489], [-16.328, -1.697], [-1.041, 8.78], [3.773, 6.789], [-4.159, 0.77], [-17.889, 0.12], [-5.936, -0.078], [0.374, 10.848], [0.092, 9.787], [1.023, 7.703], [6.983, -3.628], [16.042, 0.61], [2.471, 15.601], [-10.95, 3.816], [-7.095, -3.531], [-0.218, 1.472], [-0.069, 19.593], [-0.029, 4.746], [10.648, -0.082], [11.285, 0.021], [9.453, 0.959], [-3.529, 6.353], [0.376, 15.061], [13.664, 2.151], [3.55, -10.416], [-4.115, -7.669], [7.408, -0.695], [14.694, -0.158], [3.745, 0], [-0.311, -21.922]],
                            "v": [[103.167, 31.429], [95.683, 27.357], [76.866, 33.025], [44.122, 14.941], [49.055, -22.562], [94.372, -28.555], [103.332, -33.654], [104.232, -95.589], [96.31, -103.322], [42.642, -103.269], [29.315, -104.397], [23.846, -115.806], [29.62, -134.569], [3.196, -165.978], [-29.609, -140.64], [-24.399, -116.104], [-30.001, -104.316], [-42.699, -103.249], [-96.367, -103.264], [-104.638, -95.217], [-104.536, -62.637], [-103.91, -33.284], [-95.065, -28.462], [-72.882, -33.382], [-41.203, -5.194], [-63.174, 31.065], [-94.687, 28.077], [-103.93, 33.05], [-104.42, 37.489], [-104.588, 96.268], [-97.866, 102.616], [-65.92, 102.589], [-32.088, 103.468], [-24.871, 116.549], [-29.734, 136.753], [-4.083, 165.524], [28.025, 145.706], [24.241, 116.238], [30.761, 103.674], [53.086, 102.688], [97.171, 102.598], [104.085, 97.191]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.127540244308, 0.698203711416, 0.860392132927, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.454, 167.925], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }]
    }, {
        "id": "comp_4",
        "nm": "Group 8",
        "fr": 29.9700012207031,
        "layers": [{
            "ddd": 0,
            "ind": 1,
            "ty": 5,
            "nm": "User",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1627.654, 1695.329, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 36,
                            "f": "Roboto-Bold",
                            "t": "User",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 43.2000007629395,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 2,
            "ty": 5,
            "nm": "Role",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1631.211, 1463.196, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [0.254, -10.352, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Role",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 3,
            "ty": 5,
            "nm": "Group",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1631.211, 1161.196, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [0.254, -10.352, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Group",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 4,
            "ty": 5,
            "nm": "Policy",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1395.654, 1694.329, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Policy",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 5,
            "ty": 5,
            "nm": "IAM",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1395.654, 1472.329, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "IAM",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 6,
            "ty": 4,
            "nm": "a15 Outlines 2",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1631.101, 1232.315, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.453, 167.925, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[2.037, 21.889], [5.117, -2.713], [6.678, -0.538], [5.949, 11.768], [-9.353, 10.487], [-17.03, -8.256], [-0.687, 8.048], [-0.604, 20.639], [5.663, -0.069], [17.889, 0.113], [4.356, 0.842], [-3.485, 6.527], [-0.536, 6.702], [15.675, 1.628], [1.866, -15.731], [-4.291, -7.721], [7.603, -1.406], [4.239, -0.029], [17.887, 0.237], [-0.217, -6.29], [-0.103, -10.86], [-1.294, -9.745], [-6.676, 3.467], [-7.829, -0.298], [-2.521, -15.919], [15.14, -5.277], [10.13, 5.04], [1.182, -7.969], [0.005, -1.481], [0.121, -19.593], [-4.405, 0.034], [-10.649, 0], [-11.252, -1.142], [4.528, -8.153], [-0.179, -7.205], [-15.266, -2.402], [-4.586, 13.457], [5.03, 9.374], [-8.613, 0.808], [-7.446, 0.08], [-14.695, 0.003], [0.068, 4.759]],
                            "o": [[-0.542, -5.823], [-5.935, 3.147], [-13.409, 1.081], [-6.327, -12.518], [10.626, -11.913], [7.17, 3.476], [1.758, -20.621], [0.175, -5.966], [-17.887, 0.219], [-4.45, -0.028], [-7.284, -1.406], [3.167, -5.93], [1.237, -15.489], [-16.328, -1.697], [-1.041, 8.78], [3.773, 6.789], [-4.159, 0.77], [-17.889, 0.12], [-5.936, -0.078], [0.374, 10.848], [0.092, 9.787], [1.023, 7.703], [6.983, -3.628], [16.042, 0.61], [2.471, 15.601], [-10.95, 3.816], [-7.095, -3.531], [-0.218, 1.472], [-0.069, 19.593], [-0.029, 4.746], [10.648, -0.082], [11.285, 0.021], [9.453, 0.959], [-3.529, 6.353], [0.376, 15.061], [13.664, 2.151], [3.55, -10.416], [-4.115, -7.669], [7.408, -0.695], [14.694, -0.158], [3.745, 0], [-0.311, -21.922]],
                            "v": [[103.167, 31.429], [95.683, 27.357], [76.866, 33.025], [44.122, 14.941], [49.055, -22.562], [94.372, -28.555], [103.332, -33.654], [104.232, -95.589], [96.31, -103.322], [42.642, -103.269], [29.315, -104.397], [23.846, -115.806], [29.62, -134.569], [3.196, -165.978], [-29.609, -140.64], [-24.399, -116.104], [-30.001, -104.316], [-42.699, -103.249], [-96.367, -103.264], [-104.638, -95.217], [-104.536, -62.637], [-103.91, -33.284], [-95.065, -28.462], [-72.882, -33.382], [-41.203, -5.194], [-63.174, 31.065], [-94.687, 28.077], [-103.93, 33.05], [-104.42, 37.489], [-104.588, 96.268], [-97.866, 102.616], [-65.92, 102.589], [-32.088, 103.468], [-24.871, 116.549], [-29.734, 136.753], [-4.083, 165.524], [28.025, 145.706], [24.241, 116.238], [30.761, 103.674], [53.086, 102.688], [97.171, 102.598], [104.085, 97.191]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.467162427715, 0.460318322275, 0.945098039216, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.454, 167.925], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 7,
            "ty": 4,
            "nm": "a15 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1396.601, 1463.815, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.453, 167.925, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[2.037, 21.889], [5.117, -2.713], [6.678, -0.538], [5.949, 11.768], [-9.353, 10.487], [-17.03, -8.256], [-0.687, 8.048], [-0.604, 20.639], [5.663, -0.069], [17.889, 0.113], [4.356, 0.842], [-3.485, 6.527], [-0.536, 6.702], [15.675, 1.628], [1.866, -15.731], [-4.291, -7.721], [7.603, -1.406], [4.239, -0.029], [17.887, 0.237], [-0.217, -6.29], [-0.103, -10.86], [-1.294, -9.745], [-6.676, 3.467], [-7.829, -0.298], [-2.521, -15.919], [15.14, -5.277], [10.13, 5.04], [1.182, -7.969], [0.005, -1.481], [0.121, -19.593], [-4.405, 0.034], [-10.649, 0], [-11.252, -1.142], [4.528, -8.153], [-0.179, -7.205], [-15.266, -2.402], [-4.586, 13.457], [5.03, 9.374], [-8.613, 0.808], [-7.446, 0.08], [-14.695, 0.003], [0.068, 4.759]],
                            "o": [[-0.542, -5.823], [-5.935, 3.147], [-13.409, 1.081], [-6.327, -12.518], [10.626, -11.913], [7.17, 3.476], [1.758, -20.621], [0.175, -5.966], [-17.887, 0.219], [-4.45, -0.028], [-7.284, -1.406], [3.167, -5.93], [1.237, -15.489], [-16.328, -1.697], [-1.041, 8.78], [3.773, 6.789], [-4.159, 0.77], [-17.889, 0.12], [-5.936, -0.078], [0.374, 10.848], [0.092, 9.787], [1.023, 7.703], [6.983, -3.628], [16.042, 0.61], [2.471, 15.601], [-10.95, 3.816], [-7.095, -3.531], [-0.218, 1.472], [-0.069, 19.593], [-0.029, 4.746], [10.648, -0.082], [11.285, 0.021], [9.453, 0.959], [-3.529, 6.353], [0.376, 15.061], [13.664, 2.151], [3.55, -10.416], [-4.115, -7.669], [7.408, -0.695], [14.694, -0.158], [3.745, 0], [-0.311, -21.922]],
                            "v": [[103.167, 31.429], [95.683, 27.357], [76.866, 33.025], [44.122, 14.941], [49.055, -22.562], [94.372, -28.555], [103.332, -33.654], [104.232, -95.589], [96.31, -103.322], [42.642, -103.269], [29.315, -104.397], [23.846, -115.806], [29.62, -134.569], [3.196, -165.978], [-29.609, -140.64], [-24.399, -116.104], [-30.001, -104.316], [-42.699, -103.249], [-96.367, -103.264], [-104.638, -95.217], [-104.536, -62.637], [-103.91, -33.284], [-95.065, -28.462], [-72.882, -33.382], [-41.203, -5.194], [-63.174, 31.065], [-94.687, 28.077], [-103.93, 33.05], [-104.42, 37.489], [-104.588, 96.268], [-97.866, 102.616], [-65.92, 102.589], [-32.088, 103.468], [-24.871, 116.549], [-29.734, 136.753], [-4.083, 165.524], [28.025, 145.706], [24.241, 116.238], [30.761, 103.674], [53.086, 102.688], [97.171, 102.598], [104.085, 97.191]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.467162427715, 0.460318322275, 0.945098039216, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.454, 167.925], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 8,
            "ty": 4,
            "nm": "a16 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1394.972, 1695.269, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [169.667, 103.299, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-13.823, 7.193], [-10.473, -11.934], [7.324, -14.669], [-8.642, -0.207], [-10.433, 0], [-0.001, -0.085], [-8.305, 0.001], [-0.041, 13.42], [-0.49, 18.728], [-9.564, -4.882], [-7.187, 0.318], [-1.107, 14.256], [15.221, 3.388], [8.153, -4.197], [0.913, 9.665], [0.018, 5.108], [-0.249, 15.968], [5.934, -0.081], [19.376, -0.18], [-4.809, -11.712], [10.395, -11.517], [13.543, 3.957], [-10.722, 21.676], [8.317, 0.131], [21.294, 0.147], [-0.018, -4.313], [0.055, -18.527], [0.413, -3.153], [7.962, 4.349], [5.734, 0.729], [2.915, -14.239], [-15.598, -4.268], [-7.757, 4.559], [-0.427, -11.911], [-0.004, -4.046], [0.231, -15.755], [-5.987, 0.078], [-20.23, 0.084], [-1.683, 0.23], [2.11, 4.011], [1.068, 4.393]],
                            "o": [[14.154, -7.365], [9.413, 10.725], [-3.812, 7.633], [10.427, 0.25], [0, 0.085], [8.305, 0], [13.663, -0.002], [0.056, -18.739], [0.287, -10.962], [6.408, 3.271], [14.838, -0.657], [1.238, -15.944], [-9.254, -2.059], [-8.524, 4.388], [-0.479, -5.076], [-0.055, -15.971], [0.088, -5.695], [-19.375, 0.265], [-12.981, 0.121], [5.681, 13.836], [-9.363, 10.374], [-21.114, -6.169], [3.695, -7.471], [-21.29, -0.335], [-4.9, -0.034], [0.078, 18.526], [-0.01, 3.19], [-1.171, 8.923], [-5.154, -2.814], [-14.954, -1.902], [-3.326, 16.243], [8.84, 2.419], [11.811, -6.943], [0.145, 4.042], [0.016, 15.758], [-0.082, 5.596], [20.227, -0.263], [1.7, -0.007], [4.11, -0.561], [-2.084, -3.963], [-3.906, -16.063]],
                            "v": [[-15.042, 44.178], [26.26, 51.842], [29.663, 93.217], [35.258, 102.588], [66.556, 102.646], [66.557, 102.902], [91.472, 102.902], [105.145, 89.479], [105.507, 33.266], [119.728, 24.856], [140.01, 29.585], [168.179, 3.187], [144.977, -28.782], [119.104, -24.387], [105.588, -31.773], [105.13, -47.09], [105.187, -95.004], [97.496, -102.968], [39.363, -102.752], [30.96, -90.177], [25.807, -51.318], [-9.121, -41.692], [-28.101, -92.846], [-33.659, -102.559], [-97.54, -102.896], [-103.598, -96], [-103.635, -40.421], [-104.054, -30.857], [-117.117, -24.257], [-133.477, -29.352], [-166.091, -6.753], [-145.074, 28.454], [-119.702, 25.476], [-103.703, 35.443], [-103.566, 47.58], [-103.635, 94.855], [-96.017, 102.971], [-35.329, 102.691], [-30.232, 102.368], [-26.627, 95.775], [-31.749, 83.417]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.467162427715, 0.460318322275, 0.945098039216, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [169.667, 103.3], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 9,
            "ty": 4,
            "nm": "a16 Outlines 4",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 270, "ix": 10},
                "p": {"a": 0, "k": [1629.472, 1697.269, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [169.667, 103.299, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-13.823, 7.193], [-10.473, -11.934], [7.324, -14.669], [-8.642, -0.207], [-10.433, 0], [-0.001, -0.085], [-8.305, 0.001], [-0.041, 13.42], [-0.49, 18.728], [-9.564, -4.882], [-7.187, 0.318], [-1.107, 14.256], [15.221, 3.388], [8.153, -4.197], [0.913, 9.665], [0.018, 5.108], [-0.249, 15.968], [5.934, -0.081], [19.376, -0.18], [-4.809, -11.712], [10.395, -11.517], [13.543, 3.957], [-10.722, 21.676], [8.317, 0.131], [21.294, 0.147], [-0.018, -4.313], [0.055, -18.527], [0.413, -3.153], [7.962, 4.349], [5.734, 0.729], [2.915, -14.239], [-15.598, -4.268], [-7.757, 4.559], [-0.427, -11.911], [-0.004, -4.046], [0.231, -15.755], [-5.987, 0.078], [-20.23, 0.084], [-1.683, 0.23], [2.11, 4.011], [1.068, 4.393]],
                            "o": [[14.154, -7.365], [9.413, 10.725], [-3.812, 7.633], [10.427, 0.25], [0, 0.085], [8.305, 0], [13.663, -0.002], [0.056, -18.739], [0.287, -10.962], [6.408, 3.271], [14.838, -0.657], [1.238, -15.944], [-9.254, -2.059], [-8.524, 4.388], [-0.479, -5.076], [-0.055, -15.971], [0.088, -5.695], [-19.375, 0.265], [-12.981, 0.121], [5.681, 13.836], [-9.363, 10.374], [-21.114, -6.169], [3.695, -7.471], [-21.29, -0.335], [-4.9, -0.034], [0.078, 18.526], [-0.01, 3.19], [-1.171, 8.923], [-5.154, -2.814], [-14.954, -1.902], [-3.326, 16.243], [8.84, 2.419], [11.811, -6.943], [0.145, 4.042], [0.016, 15.758], [-0.082, 5.596], [20.227, -0.263], [1.7, -0.007], [4.11, -0.561], [-2.084, -3.963], [-3.906, -16.063]],
                            "v": [[-15.042, 44.178], [26.26, 51.842], [29.663, 93.217], [35.258, 102.588], [66.556, 102.646], [66.557, 102.902], [91.472, 102.902], [105.145, 89.479], [105.507, 33.266], [119.728, 24.856], [140.01, 29.585], [168.179, 3.187], [144.977, -28.782], [119.104, -24.387], [105.588, -31.773], [105.13, -47.09], [105.187, -95.004], [97.496, -102.968], [39.363, -102.752], [30.96, -90.177], [25.807, -51.318], [-9.121, -41.692], [-28.101, -92.846], [-33.659, -102.559], [-97.54, -102.896], [-103.598, -96], [-103.635, -40.421], [-104.054, -30.857], [-117.117, -24.257], [-133.477, -29.352], [-166.091, -6.753], [-145.074, 28.454], [-119.702, 25.476], [-103.703, 35.443], [-103.566, 47.58], [-103.635, 94.855], [-96.017, 102.971], [-35.329, 102.691], [-30.232, 102.368], [-26.627, 95.775], [-31.749, 83.417]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.467162427715, 0.460318322275, 0.945098039216, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [169.667, 103.3], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 10,
            "ty": 4,
            "nm": "a16 Outlines 3",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 180, "ix": 10},
                "p": {"a": 0, "k": [1631.472, 1463.269, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [169.667, 103.299, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-13.823, 7.193], [-10.473, -11.934], [7.324, -14.669], [-8.642, -0.207], [-10.433, 0], [-0.001, -0.085], [-8.305, 0.001], [-0.041, 13.42], [-0.49, 18.728], [-9.564, -4.882], [-7.187, 0.318], [-1.107, 14.256], [15.221, 3.388], [8.153, -4.197], [0.913, 9.665], [0.018, 5.108], [-0.249, 15.968], [5.934, -0.081], [19.376, -0.18], [-4.809, -11.712], [10.395, -11.517], [13.543, 3.957], [-10.722, 21.676], [8.317, 0.131], [21.294, 0.147], [-0.018, -4.313], [0.055, -18.527], [0.413, -3.153], [7.962, 4.349], [5.734, 0.729], [2.915, -14.239], [-15.598, -4.268], [-7.757, 4.559], [-0.427, -11.911], [-0.004, -4.046], [0.231, -15.755], [-5.987, 0.078], [-20.23, 0.084], [-1.683, 0.23], [2.11, 4.011], [1.068, 4.393]],
                            "o": [[14.154, -7.365], [9.413, 10.725], [-3.812, 7.633], [10.427, 0.25], [0, 0.085], [8.305, 0], [13.663, -0.002], [0.056, -18.739], [0.287, -10.962], [6.408, 3.271], [14.838, -0.657], [1.238, -15.944], [-9.254, -2.059], [-8.524, 4.388], [-0.479, -5.076], [-0.055, -15.971], [0.088, -5.695], [-19.375, 0.265], [-12.981, 0.121], [5.681, 13.836], [-9.363, 10.374], [-21.114, -6.169], [3.695, -7.471], [-21.29, -0.335], [-4.9, -0.034], [0.078, 18.526], [-0.01, 3.19], [-1.171, 8.923], [-5.154, -2.814], [-14.954, -1.902], [-3.326, 16.243], [8.84, 2.419], [11.811, -6.943], [0.145, 4.042], [0.016, 15.758], [-0.082, 5.596], [20.227, -0.263], [1.7, -0.007], [4.11, -0.561], [-2.084, -3.963], [-3.906, -16.063]],
                            "v": [[-15.042, 44.178], [26.26, 51.842], [29.663, 93.217], [35.258, 102.588], [66.556, 102.646], [66.557, 102.902], [91.472, 102.902], [105.145, 89.479], [105.507, 33.266], [119.728, 24.856], [140.01, 29.585], [168.179, 3.187], [144.977, -28.782], [119.104, -24.387], [105.588, -31.773], [105.13, -47.09], [105.187, -95.004], [97.496, -102.968], [39.363, -102.752], [30.96, -90.177], [25.807, -51.318], [-9.121, -41.692], [-28.101, -92.846], [-33.659, -102.559], [-97.54, -102.896], [-103.598, -96], [-103.635, -40.421], [-104.054, -30.857], [-117.117, -24.257], [-133.477, -29.352], [-166.091, -6.753], [-145.074, 28.454], [-119.702, 25.476], [-103.703, 35.443], [-103.566, 47.58], [-103.635, 94.855], [-96.017, 102.971], [-35.329, 102.691], [-30.232, 102.368], [-26.627, 95.775], [-31.749, 83.417]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.467162427715, 0.460318322275, 0.945098039216, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [169.667, 103.3], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }]
    }, {
        "id": "comp_5",
        "nm": "Group 7",
        "fr": 29.9700012207031,
        "layers": [{
            "ddd": 0,
            "ind": 1,
            "ty": 5,
            "nm": "Backup",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1159.876, 1624, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Backup",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 2,
            "ty": 5,
            "nm": "Aurora",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1159.876, 1470, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Aurora",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 3,
            "ty": 5,
            "nm": "RDS",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [929.876, 1468, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "RDS",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 4,
            "ty": 5,
            "nm": "DynamoDB",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [929.876, 1233, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "DynamoDB",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 5,
            "ty": 4,
            "nm": "a16 Outlines 4",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 180, "ix": 10},
                "p": {"a": 0, "k": [929.972, 1234.769, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [169.667, 103.299, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-13.823, 7.193], [-10.473, -11.934], [7.324, -14.669], [-8.642, -0.207], [-10.433, 0], [-0.001, -0.085], [-8.305, 0.001], [-0.041, 13.42], [-0.49, 18.728], [-9.564, -4.882], [-7.187, 0.318], [-1.107, 14.256], [15.221, 3.388], [8.153, -4.197], [0.913, 9.665], [0.018, 5.108], [-0.249, 15.968], [5.934, -0.081], [19.376, -0.18], [-4.809, -11.712], [10.395, -11.517], [13.543, 3.957], [-10.722, 21.676], [8.317, 0.131], [21.294, 0.147], [-0.018, -4.313], [0.055, -18.527], [0.413, -3.153], [7.962, 4.349], [5.734, 0.729], [2.915, -14.239], [-15.598, -4.268], [-7.757, 4.559], [-0.427, -11.911], [-0.004, -4.046], [0.231, -15.755], [-5.987, 0.078], [-20.23, 0.084], [-1.683, 0.23], [2.11, 4.011], [1.068, 4.393]],
                            "o": [[14.154, -7.365], [9.413, 10.725], [-3.812, 7.633], [10.427, 0.25], [0, 0.085], [8.305, 0], [13.663, -0.002], [0.056, -18.739], [0.287, -10.962], [6.408, 3.271], [14.838, -0.657], [1.238, -15.944], [-9.254, -2.059], [-8.524, 4.388], [-0.479, -5.076], [-0.055, -15.971], [0.088, -5.695], [-19.375, 0.265], [-12.981, 0.121], [5.681, 13.836], [-9.363, 10.374], [-21.114, -6.169], [3.695, -7.471], [-21.29, -0.335], [-4.9, -0.034], [0.078, 18.526], [-0.01, 3.19], [-1.171, 8.923], [-5.154, -2.814], [-14.954, -1.902], [-3.326, 16.243], [8.84, 2.419], [11.811, -6.943], [0.145, 4.042], [0.016, 15.758], [-0.082, 5.596], [20.227, -0.263], [1.7, -0.007], [4.11, -0.561], [-2.084, -3.963], [-3.906, -16.063]],
                            "v": [[-15.042, 44.178], [26.26, 51.842], [29.663, 93.217], [35.258, 102.588], [66.556, 102.646], [66.557, 102.902], [91.472, 102.902], [105.145, 89.479], [105.507, 33.266], [119.728, 24.856], [140.01, 29.585], [168.179, 3.187], [144.977, -28.782], [119.104, -24.387], [105.588, -31.773], [105.13, -47.09], [105.187, -95.004], [97.496, -102.968], [39.363, -102.752], [30.96, -90.177], [25.807, -51.318], [-9.121, -41.692], [-28.101, -92.846], [-33.659, -102.559], [-97.54, -102.896], [-103.598, -96], [-103.635, -40.421], [-104.054, -30.857], [-117.117, -24.257], [-133.477, -29.352], [-166.091, -6.753], [-145.074, 28.454], [-119.702, 25.476], [-103.703, 35.443], [-103.566, 47.58], [-103.635, 94.855], [-96.017, 102.971], [-35.329, 102.691], [-30.232, 102.368], [-26.627, 95.775], [-31.749, 83.417]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [1, 1, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [169.667, 103.3], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 6,
            "ty": 4,
            "nm": "a16 Outlines 3",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 180, "ix": 10},
                "p": {"a": 0, "k": [1162.972, 1464.769, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [169.667, 103.299, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-13.823, 7.193], [-10.473, -11.934], [7.324, -14.669], [-8.642, -0.207], [-10.433, 0], [-0.001, -0.085], [-8.305, 0.001], [-0.041, 13.42], [-0.49, 18.728], [-9.564, -4.882], [-7.187, 0.318], [-1.107, 14.256], [15.221, 3.388], [8.153, -4.197], [0.913, 9.665], [0.018, 5.108], [-0.249, 15.968], [5.934, -0.081], [19.376, -0.18], [-4.809, -11.712], [10.395, -11.517], [13.543, 3.957], [-10.722, 21.676], [8.317, 0.131], [21.294, 0.147], [-0.018, -4.313], [0.055, -18.527], [0.413, -3.153], [7.962, 4.349], [5.734, 0.729], [2.915, -14.239], [-15.598, -4.268], [-7.757, 4.559], [-0.427, -11.911], [-0.004, -4.046], [0.231, -15.755], [-5.987, 0.078], [-20.23, 0.084], [-1.683, 0.23], [2.11, 4.011], [1.068, 4.393]],
                            "o": [[14.154, -7.365], [9.413, 10.725], [-3.812, 7.633], [10.427, 0.25], [0, 0.085], [8.305, 0], [13.663, -0.002], [0.056, -18.739], [0.287, -10.962], [6.408, 3.271], [14.838, -0.657], [1.238, -15.944], [-9.254, -2.059], [-8.524, 4.388], [-0.479, -5.076], [-0.055, -15.971], [0.088, -5.695], [-19.375, 0.265], [-12.981, 0.121], [5.681, 13.836], [-9.363, 10.374], [-21.114, -6.169], [3.695, -7.471], [-21.29, -0.335], [-4.9, -0.034], [0.078, 18.526], [-0.01, 3.19], [-1.171, 8.923], [-5.154, -2.814], [-14.954, -1.902], [-3.326, 16.243], [8.84, 2.419], [11.811, -6.943], [0.145, 4.042], [0.016, 15.758], [-0.082, 5.596], [20.227, -0.263], [1.7, -0.007], [4.11, -0.561], [-2.084, -3.963], [-3.906, -16.063]],
                            "v": [[-15.042, 44.178], [26.26, 51.842], [29.663, 93.217], [35.258, 102.588], [66.556, 102.646], [66.557, 102.902], [91.472, 102.902], [105.145, 89.479], [105.507, 33.266], [119.728, 24.856], [140.01, 29.585], [168.179, 3.187], [144.977, -28.782], [119.104, -24.387], [105.588, -31.773], [105.13, -47.09], [105.187, -95.004], [97.496, -102.968], [39.363, -102.752], [30.96, -90.177], [25.807, -51.318], [-9.121, -41.692], [-28.101, -92.846], [-33.659, -102.559], [-97.54, -102.896], [-103.598, -96], [-103.635, -40.421], [-104.054, -30.857], [-117.117, -24.257], [-133.477, -29.352], [-166.091, -6.753], [-145.074, 28.454], [-119.702, 25.476], [-103.703, 35.443], [-103.566, 47.58], [-103.635, 94.855], [-96.017, 102.971], [-35.329, 102.691], [-30.232, 102.368], [-26.627, 95.775], [-31.749, 83.417]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [1, 1, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [169.667, 103.3], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 7,
            "ty": 4,
            "nm": "a16 Outlines 2",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 90, "ix": 10},
                "p": {"a": 0, "k": [928.972, 1464.769, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [169.667, 103.299, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-13.823, 7.193], [-10.473, -11.934], [7.324, -14.669], [-8.642, -0.207], [-10.433, 0], [-0.001, -0.085], [-8.305, 0.001], [-0.041, 13.42], [-0.49, 18.728], [-9.564, -4.882], [-7.187, 0.318], [-1.107, 14.256], [15.221, 3.388], [8.153, -4.197], [0.913, 9.665], [0.018, 5.108], [-0.249, 15.968], [5.934, -0.081], [19.376, -0.18], [-4.809, -11.712], [10.395, -11.517], [13.543, 3.957], [-10.722, 21.676], [8.317, 0.131], [21.294, 0.147], [-0.018, -4.313], [0.055, -18.527], [0.413, -3.153], [7.962, 4.349], [5.734, 0.729], [2.915, -14.239], [-15.598, -4.268], [-7.757, 4.559], [-0.427, -11.911], [-0.004, -4.046], [0.231, -15.755], [-5.987, 0.078], [-20.23, 0.084], [-1.683, 0.23], [2.11, 4.011], [1.068, 4.393]],
                            "o": [[14.154, -7.365], [9.413, 10.725], [-3.812, 7.633], [10.427, 0.25], [0, 0.085], [8.305, 0], [13.663, -0.002], [0.056, -18.739], [0.287, -10.962], [6.408, 3.271], [14.838, -0.657], [1.238, -15.944], [-9.254, -2.059], [-8.524, 4.388], [-0.479, -5.076], [-0.055, -15.971], [0.088, -5.695], [-19.375, 0.265], [-12.981, 0.121], [5.681, 13.836], [-9.363, 10.374], [-21.114, -6.169], [3.695, -7.471], [-21.29, -0.335], [-4.9, -0.034], [0.078, 18.526], [-0.01, 3.19], [-1.171, 8.923], [-5.154, -2.814], [-14.954, -1.902], [-3.326, 16.243], [8.84, 2.419], [11.811, -6.943], [0.145, 4.042], [0.016, 15.758], [-0.082, 5.596], [20.227, -0.263], [1.7, -0.007], [4.11, -0.561], [-2.084, -3.963], [-3.906, -16.063]],
                            "v": [[-15.042, 44.178], [26.26, 51.842], [29.663, 93.217], [35.258, 102.588], [66.556, 102.646], [66.557, 102.902], [91.472, 102.902], [105.145, 89.479], [105.507, 33.266], [119.728, 24.856], [140.01, 29.585], [168.179, 3.187], [144.977, -28.782], [119.104, -24.387], [105.588, -31.773], [105.13, -47.09], [105.187, -95.004], [97.496, -102.968], [39.363, -102.752], [30.96, -90.177], [25.807, -51.318], [-9.121, -41.692], [-28.101, -92.846], [-33.659, -102.559], [-97.54, -102.896], [-103.598, -96], [-103.635, -40.421], [-104.054, -30.857], [-117.117, -24.257], [-133.477, -29.352], [-166.091, -6.753], [-145.074, 28.454], [-119.702, 25.476], [-103.703, 35.443], [-103.566, 47.58], [-103.635, 94.855], [-96.017, 102.971], [-35.329, 102.691], [-30.232, 102.368], [-26.627, 95.775], [-31.749, 83.417]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [1, 1, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [169.667, 103.3], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 8,
            "ty": 4,
            "nm": "a16 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 90, "ix": 10},
                "p": {"a": 0, "k": [1161.972, 1695.769, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [169.667, 103.299, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-13.823, 7.193], [-10.473, -11.934], [7.324, -14.669], [-8.642, -0.207], [-10.433, 0], [-0.001, -0.085], [-8.305, 0.001], [-0.041, 13.42], [-0.49, 18.728], [-9.564, -4.882], [-7.187, 0.318], [-1.107, 14.256], [15.221, 3.388], [8.153, -4.197], [0.913, 9.665], [0.018, 5.108], [-0.249, 15.968], [5.934, -0.081], [19.376, -0.18], [-4.809, -11.712], [10.395, -11.517], [13.543, 3.957], [-10.722, 21.676], [8.317, 0.131], [21.294, 0.147], [-0.018, -4.313], [0.055, -18.527], [0.413, -3.153], [7.962, 4.349], [5.734, 0.729], [2.915, -14.239], [-15.598, -4.268], [-7.757, 4.559], [-0.427, -11.911], [-0.004, -4.046], [0.231, -15.755], [-5.987, 0.078], [-20.23, 0.084], [-1.683, 0.23], [2.11, 4.011], [1.068, 4.393]],
                            "o": [[14.154, -7.365], [9.413, 10.725], [-3.812, 7.633], [10.427, 0.25], [0, 0.085], [8.305, 0], [13.663, -0.002], [0.056, -18.739], [0.287, -10.962], [6.408, 3.271], [14.838, -0.657], [1.238, -15.944], [-9.254, -2.059], [-8.524, 4.388], [-0.479, -5.076], [-0.055, -15.971], [0.088, -5.695], [-19.375, 0.265], [-12.981, 0.121], [5.681, 13.836], [-9.363, 10.374], [-21.114, -6.169], [3.695, -7.471], [-21.29, -0.335], [-4.9, -0.034], [0.078, 18.526], [-0.01, 3.19], [-1.171, 8.923], [-5.154, -2.814], [-14.954, -1.902], [-3.326, 16.243], [8.84, 2.419], [11.811, -6.943], [0.145, 4.042], [0.016, 15.758], [-0.082, 5.596], [20.227, -0.263], [1.7, -0.007], [4.11, -0.561], [-2.084, -3.963], [-3.906, -16.063]],
                            "v": [[-15.042, 44.178], [26.26, 51.842], [29.663, 93.217], [35.258, 102.588], [66.556, 102.646], [66.557, 102.902], [91.472, 102.902], [105.145, 89.479], [105.507, 33.266], [119.728, 24.856], [140.01, 29.585], [168.179, 3.187], [144.977, -28.782], [119.104, -24.387], [105.588, -31.773], [105.13, -47.09], [105.187, -95.004], [97.496, -102.968], [39.363, -102.752], [30.96, -90.177], [25.807, -51.318], [-9.121, -41.692], [-28.101, -92.846], [-33.659, -102.559], [-97.54, -102.896], [-103.598, -96], [-103.635, -40.421], [-104.054, -30.857], [-117.117, -24.257], [-133.477, -29.352], [-166.091, -6.753], [-145.074, 28.454], [-119.702, 25.476], [-103.703, 35.443], [-103.566, 47.58], [-103.635, 94.855], [-96.017, 102.971], [-35.329, 102.691], [-30.232, 102.368], [-26.627, 95.775], [-31.749, 83.417]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [1, 1, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [169.667, 103.3], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }]
    }, {
        "id": "comp_6",
        "nm": "Group 6",
        "fr": 29.9700012207031,
        "layers": [{
            "ddd": 0,
            "ind": 1,
            "ty": 5,
            "nm": "Run",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [2097.578, 1694.902, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Run",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 2,
            "ty": 5,
            "nm": "Session",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [2098.174, 1473.171, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Session",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 3,
            "ty": 5,
            "nm": "Secrets",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1863.598, 1695.098, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Secrets",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 4,
            "ty": 5,
            "nm": "SSM",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1864.154, 1472.829, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "SSM",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 5,
            "ty": 4,
            "nm": "a7 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 180, "ix": 10},
                "p": {"a": 0, "k": [2060.323, 1468.475, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [137.647, 103.294, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-5.35, 0.056], [-19.8, 0.221], [4.848, 10.465], [-20.244, 5.644], [-9.287, -10.836], [6.384, -14.025], [-10.218, -0.124], [-20.438, -0.203], [0.05, 5.144], [-0.052, 17.673], [-0.467, 3.788], [-7.881, -4.155], [-5.535, -0.742], [-3.403, 14.19], [14.25, 5.245], [8.582, -5.005], [0.349, 10.746], [0.006, 4.258], [-0.21, 15.754], [5.518, -0.059], [20.438, -0.252], [-4.554, -9.325], [-0.65, -4.222], [15.588, -5.486], [8.11, 14.629], [-6.137, 12.08], [6.961, 0.197], [10.857, 0], [0, 0.115], [10.43, 0.204], [-0.01, -5.517], [0.134, -63.665]],
                            "o": [[19.8, -0.206], [11.798, -0.132], [-9.496, -20.497], [13.811, -3.851], [10.485, 12.233], [-4.108, 9.025], [20.437, 0.25], [5.275, 0.052], [-0.168, -17.671], [0.011, -3.828], [1.106, -8.965], [4.974, 2.623], [15.114, 2.026], [3.611, -15.059], [-9.545, -3.512], [-12.632, 7.367], [-0.138, -4.255], [-0.021, -15.757], [0.072, -5.461], [-20.438, 0.221], [-10.175, 0.125], [1.89, 3.87], [2.596, 16.863], [-15.599, 5.49], [-6.796, -12.259], [3.149, -6.198], [-10.848, -0.307], [0, -0.115], [-10.433, 0], [-5.451, -0.107], [0.113, 63.664], [-0.012, 5.677]],
                            "v": [[-129.786, 102.987], [-70.382, 102.747], [-62.82, 90.971], [-42.671, 41.647], [-7.387, 51.945], [-3.647, 92.086], [3.077, 102.697], [64.396, 102.984], [71.457, 95.714], [71.433, 42.695], [71.899, 31.219], [84.887, 24.244], [100.576, 29.378], [133.785, 7.519], [115.495, -27.644], [87.694, -25.477], [71.563, -35.281], [71.396, -48.053], [71.456, -95.323], [63.996, -102.938], [2.678, -102.622], [-3.54, -91.909], [0.219, -79.75], [-21.66, -42.201], [-62.312, -57.451], [-61.223, -94.125], [-65.979, -102.451], [-98.548, -102.531], [-98.548, -102.878], [-129.847, -102.936], [-137.372, -95.38], [-137.385, 95.615]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.832156910616, 0.668460442038, 0.520179598939, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [137.647, 103.294], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 6,
            "ty": 4,
            "nm": "a13 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 180, "ix": 10},
                "p": {"a": 0, "k": [2095.782, 1698.941, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.128, 167.783, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-5.817, 0.117], [-12.35, 0.055], [-9.327, -1.023], [4.238, -7.876], [0.827, -5.313], [-18.053, -1.541], [-0.328, 17.124], [3.614, 6.329], [-9.029, 1.087], [-1.913, 0.02], [-19.799, -0.026], [0.194, 5.846], [0.147, 9.367], [1.567, 11.449], [6.49, -3.316], [6.226, -0.252], [6.968, 12.556], [-8.087, 11.209], [-18.252, -8.823], [-0.667, 8.051], [-0.286, 21.495], [3.699, -0.004], [14.053, 0.142], [8.238, 1.487], [-3.808, 7.056], [-0.426, 6.274], [10.565, 6.164], [10.448, -6.657], [-0.913, -11.808], [-2.962, -5.529], [7.098, -1.224], [4.24, -0.033], [17.035, -0.019], [0.002, -10.761], [-0.006, -30.664], [0.176, -31.727]],
                            "o": [[12.346, -0.249], [9.372, -0.041], [9.077, 0.996], [-2.56, 4.76], [-2.705, 17.377], [16.538, 1.411], [0.138, -7.189], [-4.454, -7.798], [1.9, -0.229], [19.799, -0.207], [5.735, 0.007], [-0.31, -9.359], [-0.179, -11.486], [-0.965, -7.045], [-5.58, 2.851], [-14.163, 0.574], [-6.735, -12.136], [10.288, -14.26], [7.466, 3.609], [1.778, -21.468], [0.065, -4.853], [-14.054, 0.013], [-8.291, -0.084], [-7.99, -1.441], [2.984, -5.529], [0.825, -12.118], [-10.609, -6.189], [-10.109, 6.442], [0.485, 6.283], [3.47, 6.478], [-4.175, 0.72], [-17.034, 0.134], [-11.083, 0.013], [-0.006, 30.664], [0, 31.728], [-0.031, 5.764]],
                            "v": [[-97.037, 103.069], [-59.987, 102.977], [-31.913, 103.897], [-24.91, 116.686], [-29.95, 131.738], [-2.087, 166.122], [29.12, 136.969], [24.166, 116.792], [30.991, 103.92], [36.726, 103.547], [96.124, 103.061], [103.991, 95.179], [103.882, 67.075], [103.118, 32.622], [94.481, 28.276], [76.826, 33.434], [44.403, 15.961], [46.802, -19.499], [93.994, -28.267], [103.1, -33.065], [103.86, -97.546], [96.904, -102.822], [54.742, -102.879], [29.88, -103.775], [23.819, -115.802], [29.289, -133.331], [15.173, -161.344], [-16.878, -160.775], [-30.063, -132.912], [-24.425, -115.437], [-29.864, -104.007], [-42.566, -102.914], [-93.671, -102.817], [-104.767, -92.039], [-104.763, -0.048], [-104.847, 95.136]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.832156910616, 0.668460442038, 0.520179598939, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.128, 167.783], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 7,
            "ty": 4,
            "nm": "a16 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1862.472, 1697.769, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [169.667, 103.299, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-13.823, 7.193], [-10.473, -11.934], [7.324, -14.669], [-8.642, -0.207], [-10.433, 0], [-0.001, -0.085], [-8.305, 0.001], [-0.041, 13.42], [-0.49, 18.728], [-9.564, -4.882], [-7.187, 0.318], [-1.107, 14.256], [15.221, 3.388], [8.153, -4.197], [0.913, 9.665], [0.018, 5.108], [-0.249, 15.968], [5.934, -0.081], [19.376, -0.18], [-4.809, -11.712], [10.395, -11.517], [13.543, 3.957], [-10.722, 21.676], [8.317, 0.131], [21.294, 0.147], [-0.018, -4.313], [0.055, -18.527], [0.413, -3.153], [7.962, 4.349], [5.734, 0.729], [2.915, -14.239], [-15.598, -4.268], [-7.757, 4.559], [-0.427, -11.911], [-0.004, -4.046], [0.231, -15.755], [-5.987, 0.078], [-20.23, 0.084], [-1.683, 0.23], [2.11, 4.011], [1.068, 4.393]],
                            "o": [[14.154, -7.365], [9.413, 10.725], [-3.812, 7.633], [10.427, 0.25], [0, 0.085], [8.305, 0], [13.663, -0.002], [0.056, -18.739], [0.287, -10.962], [6.408, 3.271], [14.838, -0.657], [1.238, -15.944], [-9.254, -2.059], [-8.524, 4.388], [-0.479, -5.076], [-0.055, -15.971], [0.088, -5.695], [-19.375, 0.265], [-12.981, 0.121], [5.681, 13.836], [-9.363, 10.374], [-21.114, -6.169], [3.695, -7.471], [-21.29, -0.335], [-4.9, -0.034], [0.078, 18.526], [-0.01, 3.19], [-1.171, 8.923], [-5.154, -2.814], [-14.954, -1.902], [-3.326, 16.243], [8.84, 2.419], [11.811, -6.943], [0.145, 4.042], [0.016, 15.758], [-0.082, 5.596], [20.227, -0.263], [1.7, -0.007], [4.11, -0.561], [-2.084, -3.963], [-3.906, -16.063]],
                            "v": [[-15.042, 44.178], [26.26, 51.842], [29.663, 93.217], [35.258, 102.588], [66.556, 102.646], [66.557, 102.902], [91.472, 102.902], [105.145, 89.479], [105.507, 33.266], [119.728, 24.856], [140.01, 29.585], [168.179, 3.187], [144.977, -28.782], [119.104, -24.387], [105.588, -31.773], [105.13, -47.09], [105.187, -95.004], [97.496, -102.968], [39.363, -102.752], [30.96, -90.177], [25.807, -51.318], [-9.121, -41.692], [-28.101, -92.846], [-33.659, -102.559], [-97.54, -102.896], [-103.598, -96], [-103.635, -40.421], [-104.054, -30.857], [-117.117, -24.257], [-133.477, -29.352], [-166.091, -6.753], [-145.074, 28.454], [-119.702, 25.476], [-103.703, 35.443], [-103.566, 47.58], [-103.635, 94.855], [-96.017, 102.971], [-35.329, 102.691], [-30.232, 102.368], [-26.627, 95.775], [-31.749, 83.417]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.832156910616, 0.668460442038, 0.520179598939, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [169.667, 103.3], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 8,
            "ty": 4,
            "nm": "a15 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1864.101, 1468.315, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.453, 167.925, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[2.037, 21.889], [5.117, -2.713], [6.678, -0.538], [5.949, 11.768], [-9.353, 10.487], [-17.03, -8.256], [-0.687, 8.048], [-0.604, 20.639], [5.663, -0.069], [17.889, 0.113], [4.356, 0.842], [-3.485, 6.527], [-0.536, 6.702], [15.675, 1.628], [1.866, -15.731], [-4.291, -7.721], [7.603, -1.406], [4.239, -0.029], [17.887, 0.237], [-0.217, -6.29], [-0.103, -10.86], [-1.294, -9.745], [-6.676, 3.467], [-7.829, -0.298], [-2.521, -15.919], [15.14, -5.277], [10.13, 5.04], [1.182, -7.969], [0.005, -1.481], [0.121, -19.593], [-4.405, 0.034], [-10.649, 0], [-11.252, -1.142], [4.528, -8.153], [-0.179, -7.205], [-15.266, -2.402], [-4.586, 13.457], [5.03, 9.374], [-8.613, 0.808], [-7.446, 0.08], [-14.695, 0.003], [0.068, 4.759]],
                            "o": [[-0.542, -5.823], [-5.935, 3.147], [-13.409, 1.081], [-6.327, -12.518], [10.626, -11.913], [7.17, 3.476], [1.758, -20.621], [0.175, -5.966], [-17.887, 0.219], [-4.45, -0.028], [-7.284, -1.406], [3.167, -5.93], [1.237, -15.489], [-16.328, -1.697], [-1.041, 8.78], [3.773, 6.789], [-4.159, 0.77], [-17.889, 0.12], [-5.936, -0.078], [0.374, 10.848], [0.092, 9.787], [1.023, 7.703], [6.983, -3.628], [16.042, 0.61], [2.471, 15.601], [-10.95, 3.816], [-7.095, -3.531], [-0.218, 1.472], [-0.069, 19.593], [-0.029, 4.746], [10.648, -0.082], [11.285, 0.021], [9.453, 0.959], [-3.529, 6.353], [0.376, 15.061], [13.664, 2.151], [3.55, -10.416], [-4.115, -7.669], [7.408, -0.695], [14.694, -0.158], [3.745, 0], [-0.311, -21.922]],
                            "v": [[103.167, 31.429], [95.683, 27.357], [76.866, 33.025], [44.122, 14.941], [49.055, -22.562], [94.372, -28.555], [103.332, -33.654], [104.232, -95.589], [96.31, -103.322], [42.642, -103.269], [29.315, -104.397], [23.846, -115.806], [29.62, -134.569], [3.196, -165.978], [-29.609, -140.64], [-24.399, -116.104], [-30.001, -104.316], [-42.699, -103.249], [-96.367, -103.264], [-104.638, -95.217], [-104.536, -62.637], [-103.91, -33.284], [-95.065, -28.462], [-72.882, -33.382], [-41.203, -5.194], [-63.174, 31.065], [-94.687, 28.077], [-103.93, 33.05], [-104.42, 37.489], [-104.588, 96.268], [-97.866, 102.616], [-65.92, 102.589], [-32.088, 103.468], [-24.871, 116.549], [-29.734, 136.753], [-4.083, 165.524], [28.025, 145.706], [24.241, 116.238], [30.761, 103.674], [53.086, 102.688], [97.171, 102.598], [104.085, 97.191]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.832156910616, 0.668460442038, 0.520179598939, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.454, 167.925], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }]
    }, {
        "id": "comp_7",
        "nm": "Group 5",
        "fr": 29.9700012207031,
        "layers": [{
            "ddd": 0,
            "ind": 1,
            "ty": 5,
            "nm": "GLB",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [692.485, 1460, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "GLB",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 2,
            "ty": 5,
            "nm": "ACM",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [693.826, 1701, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "ACM",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 3,
            "ty": 5,
            "nm": "NLB",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [693.318, 1234, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "NLB",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 4,
            "ty": 5,
            "nm": "HTTPS",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [931.876, 1701, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "HTTPS",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 5,
            "ty": 5,
            "nm": "ALB",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [461.876, 1234, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "ALB",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 6,
            "ty": 4,
            "nm": "a7 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [498.823, 1235.975, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [137.647, 103.294, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-5.35, 0.056], [-19.8, 0.221], [4.848, 10.465], [-20.244, 5.644], [-9.287, -10.836], [6.384, -14.025], [-10.218, -0.124], [-20.438, -0.203], [0.05, 5.144], [-0.052, 17.673], [-0.467, 3.788], [-7.881, -4.155], [-5.535, -0.742], [-3.403, 14.19], [14.25, 5.245], [8.582, -5.005], [0.349, 10.746], [0.006, 4.258], [-0.21, 15.754], [5.518, -0.059], [20.438, -0.252], [-4.554, -9.325], [-0.65, -4.222], [15.588, -5.486], [8.11, 14.629], [-6.137, 12.08], [6.961, 0.197], [10.857, 0], [0, 0.115], [10.43, 0.204], [-0.01, -5.517], [0.134, -63.665]],
                            "o": [[19.8, -0.206], [11.798, -0.132], [-9.496, -20.497], [13.811, -3.851], [10.485, 12.233], [-4.108, 9.025], [20.437, 0.25], [5.275, 0.052], [-0.168, -17.671], [0.011, -3.828], [1.106, -8.965], [4.974, 2.623], [15.114, 2.026], [3.611, -15.059], [-9.545, -3.512], [-12.632, 7.367], [-0.138, -4.255], [-0.021, -15.757], [0.072, -5.461], [-20.438, 0.221], [-10.175, 0.125], [1.89, 3.87], [2.596, 16.863], [-15.599, 5.49], [-6.796, -12.259], [3.149, -6.198], [-10.848, -0.307], [0, -0.115], [-10.433, 0], [-5.451, -0.107], [0.113, 63.664], [-0.012, 5.677]],
                            "v": [[-129.786, 102.987], [-70.382, 102.747], [-62.82, 90.971], [-42.671, 41.647], [-7.387, 51.945], [-3.647, 92.086], [3.077, 102.697], [64.396, 102.984], [71.457, 95.714], [71.433, 42.695], [71.899, 31.219], [84.887, 24.244], [100.576, 29.378], [133.785, 7.519], [115.495, -27.644], [87.694, -25.477], [71.563, -35.281], [71.396, -48.053], [71.456, -95.323], [63.996, -102.938], [2.678, -102.622], [-3.54, -91.909], [0.219, -79.75], [-21.66, -42.201], [-62.312, -57.451], [-61.223, -94.125], [-65.979, -102.451], [-98.548, -102.531], [-98.548, -102.878], [-129.847, -102.936], [-137.372, -95.38], [-137.385, 95.615]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.721568627451, 0.498039245605, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [137.647, 103.294], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 7,
            "ty": 4,
            "nm": "a14 Outlines 2",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [695.601, 1466.277, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [169.936, 103.308, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-0.707, 3.733], [-6.485, -3.346], [-5.517, -0.874], [-2.35, 15.48], [17.36, 2.805], [7.341, -3.899], [0.926, 10.056], [0.019, 5.322], [-0.266, 15.756], [5.759, -0.072], [19.378, -0.183], [-4.938, -11.793], [18.82, -7.011], [9.044, 10.006], [-7.09, 14.535], [9.667, 0.117], [20.443, 0.238], [-0.057, -5.518], [0.073, -18.315], [0.503, -3.351], [7.323, 3.814], [5.767, 0.761], [2.172, -15.408], [-16.805, -2.493], [-7.403, 3.746], [-1.077, -10.068], [-0.009, -3.405], [0.279, -17.459], [-5.982, 0.08], [-18.316, 0.051], [-3.181, 0.263], [2.505, 4.682], [0.982, 3.015], [-15.104, 8.344], [-10.107, -12.904], [7.047, -14.032], [-7.298, -0.201], [-10.86, 0], [0, -0.1], [-9.797, 0.042], [-0.007, 8.408], [-0.084, 17.676]],
                            "o": [[1.364, -7.195], [4.981, 2.569], [16.639, 2.633], [2.658, -17.506], [-8.255, -1.334], [-8.976, 4.767], [-0.487, -5.287], [-0.055, -15.759], [0.099, -5.868], [-19.377, 0.244], [-12.867, 0.121], [8.481, 20.251], [-12.985, 4.838], [-9.73, -10.766], [4.194, -8.598], [-20.442, -0.248], [-5.506, -0.064], [0.186, 18.313], [-0.013, 3.401], [-1.24, 8.258], [-5.157, -2.686], [-16.093, -2.124], [-2.409, 17.089], [8.297, 1.231], [9.096, -4.602], [0.361, 3.377], [0.044, 17.463], [-0.099, 6.2], [18.313, -0.243], [3.191, -0.009], [4.787, -0.397], [-1.501, -2.805], [-5.636, -17.31], [13.793, -7.62], [10.099, 12.893], [-3.326, 6.621], [10.851, 0.299], [0, 0.101], [9.797, 0], [8.629, -0.036], [0.015, -17.677], [0.018, -3.818]],
                            "v": [[105.173, 29.425], [116.616, 23.764], [132.195, 29.252], [167.028, 5.642], [142.047, -29.183], [118.632, -24.638], [104.684, -31.927], [104.301, -47.886], [104.338, -95.164], [96.491, -102.986], [38.352, -102.767], [30.069, -90.143], [11.931, -42.314], [-25.024, -50.985], [-29.329, -92.238], [-35.666, -102.672], [-96.999, -102.97], [-104.49, -95.464], [-104.508, -40.518], [-105.054, -30.324], [-117.403, -23.91], [-133.656, -29.382], [-167.277, -4.898], [-142.274, 29.274], [-118.825, 24.748], [-104.847, 32.232], [-104.505, 42.442], [-104.551, 94.831], [-96.285, 102.978], [-41.339, 102.834], [-31.767, 102.424], [-27.724, 95.217], [-31.622, 86.489], [-15.906, 44.168], [26.155, 52.956], [28.36, 93.782], [33.171, 102.486], [65.748, 102.563], [65.748, 102.865], [95.138, 102.855], [104.287, 93.891], [104.334, 40.861]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.721578022078, 0.496470582251, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [169.936, 103.308], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 8,
            "ty": 4,
            "nm": "a15 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [695.101, 1696.315, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.453, 167.925, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[2.037, 21.889], [5.117, -2.713], [6.678, -0.538], [5.949, 11.768], [-9.353, 10.487], [-17.03, -8.256], [-0.687, 8.048], [-0.604, 20.639], [5.663, -0.069], [17.889, 0.113], [4.356, 0.842], [-3.485, 6.527], [-0.536, 6.702], [15.675, 1.628], [1.866, -15.731], [-4.291, -7.721], [7.603, -1.406], [4.239, -0.029], [17.887, 0.237], [-0.217, -6.29], [-0.103, -10.86], [-1.294, -9.745], [-6.676, 3.467], [-7.829, -0.298], [-2.521, -15.919], [15.14, -5.277], [10.13, 5.04], [1.182, -7.969], [0.005, -1.481], [0.121, -19.593], [-4.405, 0.034], [-10.649, 0], [-11.252, -1.142], [4.528, -8.153], [-0.179, -7.205], [-15.266, -2.402], [-4.586, 13.457], [5.03, 9.374], [-8.613, 0.808], [-7.446, 0.08], [-14.695, 0.003], [0.068, 4.759]],
                            "o": [[-0.542, -5.823], [-5.935, 3.147], [-13.409, 1.081], [-6.327, -12.518], [10.626, -11.913], [7.17, 3.476], [1.758, -20.621], [0.175, -5.966], [-17.887, 0.219], [-4.45, -0.028], [-7.284, -1.406], [3.167, -5.93], [1.237, -15.489], [-16.328, -1.697], [-1.041, 8.78], [3.773, 6.789], [-4.159, 0.77], [-17.889, 0.12], [-5.936, -0.078], [0.374, 10.848], [0.092, 9.787], [1.023, 7.703], [6.983, -3.628], [16.042, 0.61], [2.471, 15.601], [-10.95, 3.816], [-7.095, -3.531], [-0.218, 1.472], [-0.069, 19.593], [-0.029, 4.746], [10.648, -0.082], [11.285, 0.021], [9.453, 0.959], [-3.529, 6.353], [0.376, 15.061], [13.664, 2.151], [3.55, -10.416], [-4.115, -7.669], [7.408, -0.695], [14.694, -0.158], [3.745, 0], [-0.311, -21.922]],
                            "v": [[103.167, 31.429], [95.683, 27.357], [76.866, 33.025], [44.122, 14.941], [49.055, -22.562], [94.372, -28.555], [103.332, -33.654], [104.232, -95.589], [96.31, -103.322], [42.642, -103.269], [29.315, -104.397], [23.846, -115.806], [29.62, -134.569], [3.196, -165.978], [-29.609, -140.64], [-24.399, -116.104], [-30.001, -104.316], [-42.699, -103.249], [-96.367, -103.264], [-104.638, -95.217], [-104.536, -62.637], [-103.91, -33.284], [-95.065, -28.462], [-72.882, -33.382], [-41.203, -5.194], [-63.174, 31.065], [-94.687, 28.077], [-103.93, 33.05], [-104.42, 37.489], [-104.588, 96.268], [-97.866, 102.616], [-65.92, 102.589], [-32.088, 103.468], [-24.871, 116.549], [-29.734, 136.753], [-4.083, 165.524], [28.025, 145.706], [24.241, 116.238], [30.761, 103.674], [53.086, 102.688], [97.171, 102.598], [104.085, 97.191]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.721578022078, 0.496470582251, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.454, 167.925], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 9,
            "ty": 4,
            "nm": "a16 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [926.972, 1696.769, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [169.667, 103.299, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-13.823, 7.193], [-10.473, -11.934], [7.324, -14.669], [-8.642, -0.207], [-10.433, 0], [-0.001, -0.085], [-8.305, 0.001], [-0.041, 13.42], [-0.49, 18.728], [-9.564, -4.882], [-7.187, 0.318], [-1.107, 14.256], [15.221, 3.388], [8.153, -4.197], [0.913, 9.665], [0.018, 5.108], [-0.249, 15.968], [5.934, -0.081], [19.376, -0.18], [-4.809, -11.712], [10.395, -11.517], [13.543, 3.957], [-10.722, 21.676], [8.317, 0.131], [21.294, 0.147], [-0.018, -4.313], [0.055, -18.527], [0.413, -3.153], [7.962, 4.349], [5.734, 0.729], [2.915, -14.239], [-15.598, -4.268], [-7.757, 4.559], [-0.427, -11.911], [-0.004, -4.046], [0.231, -15.755], [-5.987, 0.078], [-20.23, 0.084], [-1.683, 0.23], [2.11, 4.011], [1.068, 4.393]],
                            "o": [[14.154, -7.365], [9.413, 10.725], [-3.812, 7.633], [10.427, 0.25], [0, 0.085], [8.305, 0], [13.663, -0.002], [0.056, -18.739], [0.287, -10.962], [6.408, 3.271], [14.838, -0.657], [1.238, -15.944], [-9.254, -2.059], [-8.524, 4.388], [-0.479, -5.076], [-0.055, -15.971], [0.088, -5.695], [-19.375, 0.265], [-12.981, 0.121], [5.681, 13.836], [-9.363, 10.374], [-21.114, -6.169], [3.695, -7.471], [-21.29, -0.335], [-4.9, -0.034], [0.078, 18.526], [-0.01, 3.19], [-1.171, 8.923], [-5.154, -2.814], [-14.954, -1.902], [-3.326, 16.243], [8.84, 2.419], [11.811, -6.943], [0.145, 4.042], [0.016, 15.758], [-0.082, 5.596], [20.227, -0.263], [1.7, -0.007], [4.11, -0.561], [-2.084, -3.963], [-3.906, -16.063]],
                            "v": [[-15.042, 44.178], [26.26, 51.842], [29.663, 93.217], [35.258, 102.588], [66.556, 102.646], [66.557, 102.902], [91.472, 102.902], [105.145, 89.479], [105.507, 33.266], [119.728, 24.856], [140.01, 29.585], [168.179, 3.187], [144.977, -28.782], [119.104, -24.387], [105.588, -31.773], [105.13, -47.09], [105.187, -95.004], [97.496, -102.968], [39.363, -102.752], [30.96, -90.177], [25.807, -51.318], [-9.121, -41.692], [-28.101, -92.846], [-33.659, -102.559], [-97.54, -102.896], [-103.598, -96], [-103.635, -40.421], [-104.054, -30.857], [-117.117, -24.257], [-133.477, -29.352], [-166.091, -6.753], [-145.074, 28.454], [-119.702, 25.476], [-103.703, 35.443], [-103.566, 47.58], [-103.635, 94.855], [-96.017, 102.971], [-35.329, 102.691], [-30.232, 102.368], [-26.627, 95.775], [-31.749, 83.417]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.721578022078, 0.496470582251, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [169.667, 103.3], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 10,
            "ty": 4,
            "nm": "a14 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": -90, "ix": 10},
                "p": {"a": 0, "k": [695.851, 1235.277, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [169.936, 103.308, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-0.707, 3.733], [-6.485, -3.346], [-5.517, -0.874], [-2.35, 15.48], [17.36, 2.805], [7.341, -3.899], [0.926, 10.056], [0.019, 5.322], [-0.266, 15.756], [5.759, -0.072], [19.378, -0.183], [-4.938, -11.793], [18.82, -7.011], [9.044, 10.006], [-7.09, 14.535], [9.667, 0.117], [20.443, 0.238], [-0.057, -5.518], [0.073, -18.315], [0.503, -3.351], [7.323, 3.814], [5.767, 0.761], [2.172, -15.408], [-16.805, -2.493], [-7.403, 3.746], [-1.077, -10.068], [-0.009, -3.405], [0.279, -17.459], [-5.982, 0.08], [-18.316, 0.051], [-3.181, 0.263], [2.505, 4.682], [0.982, 3.015], [-15.104, 8.344], [-10.107, -12.904], [7.047, -14.032], [-7.298, -0.201], [-10.86, 0], [0, -0.1], [-9.797, 0.042], [-0.007, 8.408], [-0.084, 17.676]],
                            "o": [[1.364, -7.195], [4.981, 2.569], [16.639, 2.633], [2.658, -17.506], [-8.255, -1.334], [-8.976, 4.767], [-0.487, -5.287], [-0.055, -15.759], [0.099, -5.868], [-19.377, 0.244], [-12.867, 0.121], [8.481, 20.251], [-12.985, 4.838], [-9.73, -10.766], [4.194, -8.598], [-20.442, -0.248], [-5.506, -0.064], [0.186, 18.313], [-0.013, 3.401], [-1.24, 8.258], [-5.157, -2.686], [-16.093, -2.124], [-2.409, 17.089], [8.297, 1.231], [9.096, -4.602], [0.361, 3.377], [0.044, 17.463], [-0.099, 6.2], [18.313, -0.243], [3.191, -0.009], [4.787, -0.397], [-1.501, -2.805], [-5.636, -17.31], [13.793, -7.62], [10.099, 12.893], [-3.326, 6.621], [10.851, 0.299], [0, 0.101], [9.797, 0], [8.629, -0.036], [0.015, -17.677], [0.018, -3.818]],
                            "v": [[105.173, 29.425], [116.616, 23.764], [132.195, 29.252], [167.028, 5.642], [142.047, -29.183], [118.632, -24.638], [104.684, -31.927], [104.301, -47.886], [104.338, -95.164], [96.491, -102.986], [38.352, -102.767], [30.069, -90.143], [11.931, -42.314], [-25.024, -50.985], [-29.329, -92.238], [-35.666, -102.672], [-96.999, -102.97], [-104.49, -95.464], [-104.508, -40.518], [-105.054, -30.324], [-117.403, -23.91], [-133.656, -29.382], [-167.277, -4.898], [-142.274, 29.274], [-118.825, 24.748], [-104.847, 32.232], [-104.505, 42.442], [-104.551, 94.831], [-96.285, 102.978], [-41.339, 102.834], [-31.767, 102.424], [-27.724, 95.217], [-31.622, 86.489], [-15.906, 44.168], [26.155, 52.956], [28.36, 93.782], [33.171, 102.486], [65.748, 102.563], [65.748, 102.865], [95.138, 102.855], [104.287, 93.891], [104.334, 40.861]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.721578022078, 0.496470582251, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [169.936, 103.308], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 462.000018817646,
            "st": 0,
            "bm": 0
        }]
    }, {
        "id": "comp_8",
        "nm": "Group 4",
        "fr": 29.9700012207031,
        "layers": [{
            "ddd": 0,
            "ind": 1,
            "ty": 5,
            "nm": "Policy",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [2116.876, 2163, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Policy",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 459.000018695453,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 2,
            "ty": 5,
            "nm": "Topic",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [2087.876, 1925, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Topic",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 459.000018695453,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 3,
            "ty": 5,
            "nm": "SNS",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1863.876, 1925, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "SNS",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 459.000018695453,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 4,
            "ty": 5,
            "nm": "SQS",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1633.876, 1925, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "SQS",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 459.000018695453,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 5,
            "ty": 4,
            "nm": "a19 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": -90, "ix": 10},
                "p": {"a": 0, "k": [2095.96, 2123.245, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [137.215, 103.514, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [107.13, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-7.148, -3.55], [-4.188, -0.953], [-7.305, 11.235], [7.279, 10.012], [15.26, -7.592], [0.641, 12.57], [0.009, 4.682], [-0.227, 15.748], [5.572, -0.068], [19.157, -0.073], [2.531, -0.308], [-2.981, -4.918], [-0.881, -5.069], [13.659, -6.649], [9.905, 10.877], [-8.032, 15.998], [6.512, 0.938], [3.822, 0.015], [17.241, -0.031], [0.002, -8.274], [-0.015, -63.007], [-8.261, -0.006], [-31.929, 0], [-31.929, 0.022], [-0.015, 8.42], [-0.077, 17.242], [-0.656, 4.179]],
                            "o": [[3.827, 1.9], [14.126, 3.214], [6.466, -9.943], [-8.636, -11.879], [-11.198, 5.571], [-0.238, -4.673], [-0.033, -15.752], [0.079, -5.486], [-19.155, 0.235], [-2.543, 0.01], [-4.993, 0.609], [2.673, 4.411], [2.704, 15.562], [-13.352, 6.5], [-10.153, -11.151], [2.987, -5.95], [-3.774, -0.544], [-17.242, -0.065], [-8.374, 0.014], [-0.016, 63.006], [0.002, 8.418], [31.929, 0.022], [31.929, 0], [8.273, -0.005], [0.03, -17.242], [0.019, -4.248], [1.246, -7.94]],
                            "v": [[84.509, 23.9], [96.348, 28.577], [130.499, 15.801], [129.13, -17.827], [87.45, -25.303], [72.005, -34.384], [71.794, -48.428], [71.836, -95.681], [64.429, -103.197], [6.958, -103.022], [-0.667, -102.388], [-4.636, -94.727], [0.455, -80.354], [-17.694, -43.629], [-57.551, -51.13], [-60.907, -94.066], [-65.058, -102.434], [-76.514, -103.083], [-128.24, -103.105], [-136.949, -94.501], [-136.947, 94.518], [-128.394, 103.242], [-32.607, 103.251], [63.179, 103.242], [71.731, 94.534], [71.788, 42.809], [72.484, 30.079]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.043137254902, 0.587985887714, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [137.215, 103.515], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 459.000018695453,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 6,
            "ty": 4,
            "nm": "a7 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": -180, "ix": 10},
                "p": {"a": 0, "k": [2059.823, 1929.475, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [137.647, 103.294, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-5.35, 0.056], [-19.8, 0.221], [4.848, 10.465], [-20.244, 5.644], [-9.287, -10.836], [6.384, -14.025], [-10.218, -0.124], [-20.438, -0.203], [0.05, 5.144], [-0.052, 17.673], [-0.467, 3.788], [-7.881, -4.155], [-5.535, -0.742], [-3.403, 14.19], [14.25, 5.245], [8.582, -5.005], [0.349, 10.746], [0.006, 4.258], [-0.21, 15.754], [5.518, -0.059], [20.438, -0.252], [-4.554, -9.325], [-0.65, -4.222], [15.588, -5.486], [8.11, 14.629], [-6.137, 12.08], [6.961, 0.197], [10.857, 0], [0, 0.115], [10.43, 0.204], [-0.01, -5.517], [0.134, -63.665]],
                            "o": [[19.8, -0.206], [11.798, -0.132], [-9.496, -20.497], [13.811, -3.851], [10.485, 12.233], [-4.108, 9.025], [20.437, 0.25], [5.275, 0.052], [-0.168, -17.671], [0.011, -3.828], [1.106, -8.965], [4.974, 2.623], [15.114, 2.026], [3.611, -15.059], [-9.545, -3.512], [-12.632, 7.367], [-0.138, -4.255], [-0.021, -15.757], [0.072, -5.461], [-20.438, 0.221], [-10.175, 0.125], [1.89, 3.87], [2.596, 16.863], [-15.599, 5.49], [-6.796, -12.259], [3.149, -6.198], [-10.848, -0.307], [0, -0.115], [-10.433, 0], [-5.451, -0.107], [0.113, 63.664], [-0.012, 5.677]],
                            "v": [[-129.786, 102.987], [-70.382, 102.747], [-62.82, 90.971], [-42.671, 41.647], [-7.387, 51.945], [-3.647, 92.086], [3.077, 102.697], [64.396, 102.984], [71.457, 95.714], [71.433, 42.695], [71.899, 31.219], [84.887, 24.244], [100.576, 29.378], [133.785, 7.519], [115.495, -27.644], [87.694, -25.477], [71.563, -35.281], [71.396, -48.053], [71.456, -95.323], [63.996, -102.938], [2.678, -102.622], [-3.54, -91.909], [0.219, -79.75], [-21.66, -42.201], [-62.312, -57.451], [-61.223, -94.125], [-65.979, -102.451], [-98.548, -102.531], [-98.548, -102.878], [-129.847, -102.936], [-137.372, -95.38], [-137.385, 95.615]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.043137254902, 0.587985887714, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [137.647, 103.294], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 459.000018695453,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 7,
            "ty": 4,
            "nm": "a16 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1628.972, 1928.269, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [169.667, 103.299, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-13.823, 7.193], [-10.473, -11.934], [7.324, -14.669], [-8.642, -0.207], [-10.433, 0], [-0.001, -0.085], [-8.305, 0.001], [-0.041, 13.42], [-0.49, 18.728], [-9.564, -4.882], [-7.187, 0.318], [-1.107, 14.256], [15.221, 3.388], [8.153, -4.197], [0.913, 9.665], [0.018, 5.108], [-0.249, 15.968], [5.934, -0.081], [19.376, -0.18], [-4.809, -11.712], [10.395, -11.517], [13.543, 3.957], [-10.722, 21.676], [8.317, 0.131], [21.294, 0.147], [-0.018, -4.313], [0.055, -18.527], [0.413, -3.153], [7.962, 4.349], [5.734, 0.729], [2.915, -14.239], [-15.598, -4.268], [-7.757, 4.559], [-0.427, -11.911], [-0.004, -4.046], [0.231, -15.755], [-5.987, 0.078], [-20.23, 0.084], [-1.683, 0.23], [2.11, 4.011], [1.068, 4.393]],
                            "o": [[14.154, -7.365], [9.413, 10.725], [-3.812, 7.633], [10.427, 0.25], [0, 0.085], [8.305, 0], [13.663, -0.002], [0.056, -18.739], [0.287, -10.962], [6.408, 3.271], [14.838, -0.657], [1.238, -15.944], [-9.254, -2.059], [-8.524, 4.388], [-0.479, -5.076], [-0.055, -15.971], [0.088, -5.695], [-19.375, 0.265], [-12.981, 0.121], [5.681, 13.836], [-9.363, 10.374], [-21.114, -6.169], [3.695, -7.471], [-21.29, -0.335], [-4.9, -0.034], [0.078, 18.526], [-0.01, 3.19], [-1.171, 8.923], [-5.154, -2.814], [-14.954, -1.902], [-3.326, 16.243], [8.84, 2.419], [11.811, -6.943], [0.145, 4.042], [0.016, 15.758], [-0.082, 5.596], [20.227, -0.263], [1.7, -0.007], [4.11, -0.561], [-2.084, -3.963], [-3.906, -16.063]],
                            "v": [[-15.042, 44.178], [26.26, 51.842], [29.663, 93.217], [35.258, 102.588], [66.556, 102.646], [66.557, 102.902], [91.472, 102.902], [105.145, 89.479], [105.507, 33.266], [119.728, 24.856], [140.01, 29.585], [168.179, 3.187], [144.977, -28.782], [119.104, -24.387], [105.588, -31.773], [105.13, -47.09], [105.187, -95.004], [97.496, -102.968], [39.363, -102.752], [30.96, -90.177], [25.807, -51.318], [-9.121, -41.692], [-28.101, -92.846], [-33.659, -102.559], [-97.54, -102.896], [-103.598, -96], [-103.635, -40.421], [-104.054, -30.857], [-117.117, -24.257], [-133.477, -29.352], [-166.091, -6.753], [-145.074, 28.454], [-119.702, 25.476], [-103.703, 35.443], [-103.566, 47.58], [-103.635, 94.855], [-96.017, 102.971], [-35.329, 102.691], [-30.232, 102.368], [-26.627, 95.775], [-31.749, 83.417]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.043137254902, 0.587985887714, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [169.667, 103.3], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 459.000018695453,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 8,
            "ty": 4,
            "nm": "a15 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1863.601, 1927.815, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.453, 167.925, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[2.037, 21.889], [5.117, -2.713], [6.678, -0.538], [5.949, 11.768], [-9.353, 10.487], [-17.03, -8.256], [-0.687, 8.048], [-0.604, 20.639], [5.663, -0.069], [17.889, 0.113], [4.356, 0.842], [-3.485, 6.527], [-0.536, 6.702], [15.675, 1.628], [1.866, -15.731], [-4.291, -7.721], [7.603, -1.406], [4.239, -0.029], [17.887, 0.237], [-0.217, -6.29], [-0.103, -10.86], [-1.294, -9.745], [-6.676, 3.467], [-7.829, -0.298], [-2.521, -15.919], [15.14, -5.277], [10.13, 5.04], [1.182, -7.969], [0.005, -1.481], [0.121, -19.593], [-4.405, 0.034], [-10.649, 0], [-11.252, -1.142], [4.528, -8.153], [-0.179, -7.205], [-15.266, -2.402], [-4.586, 13.457], [5.03, 9.374], [-8.613, 0.808], [-7.446, 0.08], [-14.695, 0.003], [0.068, 4.759]],
                            "o": [[-0.542, -5.823], [-5.935, 3.147], [-13.409, 1.081], [-6.327, -12.518], [10.626, -11.913], [7.17, 3.476], [1.758, -20.621], [0.175, -5.966], [-17.887, 0.219], [-4.45, -0.028], [-7.284, -1.406], [3.167, -5.93], [1.237, -15.489], [-16.328, -1.697], [-1.041, 8.78], [3.773, 6.789], [-4.159, 0.77], [-17.889, 0.12], [-5.936, -0.078], [0.374, 10.848], [0.092, 9.787], [1.023, 7.703], [6.983, -3.628], [16.042, 0.61], [2.471, 15.601], [-10.95, 3.816], [-7.095, -3.531], [-0.218, 1.472], [-0.069, 19.593], [-0.029, 4.746], [10.648, -0.082], [11.285, 0.021], [9.453, 0.959], [-3.529, 6.353], [0.376, 15.061], [13.664, 2.151], [3.55, -10.416], [-4.115, -7.669], [7.408, -0.695], [14.694, -0.158], [3.745, 0], [-0.311, -21.922]],
                            "v": [[103.167, 31.429], [95.683, 27.357], [76.866, 33.025], [44.122, 14.941], [49.055, -22.562], [94.372, -28.555], [103.332, -33.654], [104.232, -95.589], [96.31, -103.322], [42.642, -103.269], [29.315, -104.397], [23.846, -115.806], [29.62, -134.569], [3.196, -165.978], [-29.609, -140.64], [-24.399, -116.104], [-30.001, -104.316], [-42.699, -103.249], [-96.367, -103.264], [-104.638, -95.217], [-104.536, -62.637], [-103.91, -33.284], [-95.065, -28.462], [-72.882, -33.382], [-41.203, -5.194], [-63.174, 31.065], [-94.687, 28.077], [-103.93, 33.05], [-104.42, 37.489], [-104.588, 96.268], [-97.866, 102.616], [-65.92, 102.589], [-32.088, 103.468], [-24.871, 116.549], [-29.734, 136.753], [-4.083, 165.524], [28.025, 145.706], [24.241, 116.238], [30.761, 103.674], [53.086, 102.688], [97.171, 102.598], [104.085, 97.191]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.043137254902, 0.587985887714, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.454, 167.925], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 459.000018695453,
            "st": 0,
            "bm": 0
        }]
    }, {
        "id": "comp_9",
        "nm": "Group 3",
        "fr": 29.9700012207031,
        "layers": [{
            "ddd": 0,
            "ind": 1,
            "ty": 5,
            "nm": "Container",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1395.605, 2158.024, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [0.605, -14.561, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Container",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 460.000018736184,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 2,
            "ty": 5,
            "nm": "ECR",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1868.85, 2158.024, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [0.85, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "ECR",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 460.000018736184,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 3,
            "ty": 5,
            "nm": "Task",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1628.557, 2158.764, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [0.557, -14.064, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 38,
                            "f": "Roboto-Bold",
                            "t": "Task",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 45.6000022888184,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 460.000018736184,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 4,
            "ty": 5,
            "nm": "ECS",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1393.292, 1927.445, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.708, -17.773, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "ECS",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 460.000018736184,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 5,
            "ty": 4,
            "nm": "a15 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1395.601, 1927.815, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.453, 167.925, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[2.037, 21.889], [5.117, -2.713], [6.678, -0.538], [5.949, 11.768], [-9.353, 10.487], [-17.03, -8.256], [-0.687, 8.048], [-0.604, 20.639], [5.663, -0.069], [17.889, 0.113], [4.356, 0.842], [-3.485, 6.527], [-0.536, 6.702], [15.675, 1.628], [1.866, -15.731], [-4.291, -7.721], [7.603, -1.406], [4.239, -0.029], [17.887, 0.237], [-0.217, -6.29], [-0.103, -10.86], [-1.294, -9.745], [-6.676, 3.467], [-7.829, -0.298], [-2.521, -15.919], [15.14, -5.277], [10.13, 5.04], [1.182, -7.969], [0.005, -1.481], [0.121, -19.593], [-4.405, 0.034], [-10.649, 0], [-11.252, -1.142], [4.528, -8.153], [-0.179, -7.205], [-15.266, -2.402], [-4.586, 13.457], [5.03, 9.374], [-8.613, 0.808], [-7.446, 0.08], [-14.695, 0.003], [0.068, 4.759]],
                            "o": [[-0.542, -5.823], [-5.935, 3.147], [-13.409, 1.081], [-6.327, -12.518], [10.626, -11.913], [7.17, 3.476], [1.758, -20.621], [0.175, -5.966], [-17.887, 0.219], [-4.45, -0.028], [-7.284, -1.406], [3.167, -5.93], [1.237, -15.489], [-16.328, -1.697], [-1.041, 8.78], [3.773, 6.789], [-4.159, 0.77], [-17.889, 0.12], [-5.936, -0.078], [0.374, 10.848], [0.092, 9.787], [1.023, 7.703], [6.983, -3.628], [16.042, 0.61], [2.471, 15.601], [-10.95, 3.816], [-7.095, -3.531], [-0.218, 1.472], [-0.069, 19.593], [-0.029, 4.746], [10.648, -0.082], [11.285, 0.021], [9.453, 0.959], [-3.529, 6.353], [0.376, 15.061], [13.664, 2.151], [3.55, -10.416], [-4.115, -7.669], [7.408, -0.695], [14.694, -0.158], [3.745, 0], [-0.311, -21.922]],
                            "v": [[103.167, 31.429], [95.683, 27.357], [76.866, 33.025], [44.122, 14.941], [49.055, -22.562], [94.372, -28.555], [103.332, -33.654], [104.232, -95.589], [96.31, -103.322], [42.642, -103.269], [29.315, -104.397], [23.846, -115.806], [29.62, -134.569], [3.196, -165.978], [-29.609, -140.64], [-24.399, -116.104], [-30.001, -104.316], [-42.699, -103.249], [-96.367, -103.264], [-104.638, -95.217], [-104.536, -62.637], [-103.91, -33.284], [-95.065, -28.462], [-72.882, -33.382], [-41.203, -5.194], [-63.174, 31.065], [-94.687, 28.077], [-103.93, 33.05], [-104.42, 37.489], [-104.588, 96.268], [-97.866, 102.616], [-65.92, 102.589], [-32.088, 103.468], [-24.871, 116.549], [-29.734, 136.753], [-4.083, 165.524], [28.025, 145.706], [24.241, 116.238], [30.761, 103.674], [53.086, 102.688], [97.171, 102.598], [104.085, 97.191]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.496470582251, 0.887446265127, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.454, 167.925], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 460.000018736184,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 6,
            "ty": 4,
            "nm": "a21 Outlines 2",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1864.32, 2158.893, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [170.574, 104.413, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-7.201, -3.527], [-4.172, -0.983], [-4.28, 15.366], [15.629, 4.449], [8.183, -4.957], [0.603, 13.285], [0.005, 4.044], [-0.236, 16.389], [5.541, -0.069], [19.371, -0.072], [2.312, -0.32], [-3.02, -4.916], [-0.87, -5.285], [13.417, -6.469], [9.741, 11.508], [-6.487, 14.267], [9.638, 0.16], [20.86, 0.179], [-0.022, -4.369], [0.078, -17.669], [0.613, -4.19], [7.836, 4.158], [7.856, -0.45], [4.485, -11.28], [-7.893, -9.065], [-15.701, 8.056], [-1.007, -10.517], [-0.032, -3.191], [-0.25, -5.951], [-2.654, -13.896], [-14.138, -0.304], [-20.224, 0.005], [-32.144, -0.233], [0.088, 6.105], [-0.072, 18.947], [-0.471, 2.707]],
                            "o": [[3.839, 1.88], [16.869, 3.973], [4.392, -15.764], [-9.121, -2.597], [-9.495, 5.752], [-0.183, -4.039], [-0.02, -16.392], [0.079, -5.522], [-19.369, 0.242], [-2.333, 0.009], [-4.888, 0.678], [2.823, 4.597], [2.51, 15.256], [-13.759, 6.634], [-10.606, -12.528], [3.936, -8.657], [-20.857, -0.346], [-4.883, -0.042], [0.088, 17.668], [-0.019, 4.25], [-1.292, 8.835], [-6.972, -3.698], [-12.261, 0.702], [-4.316, 10.854], [10.081, 11.578], [9.375, -4.81], [0.304, 3.173], [0.06, 5.961], [0.587, 13.956], [14.048, 3.22], [20.214, 0.435], [32.146, 0], [6.17, 0.045], [-0.273, -18.942], [0.011, -2.759], [1.38, -7.931]],
                            "v": [[116.408, 23.023], [128.266, 27.671], [165.932, 7.37], [146.039, -28.976], [119.437, -26.126], [103.883, -35.307], [103.707, -47.438], [103.778, -96.613], [96.341, -104.094], [38.227, -103.893], [31.232, -103.376], [27.253, -95.649], [32.424, -80.643], [14.257, -44.531], [-25.981, -52.515], [-29.898, -93.203], [-36.269, -103.718], [-98.852, -104.059], [-105.012, -97.307], [-105.032, -44.299], [-105.699, -31.562], [-118.318, -25.059], [-140.414, -30.144], [-166.008, -12.126], [-161.074, 18.344], [-119.568, 23.866], [-105.386, 31.613], [-105.024, 41.182], [-104.945, 59.062], [-103.795, 100.943], [-61.375, 102.244], [-0.706, 102.351], [95.731, 102.459], [103.805, 94.314], [103.802, 37.477], [104.354, 29.21]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.496470582251, 0.887446265127, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [170.574, 104.413], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 460.000018736184,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 7,
            "ty": 4,
            "nm": "a21 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1396.32, 2158.893, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [170.574, 104.413, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-7.201, -3.527], [-4.172, -0.983], [-4.28, 15.366], [15.629, 4.449], [8.183, -4.957], [0.603, 13.285], [0.005, 4.044], [-0.236, 16.389], [5.541, -0.069], [19.371, -0.072], [2.312, -0.32], [-3.02, -4.916], [-0.87, -5.285], [13.417, -6.469], [9.741, 11.508], [-6.487, 14.267], [9.638, 0.16], [20.86, 0.179], [-0.022, -4.369], [0.078, -17.669], [0.613, -4.19], [7.836, 4.158], [7.856, -0.45], [4.485, -11.28], [-7.893, -9.065], [-15.701, 8.056], [-1.007, -10.517], [-0.032, -3.191], [-0.25, -5.951], [-2.654, -13.896], [-14.138, -0.304], [-20.224, 0.005], [-32.144, -0.233], [0.088, 6.105], [-0.072, 18.947], [-0.471, 2.707]],
                            "o": [[3.839, 1.88], [16.869, 3.973], [4.392, -15.764], [-9.121, -2.597], [-9.495, 5.752], [-0.183, -4.039], [-0.02, -16.392], [0.079, -5.522], [-19.369, 0.242], [-2.333, 0.009], [-4.888, 0.678], [2.823, 4.597], [2.51, 15.256], [-13.759, 6.634], [-10.606, -12.528], [3.936, -8.657], [-20.857, -0.346], [-4.883, -0.042], [0.088, 17.668], [-0.019, 4.25], [-1.292, 8.835], [-6.972, -3.698], [-12.261, 0.702], [-4.316, 10.854], [10.081, 11.578], [9.375, -4.81], [0.304, 3.173], [0.06, 5.961], [0.587, 13.956], [14.048, 3.22], [20.214, 0.435], [32.146, 0], [6.17, 0.045], [-0.273, -18.942], [0.011, -2.759], [1.38, -7.931]],
                            "v": [[116.408, 23.023], [128.266, 27.671], [165.932, 7.37], [146.039, -28.976], [119.437, -26.126], [103.883, -35.307], [103.707, -47.438], [103.778, -96.613], [96.341, -104.094], [38.227, -103.893], [31.232, -103.376], [27.253, -95.649], [32.424, -80.643], [14.257, -44.531], [-25.981, -52.515], [-29.898, -93.203], [-36.269, -103.718], [-98.852, -104.059], [-105.012, -97.307], [-105.032, -44.299], [-105.699, -31.562], [-118.318, -25.059], [-140.414, -30.144], [-166.008, -12.126], [-161.074, 18.344], [-119.568, 23.866], [-105.386, 31.613], [-105.024, 41.182], [-104.945, 59.062], [-103.795, 100.943], [-61.375, 102.244], [-0.706, 102.351], [95.731, 102.459], [103.805, 94.314], [103.802, 37.477], [104.354, 29.21]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.496470582251, 0.887446265127, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [170.574, 104.413], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 460.000018736184,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 8,
            "ty": 4,
            "nm": "a22 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1629.504, 2123.104, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.377, 135.452, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[1.126, 8.91], [7.441, -3.668], [5.774, -0.582], [2.747, 18.206], [-17.24, 3.667], [-8.805, -4.473], [-1.018, 6.557], [-0.008, 2.116], [-0.172, 19.377], [4.707, -0.046], [14.48, 0.104], [7.61, 1.303], [-4.243, 7.831], [-0.468, 6.048], [15.993, 1.183], [0.893, -17.567], [-3.746, -6.692], [7.994, -1.46], [2.968, -0.03], [9.157, 0], [0, 0], [10.435, 0.031], [-0.062, -4.493], [-1.94, -21.889], [-5.878, 3.107], [-8.065, -0.377], [-4.662, -12.807], [10.042, -9.209], [16.215, 7.701], [0.622, -7.425], [0.403, -21.494], [-4.004, 0.003], [-65.162, -0.093], [0.079, 4.907], [0.102, 11.924]],
                            "o": [[-1.069, -8.456], [-5.231, 2.579], [-18.075, 1.822], [-2.533, -16.782], [9.838, -2.092], [6.06, 3.079], [0.326, -2.101], [0.073, -19.378], [0.045, -5.15], [-14.479, 0.142], [-7.653, -0.055], [-8.917, -1.527], [2.895, -5.343], [1.283, -16.575], [-17.782, -1.316], [-0.389, 7.655], [3.946, 7.049], [-2.914, 0.533], [-9.156, 0.094], [0, 0], [-10.435, 0], [-3.496, -0.01], [0.303, 21.919], [0.597, 6.739], [7.145, -3.777], [13.602, 0.636], [4.511, 12.393], [-11.01, 10.096], [-6.838, -3.247], [-1.8, 21.469], [-0.088, 4.663], [65.162, -0.042], [4.982, 0.008], [-0.191, -11.922], [-0.077, -8.936]],
                            "v": [[104.001, 65.803], [94.523, 60.445], [78.019, 65.101], [41.233, 36.155], [67.64, -0.609], [95.429, 3.922], [103.794, -0.256], [104.487, -6.6], [104.64, -64.732], [97.596, -71.286], [54.155, -71.274], [31.201, -71.977], [24.764, -84.626], [30.024, -101.557], [3.26, -133.885], [-29.371, -105.536], [-23.982, -84.171], [-29.84, -72.074], [-38.728, -71.316], [-66.199, -71.282], [-66.199, -71.213], [-97.503, -71.223], [-104.033, -66.251], [-103.186, -0.497], [-95.105, 3.932], [-72.362, -1.309], [-42.285, 20.848], [-51.393, 56.418], [-94.376, 60.199], [-103.257, 65.007], [-104.087, 129.489], [-97.57, 135.161], [97.918, 135.194], [104.654, 128.381], [104.57, 92.607]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.496470582251, 0.887446265127, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.376, 135.452], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 460.000018736184,
            "st": 0,
            "bm": 0
        }]
    }, {
        "id": "comp_10",
        "nm": "Group 2",
        "fr": 29.9700012207031,
        "layers": [{
            "ddd": 0,
            "ind": 1,
            "ty": 5,
            "nm": "Class",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [461.876, 2168.414, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [0.107, -14.805, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Class",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 2,
            "ty": 5,
            "nm": "Key",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [461.876, 1935.268, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [1.24, -9.951, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Key",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 3,
            "ty": 5,
            "nm": "Object",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [461.876, 1706.486, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [0.459, -10.732, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Object",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 4,
            "ty": 5,
            "nm": "S3",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [461.876, 1469, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.303, -14.219, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "S3",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 5,
            "ty": 4,
            "nm": "a13 Outlines 2",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [466.282, 1472.191, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.128, 167.783, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-5.817, 0.117], [-12.35, 0.055], [-9.327, -1.023], [4.238, -7.876], [0.827, -5.313], [-18.053, -1.541], [-0.328, 17.124], [3.614, 6.329], [-9.029, 1.087], [-1.913, 0.02], [-19.799, -0.026], [0.194, 5.846], [0.147, 9.367], [1.567, 11.449], [6.49, -3.316], [6.226, -0.252], [6.968, 12.556], [-8.087, 11.209], [-18.252, -8.823], [-0.667, 8.051], [-0.286, 21.495], [3.699, -0.004], [14.053, 0.142], [8.238, 1.487], [-3.808, 7.056], [-0.426, 6.274], [10.565, 6.164], [10.448, -6.657], [-0.913, -11.808], [-2.962, -5.529], [7.098, -1.224], [4.24, -0.033], [17.035, -0.019], [0.002, -10.761], [-0.006, -30.664], [0.176, -31.727]],
                            "o": [[12.346, -0.249], [9.372, -0.041], [9.077, 0.996], [-2.56, 4.76], [-2.705, 17.377], [16.538, 1.411], [0.138, -7.189], [-4.454, -7.798], [1.9, -0.229], [19.799, -0.207], [5.735, 0.007], [-0.31, -9.359], [-0.179, -11.486], [-0.965, -7.045], [-5.58, 2.851], [-14.163, 0.574], [-6.735, -12.136], [10.288, -14.26], [7.466, 3.609], [1.778, -21.468], [0.065, -4.853], [-14.054, 0.013], [-8.291, -0.084], [-7.99, -1.441], [2.984, -5.529], [0.825, -12.118], [-10.609, -6.189], [-10.109, 6.442], [0.485, 6.283], [3.47, 6.478], [-4.175, 0.72], [-17.034, 0.134], [-11.083, 0.013], [-0.006, 30.664], [0, 31.728], [-0.031, 5.764]],
                            "v": [[-97.037, 103.069], [-59.987, 102.977], [-31.913, 103.897], [-24.91, 116.686], [-29.95, 131.738], [-2.087, 166.122], [29.12, 136.969], [24.166, 116.792], [30.991, 103.92], [36.726, 103.547], [96.124, 103.061], [103.991, 95.179], [103.882, 67.075], [103.118, 32.622], [94.481, 28.276], [76.826, 33.434], [44.403, 15.961], [46.802, -19.499], [93.994, -28.267], [103.1, -33.065], [103.86, -97.546], [96.904, -102.822], [54.742, -102.879], [29.88, -103.775], [23.819, -115.802], [29.289, -133.331], [15.173, -161.344], [-16.878, -160.775], [-30.063, -132.912], [-24.425, -115.437], [-29.864, -104.007], [-42.566, -102.914], [-93.671, -102.817], [-104.767, -92.039], [-104.763, -0.048], [-104.847, 95.136]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.823529411765, 0.447058823529, 0.576470588235, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.128, 167.783], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 6,
            "ty": 4,
            "nm": "a13 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [466.282, 1931.941, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.128, 167.783, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-5.817, 0.117], [-12.35, 0.055], [-9.327, -1.023], [4.238, -7.876], [0.827, -5.313], [-18.053, -1.541], [-0.328, 17.124], [3.614, 6.329], [-9.029, 1.087], [-1.913, 0.02], [-19.799, -0.026], [0.194, 5.846], [0.147, 9.367], [1.567, 11.449], [6.49, -3.316], [6.226, -0.252], [6.968, 12.556], [-8.087, 11.209], [-18.252, -8.823], [-0.667, 8.051], [-0.286, 21.495], [3.699, -0.004], [14.053, 0.142], [8.238, 1.487], [-3.808, 7.056], [-0.426, 6.274], [10.565, 6.164], [10.448, -6.657], [-0.913, -11.808], [-2.962, -5.529], [7.098, -1.224], [4.24, -0.033], [17.035, -0.019], [0.002, -10.761], [-0.006, -30.664], [0.176, -31.727]],
                            "o": [[12.346, -0.249], [9.372, -0.041], [9.077, 0.996], [-2.56, 4.76], [-2.705, 17.377], [16.538, 1.411], [0.138, -7.189], [-4.454, -7.798], [1.9, -0.229], [19.799, -0.207], [5.735, 0.007], [-0.31, -9.359], [-0.179, -11.486], [-0.965, -7.045], [-5.58, 2.851], [-14.163, 0.574], [-6.735, -12.136], [10.288, -14.26], [7.466, 3.609], [1.778, -21.468], [0.065, -4.853], [-14.054, 0.013], [-8.291, -0.084], [-7.99, -1.441], [2.984, -5.529], [0.825, -12.118], [-10.609, -6.189], [-10.109, 6.442], [0.485, 6.283], [3.47, 6.478], [-4.175, 0.72], [-17.034, 0.134], [-11.083, 0.013], [-0.006, 30.664], [0, 31.728], [-0.031, 5.764]],
                            "v": [[-97.037, 103.069], [-59.987, 102.977], [-31.913, 103.897], [-24.91, 116.686], [-29.95, 131.738], [-2.087, 166.122], [29.12, 136.969], [24.166, 116.792], [30.991, 103.92], [36.726, 103.547], [96.124, 103.061], [103.991, 95.179], [103.882, 67.075], [103.118, 32.622], [94.481, 28.276], [76.826, 33.434], [44.403, 15.961], [46.802, -19.499], [93.994, -28.267], [103.1, -33.065], [103.86, -97.546], [96.904, -102.822], [54.742, -102.879], [29.88, -103.775], [23.819, -115.802], [29.289, -133.331], [15.173, -161.344], [-16.878, -160.775], [-30.063, -132.912], [-24.425, -115.437], [-29.864, -104.007], [-42.566, -102.914], [-93.671, -102.817], [-104.767, -92.039], [-104.763, -0.048], [-104.847, 95.136]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.823529411765, 0.447058823529, 0.576470588235, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.128, 167.783], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 7,
            "ty": 4,
            "nm": "a19 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [500.96, 2162.745, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [137.215, 103.514, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-7.148, -3.55], [-4.188, -0.953], [-7.305, 11.235], [7.279, 10.012], [15.26, -7.592], [0.641, 12.57], [0.009, 4.682], [-0.227, 15.748], [5.572, -0.068], [19.157, -0.073], [2.531, -0.308], [-2.981, -4.918], [-0.881, -5.069], [13.659, -6.649], [9.905, 10.877], [-8.032, 15.998], [6.512, 0.938], [3.822, 0.015], [17.241, -0.031], [0.002, -8.274], [-0.015, -63.007], [-8.261, -0.006], [-31.929, 0], [-31.929, 0.022], [-0.015, 8.42], [-0.077, 17.242], [-0.656, 4.179]],
                            "o": [[3.827, 1.9], [14.126, 3.214], [6.466, -9.943], [-8.636, -11.879], [-11.198, 5.571], [-0.238, -4.673], [-0.033, -15.752], [0.079, -5.486], [-19.155, 0.235], [-2.543, 0.01], [-4.993, 0.609], [2.673, 4.411], [2.704, 15.562], [-13.352, 6.5], [-10.153, -11.151], [2.987, -5.95], [-3.774, -0.544], [-17.242, -0.065], [-8.374, 0.014], [-0.016, 63.006], [0.002, 8.418], [31.929, 0.022], [31.929, 0], [8.273, -0.005], [0.03, -17.242], [0.019, -4.248], [1.246, -7.94]],
                            "v": [[84.509, 23.9], [96.348, 28.577], [130.499, 15.801], [129.13, -17.827], [87.45, -25.303], [72.005, -34.384], [71.794, -48.428], [71.836, -95.681], [64.429, -103.197], [6.958, -103.022], [-0.667, -102.388], [-4.636, -94.727], [0.455, -80.354], [-17.694, -43.629], [-57.551, -51.13], [-60.907, -94.066], [-65.058, -102.434], [-76.514, -103.083], [-128.24, -103.105], [-136.949, -94.501], [-136.947, 94.518], [-128.394, 103.242], [-32.607, 103.251], [63.179, 103.242], [71.731, 94.534], [71.788, 42.809], [72.484, 30.079]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.823529411765, 0.447058823529, 0.576470588235, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [137.215, 103.515], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 8,
            "ty": 4,
            "nm": "a7 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [501.823, 1702.475, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [137.647, 103.294, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-5.35, 0.056], [-19.8, 0.221], [4.848, 10.465], [-20.244, 5.644], [-9.287, -10.836], [6.384, -14.025], [-10.218, -0.124], [-20.438, -0.203], [0.05, 5.144], [-0.052, 17.673], [-0.467, 3.788], [-7.881, -4.155], [-5.535, -0.742], [-3.403, 14.19], [14.25, 5.245], [8.582, -5.005], [0.349, 10.746], [0.006, 4.258], [-0.21, 15.754], [5.518, -0.059], [20.438, -0.252], [-4.554, -9.325], [-0.65, -4.222], [15.588, -5.486], [8.11, 14.629], [-6.137, 12.08], [6.961, 0.197], [10.857, 0], [0, 0.115], [10.43, 0.204], [-0.01, -5.517], [0.134, -63.665]],
                            "o": [[19.8, -0.206], [11.798, -0.132], [-9.496, -20.497], [13.811, -3.851], [10.485, 12.233], [-4.108, 9.025], [20.437, 0.25], [5.275, 0.052], [-0.168, -17.671], [0.011, -3.828], [1.106, -8.965], [4.974, 2.623], [15.114, 2.026], [3.611, -15.059], [-9.545, -3.512], [-12.632, 7.367], [-0.138, -4.255], [-0.021, -15.757], [0.072, -5.461], [-20.438, 0.221], [-10.175, 0.125], [1.89, 3.87], [2.596, 16.863], [-15.599, 5.49], [-6.796, -12.259], [3.149, -6.198], [-10.848, -0.307], [0, -0.115], [-10.433, 0], [-5.451, -0.107], [0.113, 63.664], [-0.012, 5.677]],
                            "v": [[-129.786, 102.987], [-70.382, 102.747], [-62.82, 90.971], [-42.671, 41.647], [-7.387, 51.945], [-3.647, 92.086], [3.077, 102.697], [64.396, 102.984], [71.457, 95.714], [71.433, 42.695], [71.899, 31.219], [84.887, 24.244], [100.576, 29.378], [133.785, 7.519], [115.495, -27.644], [87.694, -25.477], [71.563, -35.281], [71.396, -48.053], [71.456, -95.323], [63.996, -102.938], [2.678, -102.622], [-3.54, -91.909], [0.219, -79.75], [-21.66, -42.201], [-62.312, -57.451], [-61.223, -94.125], [-65.979, -102.451], [-98.548, -102.531], [-98.548, -102.878], [-129.847, -102.936], [-137.372, -95.38], [-137.385, 95.615]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.823529411765, 0.447058823529, 0.576470588235, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [137.647, 103.294], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 461.000018776915,
            "st": 0,
            "bm": 0
        }]
    }, {
        "id": "comp_11",
        "nm": "Group 1",
        "fr": 29.9700012207031,
        "layers": [{
            "ddd": 0,
            "ind": 1,
            "ty": 5,
            "nm": "Subnet",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1141.168, 2095.055, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [0.293, -14.805, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "Subnet",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 35,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 2,
            "ty": 5,
            "nm": "CIDR",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1140.025, 1933.445, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [0.525, -17.773, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "CIDR",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 3,
            "ty": 5,
            "nm": "DCHP",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [904.667, 2169, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.708, -17.773, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "DCHP",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 4,
            "ty": 5,
            "nm": "IGW",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [904.042, 1933.445, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.708, -17.773, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "IGW",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 5,
            "ty": 5,
            "nm": "NAT",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [671.667, 2169, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.708, -17.773, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "NAT",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 6,
            "ty": 5,
            "nm": "VPC",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [671.292, 1933.445, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [-0.708, -17.773, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [{
                        "s": {
                            "s": 40,
                            "f": "Roboto-Bold",
                            "t": "VPC",
                            "ca": 0,
                            "j": 2,
                            "tr": 0,
                            "lh": 48,
                            "ls": 0,
                            "fc": [0, 0, 0]
                        }, "t": 0
                    }]
                }, "p": {}, "m": {"g": 1, "a": {"a": 0, "k": [0, 0], "ix": 2}}, "a": []
            },
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 7,
            "ty": 4,
            "nm": "a20 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [672.872, 2132.347, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.123, 135.914, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[0.351, 3.382], [7.669, -3.893], [6.198, -0.421], [5.329, 13.405], [-11.348, 9.175], [-14.347, -6.643], [-0.671, 8.352], [-0.554, 20.631], [5.698, -0.073], [18.732, 0.081], [3.521, 0.687], [-3.111, 6.585], [-1.011, 3.433], [9.071, 8.948], [11.669, -3.928], [-8.707, -18.395], [14.241, -0.528], [4.257, -0.005], [15.962, 0.231], [-0.073, -5.502], [-0.08, -17.88], [-0.383, -2.949], [-6.686, 3.298], [-6.948, 0.095], [-1.801, -17], [17.528, -3.598], [8.665, 4.686], [0.5, -5.45], [0.021, -3.818], [-0.027, -17.242], [-8.551, -0.005], [-31.718, 0.001], [-32.143, 0.026], [-0.014, 8.047], [0.069, 16.816]],
                            "o": [[-0.917, -8.833], [-5.617, 2.852], [-14.226, 0.966], [-5.29, -13.303], [13.002, -10.512], [7.682, 3.557], [1.656, -20.613], [0.16, -5.954], [-18.729, 0.24], [-3.602, -0.015], [-7.209, -1.406], [1.543, -3.264], [3.494, -11.872], [-8.848, -8.728], [-17.457, 5.875], [5.961, 12.596], [-4.253, 0.158], [-15.965, 0.017], [-5.554, -0.081], [0.235, 17.877], [0.014, 2.969], [0.988, 7.604], [6.189, -3.052], [17.618, -0.241], [1.842, 17.383], [-9.869, 2.025], [-4.613, -2.495], [-0.349, 3.811], [-0.097, 17.242], [0.013, 8.208], [31.717, 0.018], [32.142, 0], [7.963, -0.007], [0.028, -16.816], [-0.014, -3.398]],
                            "v": [[103.329, 66.641], [93.63, 61.033], [75.846, 65.719], [42.593, 44.447], [52.441, 6.969], [93.852, 3.871], [103.217, -1.278], [104.069, -63.187], [96.138, -70.864], [39.944, -70.809], [29.157, -71.691], [23.506, -83.134], [27.858, -93.042], [20.741, -124.935], [-10.579, -131.736], [-26.459, -87.153], [-36.702, -70.876], [-49.473, -70.734], [-97.367, -70.801], [-104.8, -63.304], [-104.638, -9.664], [-103.931, -0.763], [-95.147, 4.132], [-75.527, -0.913], [-41.178, 28.733], [-68.288, 65.016], [-95.972, 60.115], [-103.792, 64.017], [-104.627, 75.466], [-104.679, 127.192], [-95.858, 135.643], [-0.706, 135.649], [95.721, 135.638], [103.988, 127.279], [103.95, 76.83]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.043137254902, 0.788235353956, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.123, 135.914], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 8,
            "ty": 4,
            "nm": "a21 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [906.32, 2168.893, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [170.574, 104.413, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-7.201, -3.527], [-4.172, -0.983], [-4.28, 15.366], [15.629, 4.449], [8.183, -4.957], [0.603, 13.285], [0.005, 4.044], [-0.236, 16.389], [5.541, -0.069], [19.371, -0.072], [2.312, -0.32], [-3.02, -4.916], [-0.87, -5.285], [13.417, -6.469], [9.741, 11.508], [-6.487, 14.267], [9.638, 0.16], [20.86, 0.179], [-0.022, -4.369], [0.078, -17.669], [0.613, -4.19], [7.836, 4.158], [7.856, -0.45], [4.485, -11.28], [-7.893, -9.065], [-15.701, 8.056], [-1.007, -10.517], [-0.032, -3.191], [-0.25, -5.951], [-2.654, -13.896], [-14.138, -0.304], [-20.224, 0.005], [-32.144, -0.233], [0.088, 6.105], [-0.072, 18.947], [-0.471, 2.707]],
                            "o": [[3.839, 1.88], [16.869, 3.973], [4.392, -15.764], [-9.121, -2.597], [-9.495, 5.752], [-0.183, -4.039], [-0.02, -16.392], [0.079, -5.522], [-19.369, 0.242], [-2.333, 0.009], [-4.888, 0.678], [2.823, 4.597], [2.51, 15.256], [-13.759, 6.634], [-10.606, -12.528], [3.936, -8.657], [-20.857, -0.346], [-4.883, -0.042], [0.088, 17.668], [-0.019, 4.25], [-1.292, 8.835], [-6.972, -3.698], [-12.261, 0.702], [-4.316, 10.854], [10.081, 11.578], [9.375, -4.81], [0.304, 3.173], [0.06, 5.961], [0.587, 13.956], [14.048, 3.22], [20.214, 0.435], [32.146, 0], [6.17, 0.045], [-0.273, -18.942], [0.011, -2.759], [1.38, -7.931]],
                            "v": [[116.408, 23.023], [128.266, 27.671], [165.932, 7.37], [146.039, -28.976], [119.437, -26.126], [103.883, -35.307], [103.707, -47.438], [103.778, -96.613], [96.341, -104.094], [38.227, -103.893], [31.232, -103.376], [27.253, -95.649], [32.424, -80.643], [14.257, -44.531], [-25.981, -52.515], [-29.898, -93.203], [-36.269, -103.718], [-98.852, -104.059], [-105.012, -97.307], [-105.032, -44.299], [-105.699, -31.562], [-118.318, -25.059], [-140.414, -30.144], [-166.008, -12.126], [-161.074, 18.344], [-119.568, 23.866], [-105.386, 31.613], [-105.024, 41.182], [-104.945, 59.062], [-103.795, 100.943], [-61.375, 102.244], [-0.706, 102.351], [95.731, 102.459], [103.805, 94.314], [103.802, 37.477], [104.354, 29.21]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.043137254902, 0.788235353956, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [170.574, 104.413], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 9,
            "ty": 4,
            "nm": "a22 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1139.504, 2133.104, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.377, 135.452, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[1.126, 8.91], [7.441, -3.668], [5.774, -0.582], [2.747, 18.206], [-17.24, 3.667], [-8.805, -4.473], [-1.018, 6.557], [-0.008, 2.116], [-0.172, 19.377], [4.707, -0.046], [14.48, 0.104], [7.61, 1.303], [-4.243, 7.831], [-0.468, 6.048], [15.993, 1.183], [0.893, -17.567], [-3.746, -6.692], [7.994, -1.46], [2.968, -0.03], [9.157, 0], [0, 0], [10.435, 0.031], [-0.062, -4.493], [-1.94, -21.889], [-5.878, 3.107], [-8.065, -0.377], [-4.662, -12.807], [10.042, -9.209], [16.215, 7.701], [0.622, -7.425], [0.403, -21.494], [-4.004, 0.003], [-65.162, -0.093], [0.079, 4.907], [0.102, 11.924]],
                            "o": [[-1.069, -8.456], [-5.231, 2.579], [-18.075, 1.822], [-2.533, -16.782], [9.838, -2.092], [6.06, 3.079], [0.326, -2.101], [0.073, -19.378], [0.045, -5.15], [-14.479, 0.142], [-7.653, -0.055], [-8.917, -1.527], [2.895, -5.343], [1.283, -16.575], [-17.782, -1.316], [-0.389, 7.655], [3.946, 7.049], [-2.914, 0.533], [-9.156, 0.094], [0, 0], [-10.435, 0], [-3.496, -0.01], [0.303, 21.919], [0.597, 6.739], [7.145, -3.777], [13.602, 0.636], [4.511, 12.393], [-11.01, 10.096], [-6.838, -3.247], [-1.8, 21.469], [-0.088, 4.663], [65.162, -0.042], [4.982, 0.008], [-0.191, -11.922], [-0.077, -8.936]],
                            "v": [[104.001, 65.803], [94.523, 60.445], [78.019, 65.101], [41.233, 36.155], [67.64, -0.609], [95.429, 3.922], [103.794, -0.256], [104.487, -6.6], [104.64, -64.732], [97.596, -71.286], [54.155, -71.274], [31.201, -71.977], [24.764, -84.626], [30.024, -101.557], [3.26, -133.885], [-29.371, -105.536], [-23.982, -84.171], [-29.84, -72.074], [-38.728, -71.316], [-66.199, -71.282], [-66.199, -71.213], [-97.503, -71.223], [-104.033, -66.251], [-103.186, -0.497], [-95.105, 3.932], [-72.362, -1.309], [-42.285, 20.848], [-51.393, 56.418], [-94.376, 60.199], [-103.257, 65.007], [-104.087, 129.489], [-97.57, 135.161], [97.918, 135.194], [104.654, 128.381], [104.57, 92.607]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.043137254902, 0.788235353956, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.376, 135.452], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 10,
            "ty": 4,
            "nm": "a16 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [1138.472, 1938.269, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [169.667, 103.299, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-13.823, 7.193], [-10.473, -11.934], [7.324, -14.669], [-8.642, -0.207], [-10.433, 0], [-0.001, -0.085], [-8.305, 0.001], [-0.041, 13.42], [-0.49, 18.728], [-9.564, -4.882], [-7.187, 0.318], [-1.107, 14.256], [15.221, 3.388], [8.153, -4.197], [0.913, 9.665], [0.018, 5.108], [-0.249, 15.968], [5.934, -0.081], [19.376, -0.18], [-4.809, -11.712], [10.395, -11.517], [13.543, 3.957], [-10.722, 21.676], [8.317, 0.131], [21.294, 0.147], [-0.018, -4.313], [0.055, -18.527], [0.413, -3.153], [7.962, 4.349], [5.734, 0.729], [2.915, -14.239], [-15.598, -4.268], [-7.757, 4.559], [-0.427, -11.911], [-0.004, -4.046], [0.231, -15.755], [-5.987, 0.078], [-20.23, 0.084], [-1.683, 0.23], [2.11, 4.011], [1.068, 4.393]],
                            "o": [[14.154, -7.365], [9.413, 10.725], [-3.812, 7.633], [10.427, 0.25], [0, 0.085], [8.305, 0], [13.663, -0.002], [0.056, -18.739], [0.287, -10.962], [6.408, 3.271], [14.838, -0.657], [1.238, -15.944], [-9.254, -2.059], [-8.524, 4.388], [-0.479, -5.076], [-0.055, -15.971], [0.088, -5.695], [-19.375, 0.265], [-12.981, 0.121], [5.681, 13.836], [-9.363, 10.374], [-21.114, -6.169], [3.695, -7.471], [-21.29, -0.335], [-4.9, -0.034], [0.078, 18.526], [-0.01, 3.19], [-1.171, 8.923], [-5.154, -2.814], [-14.954, -1.902], [-3.326, 16.243], [8.84, 2.419], [11.811, -6.943], [0.145, 4.042], [0.016, 15.758], [-0.082, 5.596], [20.227, -0.263], [1.7, -0.007], [4.11, -0.561], [-2.084, -3.963], [-3.906, -16.063]],
                            "v": [[-15.042, 44.178], [26.26, 51.842], [29.663, 93.217], [35.258, 102.588], [66.556, 102.646], [66.557, 102.902], [91.472, 102.902], [105.145, 89.479], [105.507, 33.266], [119.728, 24.856], [140.01, 29.585], [168.179, 3.187], [144.977, -28.782], [119.104, -24.387], [105.588, -31.773], [105.13, -47.09], [105.187, -95.004], [97.496, -102.968], [39.363, -102.752], [30.96, -90.177], [25.807, -51.318], [-9.121, -41.692], [-28.101, -92.846], [-33.659, -102.559], [-97.54, -102.896], [-103.598, -96], [-103.635, -40.421], [-104.054, -30.857], [-117.117, -24.257], [-133.477, -29.352], [-166.091, -6.753], [-145.074, 28.454], [-119.702, 25.476], [-103.703, 35.443], [-103.566, 47.58], [-103.635, 94.855], [-96.017, 102.971], [-35.329, 102.691], [-30.232, 102.368], [-26.627, 95.775], [-31.749, 83.417]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.043137254902, 0.788235353956, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [169.667, 103.3], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 11,
            "ty": 4,
            "nm": "a15 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [905.601, 1938.315, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [105.453, 167.925, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[2.037, 21.889], [5.117, -2.713], [6.678, -0.538], [5.949, 11.768], [-9.353, 10.487], [-17.03, -8.256], [-0.687, 8.048], [-0.604, 20.639], [5.663, -0.069], [17.889, 0.113], [4.356, 0.842], [-3.485, 6.527], [-0.536, 6.702], [15.675, 1.628], [1.866, -15.731], [-4.291, -7.721], [7.603, -1.406], [4.239, -0.029], [17.887, 0.237], [-0.217, -6.29], [-0.103, -10.86], [-1.294, -9.745], [-6.676, 3.467], [-7.829, -0.298], [-2.521, -15.919], [15.14, -5.277], [10.13, 5.04], [1.182, -7.969], [0.005, -1.481], [0.121, -19.593], [-4.405, 0.034], [-10.649, 0], [-11.252, -1.142], [4.528, -8.153], [-0.179, -7.205], [-15.266, -2.402], [-4.586, 13.457], [5.03, 9.374], [-8.613, 0.808], [-7.446, 0.08], [-14.695, 0.003], [0.068, 4.759]],
                            "o": [[-0.542, -5.823], [-5.935, 3.147], [-13.409, 1.081], [-6.327, -12.518], [10.626, -11.913], [7.17, 3.476], [1.758, -20.621], [0.175, -5.966], [-17.887, 0.219], [-4.45, -0.028], [-7.284, -1.406], [3.167, -5.93], [1.237, -15.489], [-16.328, -1.697], [-1.041, 8.78], [3.773, 6.789], [-4.159, 0.77], [-17.889, 0.12], [-5.936, -0.078], [0.374, 10.848], [0.092, 9.787], [1.023, 7.703], [6.983, -3.628], [16.042, 0.61], [2.471, 15.601], [-10.95, 3.816], [-7.095, -3.531], [-0.218, 1.472], [-0.069, 19.593], [-0.029, 4.746], [10.648, -0.082], [11.285, 0.021], [9.453, 0.959], [-3.529, 6.353], [0.376, 15.061], [13.664, 2.151], [3.55, -10.416], [-4.115, -7.669], [7.408, -0.695], [14.694, -0.158], [3.745, 0], [-0.311, -21.922]],
                            "v": [[103.167, 31.429], [95.683, 27.357], [76.866, 33.025], [44.122, 14.941], [49.055, -22.562], [94.372, -28.555], [103.332, -33.654], [104.232, -95.589], [96.31, -103.322], [42.642, -103.269], [29.315, -104.397], [23.846, -115.806], [29.62, -134.569], [3.196, -165.978], [-29.609, -140.64], [-24.399, -116.104], [-30.001, -104.316], [-42.699, -103.249], [-96.367, -103.264], [-104.638, -95.217], [-104.536, -62.637], [-103.91, -33.284], [-95.065, -28.462], [-72.882, -33.382], [-41.203, -5.194], [-63.174, 31.065], [-94.687, 28.077], [-103.93, 33.05], [-104.42, 37.489], [-104.588, 96.268], [-97.866, 102.616], [-65.92, 102.589], [-32.088, 103.468], [-24.871, 116.549], [-29.734, 136.753], [-4.083, 165.524], [28.025, 145.706], [24.241, 116.238], [30.761, 103.674], [53.086, 102.688], [97.171, 102.598], [104.085, 97.191]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.043137254902, 0.788235353956, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [105.454, 167.925], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 12,
            "ty": 4,
            "nm": "a14 Outlines",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [672.601, 1937.277, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [169.936, 103.308, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[-0.707, 3.733], [-6.485, -3.346], [-5.517, -0.874], [-2.35, 15.48], [17.36, 2.805], [7.341, -3.899], [0.926, 10.056], [0.019, 5.322], [-0.266, 15.756], [5.759, -0.072], [19.378, -0.183], [-4.938, -11.793], [18.82, -7.011], [9.044, 10.006], [-7.09, 14.535], [9.667, 0.117], [20.443, 0.238], [-0.057, -5.518], [0.073, -18.315], [0.503, -3.351], [7.323, 3.814], [5.767, 0.761], [2.172, -15.408], [-16.805, -2.493], [-7.403, 3.746], [-1.077, -10.068], [-0.009, -3.405], [0.279, -17.459], [-5.982, 0.08], [-18.316, 0.051], [-3.181, 0.263], [2.505, 4.682], [0.982, 3.015], [-15.104, 8.344], [-10.107, -12.904], [7.047, -14.032], [-7.298, -0.201], [-10.86, 0], [0, -0.1], [-9.797, 0.042], [-0.007, 8.408], [-0.084, 17.676]],
                            "o": [[1.364, -7.195], [4.981, 2.569], [16.639, 2.633], [2.658, -17.506], [-8.255, -1.334], [-8.976, 4.767], [-0.487, -5.287], [-0.055, -15.759], [0.099, -5.868], [-19.377, 0.244], [-12.867, 0.121], [8.481, 20.251], [-12.985, 4.838], [-9.73, -10.766], [4.194, -8.598], [-20.442, -0.248], [-5.506, -0.064], [0.186, 18.313], [-0.013, 3.401], [-1.24, 8.258], [-5.157, -2.686], [-16.093, -2.124], [-2.409, 17.089], [8.297, 1.231], [9.096, -4.602], [0.361, 3.377], [0.044, 17.463], [-0.099, 6.2], [18.313, -0.243], [3.191, -0.009], [4.787, -0.397], [-1.501, -2.805], [-5.636, -17.31], [13.793, -7.62], [10.099, 12.893], [-3.326, 6.621], [10.851, 0.299], [0, 0.101], [9.797, 0], [8.629, -0.036], [0.015, -17.677], [0.018, -3.818]],
                            "v": [[105.173, 29.425], [116.616, 23.764], [132.195, 29.252], [167.028, 5.642], [142.047, -29.183], [118.632, -24.638], [104.684, -31.927], [104.301, -47.886], [104.338, -95.164], [96.491, -102.986], [38.352, -102.767], [30.069, -90.143], [11.931, -42.314], [-25.024, -50.985], [-29.329, -92.238], [-35.666, -102.672], [-96.999, -102.97], [-104.49, -95.464], [-104.508, -40.518], [-105.054, -30.324], [-117.403, -23.91], [-133.656, -29.382], [-167.277, -4.898], [-142.274, 29.274], [-118.825, 24.748], [-104.847, 32.232], [-104.505, 42.442], [-104.551, 94.831], [-96.285, 102.978], [-41.339, 102.834], [-31.767, 102.424], [-27.724, 95.217], [-31.622, 86.489], [-15.906, 44.168], [26.155, 52.956], [28.36, 93.782], [33.171, 102.486], [65.748, 102.563], [65.748, 102.865], [95.138, 102.855], [104.287, 93.891], [104.334, 40.861]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.043137254902, 0.788235353956, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [169.936, 103.308], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }],
            "ip": 0,
            "op": 463.000018858377,
            "st": 0,
            "bm": 0
        }]
    }],
    "fonts": {"list": [{"fName": "Roboto-Bold", "fFamily": "Roboto", "fStyle": "Bold", "ascent": 75}]},
    "layers": [{
        "ddd": 0,
        "ind": 1,
        "ty": 2,
        "nm": "Logo.ai",
        "cl": "ai",
        "refId": "image_0",
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 35, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {"a": 0, "k": [1280, 256, 0], "ix": 2, "l": 2},
            "a": {"a": 0, "k": [424.5, 106, 0], "ix": 1, "l": 2},
            "s": {"a": 0, "k": [130.189, 130.189, 100], "ix": 6, "l": 2}
        },
        "ao": 0,
        "ip": 0,
        "op": 610.000024845809,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 2,
        "ty": 0,
        "nm": "Puzzles",
        "refId": "comp_0",
        "sr": 1.49085608269282,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {"a": 0, "k": [1280, 1440, 0], "ix": 2, "l": 2},
            "a": {"a": 0, "k": [1280, 1440, 0], "ix": 1, "l": 2},
            "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
        },
        "ao": 0,
        "hasMask": true,
        "masksProperties": [{
            "inv": false,
            "mode": "a",
            "pt": {
                "a": 0,
                "k": {
                    "i": [[0, 0], [0, 0], [0, 0], [0, 0]],
                    "o": [[0, 0], [0, 0], [0, 0], [0, 0]],
                    "v": [[2244, 484], [280, 484], [280, 2328], [2244, 2328]],
                    "c": true
                },
                "ix": 1
            },
            "o": {"a": 0, "k": 100, "ix": 3},
            "x": {"a": 0, "k": 0, "ix": 4},
            "nm": "Mask 1"
        }],
        "w": 2560,
        "h": 2880,
        "ip": 0,
        "op": 670.885264537484,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 3,
        "ty": 4,
        "nm": "Shape Layer 2",
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {"a": 0, "k": [1280, 2349.75, 0], "ix": 2, "l": 2},
            "a": {"a": 0, "k": [-0.499, 909.75, 0], "ix": 1, "l": 2},
            "s": {"a": 0, "k": [101.066, 100.76, 100], "ix": 6, "l": 2}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 0,
                    "k": {
                        "i": [[0, 0], [0, 0], [0, -61.5], [0, 0], [-84.5, 0], [0, 0]],
                        "o": [[0, 0], [0, 0], [0, 61.5], [0, 0], [84.5, 0], [0, 0]],
                        "v": [[938, 844], [-936, 844], [-939, 908.5], [-868, 975.5], [855, 975.5], [938, 912.5]],
                        "c": true
                    },
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [1, 1, 1, 1], "ix": 4},
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [0, 0], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Shape 1",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 607.000024723617,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 4,
        "ty": 4,
        "nm": "Shape Layer 1",
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {"a": 0, "k": [1449.723, 1347.02, 0], "ix": 2, "l": 2},
            "a": {"a": 0, "k": [0, 0, 0], "ix": 1, "l": 2},
            "s": {"a": 0, "k": [87.058, 86.275, 100], "ix": 6, "l": 2}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ty": "rc",
                "d": 1,
                "s": {"a": 0, "k": [2177, 2233], "ix": 2},
                "p": {"a": 0, "k": [0, 0], "ix": 3},
                "r": {"a": 0, "k": 83, "ix": 4},
                "nm": "Rectangle Path 1",
                "mn": "ADBE Vector Shape - Rect",
                "hd": false
            }, {
                "ty": "st",
                "c": {"a": 0, "k": [1, 1, 1, 1], "ix": 3},
                "o": {"a": 0, "k": 100, "ix": 4},
                "w": {"a": 0, "k": 4, "ix": 5},
                "lc": 1,
                "lj": 1,
                "ml": 4,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [-194.955, 107.773], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Rectangle 1",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 610.000024845809,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 5,
        "ty": 4,
        "nm": "Shape Layer 5",
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {"a": 0, "k": [1280, 1440, 0], "ix": 2, "l": 2},
            "a": {"a": 0, "k": [0, 0, 0], "ix": 1, "l": 2},
            "s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ty": "rc",
                "d": 1,
                "s": {"a": 0, "k": [2560, 2880], "ix": 2},
                "p": {"a": 0, "k": [0, 0], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 4},
                "nm": "Rectangle Path 1",
                "mn": "ADBE Vector Shape - Rect",
                "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0.065467064053, 0.068664618099, 0.129411645029, 1], "ix": 4},
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [0, 0], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Rectangle 1",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 611.00002488654,
        "st": 0,
        "bm": 0
    }],
    "markers": [],
    "chars": [{
        "ch": "V",
        "size": 40,
        "style": "Bold",
        "w": 65.38,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[16.602, -71.094], [0.342, -71.094], [25, 0], [40.283, 0], [65.039, -71.094], [48.73, -71.094], [32.617, -17.627]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "V",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "V",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "P",
        "size": 40,
        "style": "Bold",
        "w": 64.5,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [-4.769, 4.021], [0, 6.966], [2.18, 3.597], [4.053, 1.953], [5.338, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[8.43, 0], [4.768, -4.02], [0, -4.59], [-2.181, -3.596], [-4.053, -1.953], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[33.838, -25.049], [53.638, -31.079], [60.791, -47.559], [57.52, -59.839], [48.169, -68.164], [34.082, -71.094], [6.348, -71.094], [6.348, 0], [20.996, 0], [20.996, -25.049]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "P",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [-2.051, -2.148], [0, -3.483], [2.034, -1.823], [3.873, 0], [0, 0]],
                            "o": [[0, 0], [3.613, 0.066], [2.051, 2.148], [0, 3.386], [-2.035, 1.823], [0, 0], [0, 0]],
                            "v": [[20.996, -59.229], [34.424, -59.229], [42.92, -55.908], [45.996, -47.461], [42.944, -39.648], [34.082, -36.914], [20.996, -36.914]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "P",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "P",
                "np": 5,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "C", "size": 40, "style": "Bold", "w": 65.43, "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [2.229, -2.067], [4.524, 0], [2.327, 3.548], [0, 7.683], [0, 0], [-2.425, 3.5], [-4.883, 0], [-2.197, -2.067], [-0.359, -4.59], [0, 0], [5.013, 4.395], [8.203, 0], [4.475, -2.783], [2.409, -5.208], [0, -6.836], [0, 0], [-5.225, -6.136], [-9.115, 0], [-5.095, 4.395], [-0.554, 7.65]],
                            "o": [[-0.326, 4.33], [-2.23, 2.068], [-5.013, 0], [-2.328, -3.548], [0, 0], [0.065, -7.356], [2.425, -3.499], [4.492, 0], [2.197, 2.068], [0, 0], [-0.781, -7.942], [-5.013, -4.395], [-5.925, 0], [-4.476, 2.783], [-2.409, 5.209], [0, 0], [0, 10.71], [5.225, 6.136], [8.333, 0], [5.094, -4.395], [0, 0]],
                            "v": [[47.51, -23.682], [43.677, -14.087], [33.545, -10.986], [22.534, -16.309], [19.043, -33.154], [19.043, -38.525], [22.778, -54.81], [33.74, -60.059], [43.774, -56.958], [47.607, -46.973], [62.256, -46.973], [53.564, -65.479], [33.74, -72.07], [18.14, -67.896], [7.812, -55.908], [4.199, -37.842], [4.199, -33.496], [12.036, -8.228], [33.545, 0.977], [53.687, -5.615], [62.158, -23.682]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "C",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "C",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        }, "fFamily": "Roboto"
    }, {
        "ch": "N",
        "size": 40,
        "style": "Bold",
        "w": 70.61,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[64.16, -71.094], [49.561, -71.094], [49.561, -24.219], [20.996, -71.094], [6.348, -71.094], [6.348, 0], [20.996, 0], [20.996, -46.777], [49.512, 0], [64.16, 0]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "N",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "N",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "A",
        "size": 40,
        "style": "Bold",
        "w": 67.29,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[51.416, 0], [66.992, 0], [40.381, -71.094], [26.807, -71.094], [0.342, 0], [15.918, 0], [20.801, -14.648], [46.484, -14.648]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "A",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[33.594, -53.125], [42.529, -26.514], [24.756, -26.514]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "A",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "A",
                "np": 5,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "T",
        "size": 40,
        "style": "Bold",
        "w": 62.65,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[59.863, -71.094], [1.953, -71.094], [1.953, -59.229], [23.438, -59.229], [23.438, 0], [38.086, 0], [38.086, -59.229], [59.863, -59.229]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "T",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "T",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "I",
        "size": 40,
        "style": "Bold",
        "w": 29.15,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[21.924, -71.094], [7.275, -71.094], [7.275, 0], [21.924, 0]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "I",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "I",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "G", "size": 40, "style": "Bold", "w": 68.12, "data": {
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [5.501, 0], [2.832, 3.809], [0, 7.455], [0, 0], [-2.605, 3.744], [-4.98, 0], [-2.23, -1.888], [-0.652, -4.069], [0, 0], [4.752, 4.021], [8.43, 0], [4.508, -2.75], [2.393, -5.192], [0, -7.096], [0, 0], [-2.523, -5.11], [-4.639, -2.686], [-6.152, 0], [-4.818, 1.741], [-2.637, 3.158]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [-2.344, 2.344], [-5.469, 0], [-2.832, -3.809], [0, 0], [0.032, -7.389], [2.604, -3.743], [3.906, 0], [2.229, 1.888], [0, 0], [-0.879, -7.682], [-4.753, -4.02], [-6.055, 0], [-4.509, 2.751], [-2.393, 5.193], [0, 0], [0.065, 6.902], [2.522, 5.111], [4.639, 2.686], [5.859, 0], [4.817, -1.741], [0, 0]],
                            "v": [[62.598, -37.354], [34.619, -37.354], [34.619, -26.562], [47.949, -26.562], [47.949, -14.307], [36.182, -10.791], [23.73, -16.504], [19.482, -33.398], [19.482, -37.939], [23.438, -54.639], [34.814, -60.254], [44.019, -57.422], [48.34, -48.486], [62.598, -48.486], [54.15, -66.04], [34.375, -72.07], [18.53, -67.944], [8.179, -56.03], [4.59, -37.598], [4.59, -32.764], [8.472, -14.746], [19.214, -3.052], [35.4, 0.977], [51.416, -1.636], [62.598, -8.984]],
                            "c": true
                        },
                        "ix": 2
                    }, "nm": "G", "mn": "ADBE Vector Shape - Group", "hd": false
                }], "nm": "G", "np": 3, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }]
        }, "fFamily": "Roboto"
    }, {
        "ch": "W",
        "size": 40,
        "style": "Bold",
        "w": 87.45,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[50.049, -71.094], [37.646, -71.094], [25.928, -20.605], [16.309, -71.094], [1.709, -71.094], [17.48, 0], [32.227, 0], [43.799, -47.559], [55.371, 0], [70.117, 0], [85.889, -71.094], [71.289, -71.094], [61.719, -20.508]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "W",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "W",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "D", "size": 40, "style": "Bold", "w": 64.99, "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [-4.948, 2.832], [-2.718, 5.144], [0, 6.609], [0, 0], [2.766, 5.193], [4.932, 2.816], [6.25, 0], [0, 0], [0, 0]],
                            "o": [[6.217, -0.032], [4.948, -2.832], [2.718, -5.143], [0, 0], [0, -6.608], [-2.767, -5.192], [-4.932, -2.815], [0, 0], [0, 0], [0, 0]],
                            "v": [[28.369, 0], [45.117, -4.297], [56.616, -16.26], [60.693, -33.887], [60.693, -37.158], [56.543, -54.858], [44.995, -66.87], [28.223, -71.094], [6.348, -71.094], [6.348, 0]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "D",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [-2.995, -3.727], [0, -7.227], [0, 0], [3.027, -3.743], [5.729, 0], [0, 0], [0, 0]],
                            "o": [[5.762, 0], [2.995, 3.728], [0, 0], [-0.066, 6.966], [-3.027, 3.744], [0, 0], [0, 0], [0, 0]],
                            "v": [[28.223, -59.229], [41.357, -53.638], [45.85, -37.207], [45.85, -33.447], [41.211, -17.383], [28.076, -11.768], [20.996, -11.768], [20.996, -59.229]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "D",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "D",
                "np": 5,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        }, "fFamily": "Roboto"
    }, {
        "ch": "H",
        "size": 40,
        "style": "Bold",
        "w": 70.65,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[64.209, -71.094], [49.561, -71.094], [49.561, -42.285], [20.996, -42.285], [20.996, -71.094], [6.348, -71.094], [6.348, 0], [20.996, 0], [20.996, -30.469], [49.561, -30.469], [49.561, 0], [64.209, 0]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "H",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "H",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "R", "size": 40, "style": "Bold", "w": 63.82, "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [-2.1, 3.239], [0, 4.851], [4.557, 3.744], [8.398, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [4.264, -1.92], [2.1, -3.239], [0, -6.836], [-4.558, -3.743], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[45.996, 0], [61.719, 0], [61.719, -0.684], [46.338, -29.736], [55.884, -37.476], [59.033, -49.609], [52.197, -65.479], [32.764, -71.094], [6.348, -71.094], [6.348, 0], [20.996, 0], [20.996, -26.025], [32.666, -26.025]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "R",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [-1.904, -1.92], [0, -3.352], [2.018, -1.871], [3.678, 0], [0, 0]],
                            "o": [[0, 0], [3.938, 0], [1.904, 1.921], [0, 3.288], [-2.019, 1.872], [0, 0], [0, 0]],
                            "v": [[20.996, -59.229], [32.764, -59.229], [41.528, -56.348], [44.385, -48.438], [41.357, -40.698], [32.812, -37.891], [20.996, -37.891]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "R",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "R",
                "np": 5,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        }, "fFamily": "Roboto"
    }, {
        "ch": "S", "size": 40, "style": "Bold", "w": 61.47, "data": {
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[1.953, -1.416], [3.483, 0], [0, 7.845], [0, 0], [-2.361, -3.483], [-4.492, -2.002], [-5.469, 0], [-4.655, 3.5], [0, 6.152], [3.809, 3.711], [8.333, 2.507], [2.327, 1.562], [0, 2.312], [-1.986, 1.514], [-3.581, 0], [-2.051, -1.807], [0, -3.255], [0, 0], [2.197, 3.353], [3.971, 1.839], [5.078, 0], [4.053, -1.692], [2.164, -3.011], [0, -3.841], [-8.073, -4.362], [-5.078, -1.643], [-1.953, -1.481], [0, -2.766]],
                            "o": [[-1.953, 1.416], [-9.375, 0], [0, 0], [0, 4.59], [2.36, 3.484], [4.492, 2.002], [7.877, 0], [4.655, -3.499], [0, -5.534], [-3.809, -3.711], [-4.525, -1.367], [-2.328, -1.562], [0, -2.473], [1.985, -1.514], [3.711, 0], [2.051, 1.807], [0, 0], [0, -4.264], [-2.197, -3.352], [-3.972, -1.839], [-5.046, 0], [-4.053, 1.693], [-2.165, 3.011], [0, 7.39], [2.962, 1.595], [5.078, 1.644], [1.953, 1.482], [0, 2.539]],
                            "v": [[40.283, -12.72], [32.129, -10.596], [18.066, -22.363], [3.369, -22.363], [6.909, -10.254], [17.188, -2.026], [32.129, 0.977], [50.928, -4.272], [57.91, -18.75], [52.197, -32.617], [33.984, -41.943], [23.706, -46.338], [20.215, -52.148], [23.193, -58.13], [31.543, -60.4], [40.186, -57.69], [43.262, -50.098], [57.91, -50.098], [54.614, -61.523], [45.361, -69.312], [31.787, -72.07], [18.14, -69.531], [8.813, -62.476], [5.566, -52.197], [17.676, -34.57], [29.736, -29.712], [40.283, -25.024], [43.213, -18.652]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "S", "mn": "ADBE Vector Shape - Group", "hd": false
                }], "nm": "S", "np": 3, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }]
        }, "fFamily": "Roboto"
    }, {
        "ch": "u",
        "size": 40,
        "style": "Bold",
        "w": 55.96,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [4.785, 0], [0, 5.508], [0, 0], [0, 0], [0, 0], [-2.979, -3.255], [-5.664, 0], [-3.484, 4.232]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [-1.791, 3.325], [-5.013, 0], [0, 0], [0, 0], [0, 0], [0.065, 6.283], [2.979, 3.255], [6.152, 0], [0, 0]],
                            "v": [[37.451, 0], [50.732, 0], [50.732, -52.832], [36.572, -52.832], [36.572, -15.387], [26.709, -10.4], [19.189, -18.661], [19.189, -52.832], [5.078, -52.832], [5.078, -18.213], [9.644, -3.906], [22.607, 0.977], [37.061, -5.371]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "u",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "u",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "b", "size": 40, "style": "Bold", "w": 56.3, "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [3.662, 4.736], [6.445, 0], [3.255, -3.809], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-5.73, 0], [-3.613, 4.736], [0, 8.464]],
                            "o": [[0, -8.594], [-3.662, -4.736], [-5.306, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [3.418, 4.395], [6.477, 0], [3.613, -4.736], [0, 0]],
                            "v": [[53.027, -26.709], [47.534, -46.704], [32.373, -53.809], [19.531, -48.096], [19.531, -75], [5.42, -75], [5.42, 0], [18.115, 0], [18.75, -5.615], [32.471, 0.977], [47.607, -6.128], [53.027, -25.928]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "b",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0.684, -2.148], [4.557, 0], [1.725, 3.711], [0, 0], [-4.492, 0], [-1.693, -2.457], [0, -5.338]],
                            "o": [[-1.433, 4.492], [-4.525, 0], [0, 0], [1.692, -3.678], [3.352, 0], [1.692, 2.458], [0, 4.395]],
                            "v": [[37.891, -17.139], [28.906, -10.4], [19.531, -15.967], [19.531, -36.816], [28.809, -42.334], [36.377, -38.647], [38.916, -26.953]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "b",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "b",
                "np": 5,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        }, "fFamily": "Roboto"
    }, {
        "ch": "n",
        "size": 40,
        "style": "Bold",
        "w": 56.01,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [-3.972, 0], [-1.302, -1.35], [0, -2.995], [0, 0], [0, 0], [0, 0], [2.734, 3.288], [5.598, 0], [3.776, -4.72], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [1.985, -3.385], [3.027, 0], [1.302, 1.351], [0, 0], [0, 0], [0, 0], [-0.066, -6.543], [-2.734, -3.288], [-6.348, 0], [0, 0], [0, 0]],
                            "v": [[5.127, -52.832], [5.127, 0], [19.238, 0], [19.238, -37.256], [28.174, -42.334], [34.668, -40.308], [36.621, -33.789], [36.621, 0], [50.732, 0], [50.732, -34.131], [46.533, -48.877], [34.033, -53.809], [18.848, -46.729], [18.408, -52.832]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "n",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "n",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "e", "size": 40, "style": "Bold", "w": 54.05, "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-3.613, 1.676], [-2.116, 2.995], [0, 0], [5.436, 0], [2.295, 2.084], [0.455, 3.451], [0, 0], [0, 0], [4.15, 4.558], [7.227, 0], [3.76, -2.262], [2.051, -4.182], [0, -5.305], [0, 0], [-4.867, -4.752], [-7.748, 0]],
                            "o": [[3.613, -1.676], [0, 0], [-3.06, 3.939], [-3.516, 0], [-2.295, -2.083], [0, 0], [0, 0], [0, -8.366], [-4.15, -4.557], [-4.818, 0], [-3.76, 2.263], [-2.051, 4.183], [0, 0], [0, 7.91], [4.866, 4.753], [4.395, 0]],
                            "v": [[41.748, -1.538], [50.342, -8.545], [43.408, -16.309], [30.664, -10.4], [21.948, -13.525], [17.822, -21.826], [51.465, -21.826], [51.465, -27.588], [45.239, -46.973], [28.174, -53.809], [15.308, -50.415], [6.592, -40.747], [3.516, -26.514], [3.516, -25.146], [10.815, -6.152], [29.736, 0.977]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "e",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.628, -1.717], [-0.066, -3.139], [0, 0], [0, 0], [-1.742, 1.897], [-2.8, 0]],
                            "o": [[1.627, 1.717], [0, 0], [0, 0], [0.488, -3.531], [1.741, -1.897], [2.995, 0]],
                            "v": [[35.059, -39.857], [37.598, -32.574], [37.598, -31.445], [17.969, -31.445], [21.313, -39.587], [28.125, -42.432]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "e",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "e",
                "np": 5,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        }, "fFamily": "Roboto"
    }, {
        "ch": "t",
        "size": 40,
        "style": "Bold",
        "w": 33.79,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-9.896, 0], [-2.767, 0.846], [0, 0], [1.562, 0], [0.748, 0.847], [0, 1.953], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0.195, 9.994], [2.93, 0], [0, 0], [-1.205, 0.228], [-2.116, 0], [-0.749, -0.846], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[8.203, -65.82], [8.203, -52.832], [0.488, -52.832], [0.488, -42.48], [8.203, -42.48], [8.203, -14.014], [23.34, 0.977], [31.885, -0.293], [31.885, -10.986], [27.734, -10.645], [23.438, -11.914], [22.314, -16.113], [22.314, -42.48], [31.348, -42.48], [31.348, -52.832], [22.314, -52.832], [22.314, -65.82]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "t",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "t",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "3", "size": 40, "style": "Bold", "w": 57.37, "data": {
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[0, 0], [0, 0], [0, -7.096], [1.904, -1.774], [3.352, 0], [2.002, 1.693], [0, 2.67], [0, 0], [-4.509, -3.743], [-7.097, 0], [-4.607, 3.809], [0, 6.316], [1.969, 2.865], [4.004, 1.433], [-1.986, 2.734], [0, 3.255], [4.264, 3.597], [7.52, 0], [3.596, -1.66], [2.002, -2.946], [0, -3.711], [0, 0], [-1.823, 1.482], [-2.702, 0], [-1.709, -1.595], [0, -2.864], [1.725, -1.79], [3.58, 0], [0, 0]],
                            "o": [[0, 0], [7.812, 0], [0, 2.93], [-1.904, 1.775], [-2.93, 0], [-2.002, -1.692], [0, 0], [0, 6.152], [4.508, 3.744], [7.584, 0], [4.606, -3.809], [0, -3.906], [-1.97, -2.864], [3.223, -1.465], [1.985, -2.734], [0, -6.315], [-4.265, -3.596], [-4.33, 0], [-3.597, 1.66], [-2.002, 2.946], [0, 0], [0, -2.376], [1.823, -1.481], [2.995, 0], [1.709, 1.595], [0, 2.962], [-1.726, 1.791], [0, 0], [0, 0]],
                            "v": [[19.189, -30.762], [26.66, -30.762], [38.379, -20.117], [35.522, -13.062], [27.637, -10.4], [20.239, -12.939], [17.236, -19.482], [3.125, -19.482], [9.888, -4.639], [27.295, 0.977], [45.581, -4.736], [52.49, -19.922], [49.536, -30.078], [40.576, -36.523], [48.389, -42.822], [51.367, -51.807], [44.971, -66.675], [27.295, -72.07], [15.405, -69.58], [7.007, -62.671], [4.004, -52.686], [18.115, -52.686], [20.85, -58.472], [27.637, -60.693], [34.692, -58.301], [37.256, -51.611], [34.668, -44.482], [26.709, -41.797], [19.189, -41.797]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "3", "mn": "ADBE Vector Shape - Group", "hd": false
                }], "nm": "3", "np": 3, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }]
        }, "fFamily": "Roboto"
    }, {
        "ch": "O", "size": 40, "style": "Bold", "w": 69.04, "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [2.522, 5.322], [4.606, 2.849], [5.924, 0], [4.606, -2.848], [2.522, -5.322], [0, -6.998], [0, 0], [-2.539, -5.257], [-4.623, -2.832], [-5.892, 0], [-4.607, 2.865], [-2.474, 5.273], [0, 6.999]],
                            "o": [[0, -6.966], [-2.523, -5.322], [-4.607, -2.848], [-5.925, 0], [-4.607, 2.849], [-2.523, 5.322], [0, 0], [0.032, 6.836], [2.539, 5.257], [4.622, 2.832], [5.957, 0], [4.606, -2.864], [2.473, -5.273], [0, 0]],
                            "v": [[64.746, -37.109], [60.962, -55.542], [50.269, -67.798], [34.473, -72.07], [18.677, -67.798], [7.983, -55.542], [4.199, -37.061], [4.199, -33.545], [8.057, -15.405], [18.799, -3.271], [34.57, 0.977], [50.415, -3.32], [61.035, -15.527], [64.746, -33.936]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "O",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [2.637, -3.857], [4.915, 0], [2.669, 4.004], [0, 7.259], [0, 0], [-2.67, 3.825], [-4.916, 0], [-2.67, -3.873], [0, -7.454]],
                            "o": [[-0.033, 7.39], [-2.637, 3.857], [-5.013, 0], [-2.67, -4.004], [0, 0], [0.032, -7.389], [2.669, -3.825], [4.948, 0], [2.669, 3.874], [0, 0]],
                            "v": [[49.902, -33.691], [45.898, -16.821], [34.57, -11.035], [23.047, -17.041], [19.043, -33.936], [19.043, -37.402], [23.096, -54.224], [34.473, -59.961], [45.898, -54.15], [49.902, -37.158]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "O",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "O",
                "np": 5,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        }, "fFamily": "Roboto"
    }, {
        "ch": "j", "size": 40, "style": "Bold", "w": 25.98, "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [4.264, 0], [1.693, 0.293], [0, 0], [-2.441, 0], [-3.093, 3.239], [0, 5.827], [0, 0]],
                            "o": [[0, 0], [0, 4.524], [-1.27, 0], [0, 0], [2.214, 0.553], [5.827, 0], [3.092, -3.239], [0, 0], [0, 0]],
                            "v": [[6.201, -52.832], [6.201, 2.979], [-0.195, 9.766], [-4.639, 9.326], [-4.639, 20.508], [2.344, 21.338], [15.723, 16.479], [20.361, 2.881], [20.361, -52.832]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "j",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.449, -1.367], [-2.377, 0], [-1.449, 1.367], [0, 2.148], [1.416, 1.367], [2.441, 0], [1.416, -1.367], [0, -2.116]],
                            "o": [[1.448, 1.367], [2.376, 0], [1.448, -1.367], [0, -2.116], [-1.416, -1.367], [-2.441, 0], [-1.416, 1.367], [0, 2.148]],
                            "v": [[7.251, -61.23], [12.988, -59.18], [18.726, -61.23], [20.898, -66.504], [18.774, -71.729], [12.988, -73.779], [7.202, -71.729], [5.078, -66.504]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "j",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "j",
                "np": 5,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        }, "fFamily": "Roboto"
    }, {
        "ch": "c", "size": 40, "style": "Bold", "w": 52.15, "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[1.66, 2.38], [0, 5.445], [0, 0], [-1.677, 2.396], [-3.288, 0], [-1.628, -1.718], [-0.066, -2.748], [0, 0], [3.987, 3.76], [6.608, 0], [4.329, -4.85], [0, -8.138], [0, 0], [-4.362, -4.801], [-7.552, 0], [-3.337, 1.643], [-1.921, 2.979], [-0.033, 3.581], [0, 0], [1.627, -1.432], [2.604, 0]],
                            "o": [[-1.66, -2.38], [0, 0], [0, -5.379], [1.676, -2.396], [2.669, 0], [1.627, 1.718], [0, 0], [-0.066, -6.25], [-3.988, -3.76], [-7.552, 0], [-4.33, 4.851], [0, 0], [0, 8.464], [4.362, 4.802], [4.036, 0], [3.336, -1.643], [1.92, -2.979], [0, 0], [-0.066, 2.377], [-1.628, 1.433], [-3.386, 0]],
                            "v": [[19.824, -13.97], [17.334, -25.707], [17.334, -27.174], [19.849, -38.837], [27.295, -42.432], [33.74, -39.854], [36.279, -33.154], [49.512, -33.154], [43.433, -48.169], [27.539, -53.809], [9.717, -46.533], [3.223, -27.051], [3.223, -26.123], [9.766, -6.226], [27.637, 0.977], [38.696, -1.489], [46.582, -8.423], [49.512, -18.262], [36.279, -18.262], [33.74, -12.549], [27.393, -10.4]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "c",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "c",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        }, "fFamily": "Roboto"
    }, {
        "ch": "K",
        "size": 40,
        "style": "Bold",
        "w": 63.48,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[46.875, 0], [64.307, 0], [38.33, -39.502], [63.574, -71.094], [45.557, -71.094], [27.441, -47.705], [20.996, -38.867], [20.996, -71.094], [6.348, -71.094], [6.348, 0], [20.996, 0], [20.996, -20.312], [28.613, -28.516]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "K",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "K",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "y",
        "size": 40,
        "style": "Bold",
        "w": 50.2,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [1.318, -0.814], [2.669, 0], [0, 0], [0, 0], [-2.051, 0], [-3.158, 6.901], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [-0.749, 1.888], [-1.318, 0.813], [0, 0], [0, 0], [2.116, 0.618], [7.259, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[15.332, -52.832], [0.146, -52.832], [18.652, 0.146], [16.992, 4.492], [13.892, 8.545], [7.91, 9.766], [5.762, 9.717], [5.762, 20.41], [12.012, 21.338], [27.637, 10.986], [28.809, 8.203], [50.049, -52.832], [34.912, -52.832], [25.146, -19.971]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "y",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "y",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "l",
        "size": 40,
        "style": "Bold",
        "w": 26.51,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[20.312, -75], [6.152, -75], [6.152, 0], [20.312, 0]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "l",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "l",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "a", "size": 40, "style": "Bold", "w": 53.61, "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0.032, 5.013], [0, 0], [3.825, 3.271], [6.51, 0], [3.45, -1.481], [1.888, -2.604], [0, -3.059], [0, 0], [-1.351, 1.14], [-2.377, 0], [-1.254, -1.465], [0, -2.441], [0, 0], [0, 0], [4.15, -2.995], [0, -5.598], [-3.402, -2.995], [-5.176, 0], [-3.418, 3.809], [-0.652, -1.27]],
                            "o": [[0, 0], [-1.367, -2.571], [0, 0], [0, -5.924], [-3.825, -3.271], [-4.297, 0], [-3.451, 1.482], [-1.888, 2.605], [0, 0], [0, -1.985], [1.35, -1.139], [2.702, 0], [1.253, 1.465], [0, 0], [0, 0], [-7.845, 0.033], [-4.15, 2.995], [0, 4.558], [3.401, 2.995], [5.469, 0], [0.293, 1.888], [0, 0]],
                            "v": [[50.293, 0], [50.293, -0.83], [48.193, -12.207], [48.193, -35.107], [42.456, -48.901], [26.953, -53.809], [15.332, -51.587], [7.324, -45.459], [4.492, -36.963], [18.604, -36.963], [20.63, -41.65], [26.221, -43.359], [32.153, -41.162], [34.033, -35.303], [34.033, -32.275], [27.539, -32.275], [9.546, -27.734], [3.32, -14.844], [8.423, -3.516], [21.289, 0.977], [34.619, -4.736], [36.035, 0]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "a",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[1.237, 1.14], [0, 1.758], [0, 0], [-7.064, 0], [0, 0], [0, 0], [1.758, -0.928], [2.083, 0]],
                            "o": [[-1.237, -1.139], [0, 0], [0.455, -4.883], [0, 0], [0, 0], [-0.847, 1.562], [-1.758, 0.928], [-2.148, 0]],
                            "v": [[19.287, -11.523], [17.432, -15.869], [17.48, -16.699], [28.76, -24.023], [34.033, -24.023], [34.033, -14.941], [30.127, -11.206], [24.365, -9.814]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "a",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "a",
                "np": 5,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        }, "fFamily": "Roboto"
    }, {
        "ch": "s", "size": 40, "style": "Bold", "w": 51.42, "data": {
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0, "ty": "sh", "ix": 1, "ks": {
                        "a": 0, "k": {
                            "i": [[1.383, -1.025], [2.702, 0], [1.725, 1.335], [0.13, 2.507], [0, 0], [-1.953, -2.75], [-3.435, -1.579], [-4.427, 0], [-4.134, 2.979], [0, 4.818], [7.454, 2.734], [3.516, 0.7], [1.481, 0.961], [0, 1.562], [-1.302, 1.074], [-2.377, 0], [-1.302, -1.318], [0, -2.018], [0, 0], [4.02, 3.158], [6.705, 0], [3.889, -3.141], [0, -4.688], [-12.566, -2.637], [-1.709, -0.993], [0, -1.725]],
                            "o": [[-1.384, 1.025], [-2.898, 0], [-1.726, -1.334], [0, 0], [0, 3.191], [1.953, 2.751], [3.434, 1.579], [6.543, 0], [4.134, -2.979], [0, -6.738], [-2.409, -0.879], [-3.516, -0.7], [-1.482, -0.96], [0, -1.66], [1.302, -1.074], [2.766, 0], [1.302, 1.318], [0, 0], [0, -5.045], [-4.021, -3.157], [-6.283, 0], [-3.89, 3.142], [0, 8.041], [3.776, 0.781], [1.709, 0.993], [0, 1.66]],
                            "v": [[31.958, -10.571], [25.83, -9.033], [18.896, -11.035], [16.113, -16.797], [2.734, -16.797], [5.664, -7.886], [13.745, -1.392], [25.537, 0.977], [41.553, -3.491], [47.754, -15.186], [36.572, -29.395], [27.686, -31.763], [20.19, -34.253], [17.969, -38.037], [19.922, -42.139], [25.439, -43.75], [31.543, -41.772], [33.496, -36.768], [47.607, -36.768], [41.577, -49.072], [25.488, -53.809], [10.229, -49.097], [4.395, -37.354], [23.242, -21.338], [31.47, -18.677], [34.033, -14.6]],
                            "c": true
                        }, "ix": 2
                    }, "nm": "s", "mn": "ADBE Vector Shape - Group", "hd": false
                }], "nm": "s", "np": 3, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }]
        }, "fFamily": "Roboto"
    }, {
        "ch": "E",
        "size": 40,
        "style": "Bold",
        "w": 56.25,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[49.121, -42.285], [20.996, -42.285], [20.996, -59.229], [53.906, -59.229], [53.906, -71.094], [6.348, -71.094], [6.348, 0], [54.004, 0], [54.004, -11.768], [20.996, -11.768], [20.996, -30.811], [49.121, -30.811]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "E",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "E",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "k",
        "size": 38,
        "style": "Bold",
        "w": 53.42,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[38.184, 0], [54.395, 0], [33.643, -30.811], [52.734, -52.832], [35.791, -52.832], [22.266, -36.963], [19.531, -33.447], [19.531, -75], [5.42, -75], [5.42, 0], [19.531, 0], [19.531, -16.113], [24.609, -21.191]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "k",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "k",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "o", "size": 40, "style": "Bold", "w": 56.54, "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [-4.541, -4.883], [-7.617, 0], [-4.525, 4.9], [0, 8.105], [0, 0], [4.508, 4.362], [7.129, 0], [3.792, -2.246], [2.018, -4.102], [0, -5.241]],
                            "o": [[0, 8.398], [4.541, 4.883], [7.617, 0], [4.524, -4.899], [0, 0], [-0.521, -7.487], [-4.509, -4.362], [-5.013, 0], [-3.793, 2.246], [-2.019, 4.102], [0, 0]],
                            "v": [[3.223, -26.27], [10.034, -6.348], [28.271, 0.977], [46.484, -6.372], [53.271, -25.879], [53.174, -29.492], [45.63, -47.266], [28.174, -53.809], [14.966, -50.439], [6.25, -40.918], [3.223, -26.904]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "o",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.888, 2.69], [-3.451, 0], [-1.921, -2.705], [0, -4.922], [1.92, -2.625], [3.418, 0], [1.888, 2.657], [0, 5.021]],
                            "o": [[1.888, -2.689], [3.483, 0], [1.92, 2.706], [0, 5.771], [-1.921, 2.625], [-3.516, 0], [-1.888, -2.657], [0, -5.64]],
                            "v": [[20.166, -38.397], [28.174, -42.432], [36.279, -38.373], [39.16, -26.929], [36.279, -14.337], [28.271, -10.4], [20.166, -14.386], [17.334, -25.903]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "o",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "o",
                "np": 5,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        }, "fFamily": "Roboto"
    }, {
        "ch": "i",
        "size": 40,
        "style": "Bold",
        "w": 26.51,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[20.312, -52.832], [6.152, -52.832], [6.152, 0], [20.312, 0]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "i",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.449, -1.367], [-2.377, 0], [-1.449, 1.367], [0, 2.148], [1.432, 1.367], [2.409, 0], [1.416, -1.367], [0, -2.116]],
                            "o": [[1.448, 1.367], [2.376, 0], [1.448, -1.367], [0, -2.116], [-1.433, -1.367], [-2.441, 0], [-1.416, 1.367], [0, 2.148]],
                            "v": [[7.495, -61.23], [13.232, -59.18], [18.97, -61.23], [21.143, -66.504], [18.994, -71.729], [13.232, -73.779], [7.446, -71.729], [5.322, -66.504]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "i",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "i",
                "np": 5,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "r",
        "size": 40,
        "style": "Bold",
        "w": 36.47,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [1.562, 0], [2.832, -4.85], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-5.339, 0], [-1.921, -0.26]],
                            "o": [[-1.367, -0.423], [-5.013, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [1.66, -3.613], [1.465, 0], [0, 0]],
                            "v": [[35.303, -53.174], [30.908, -53.809], [19.141, -46.533], [18.75, -52.832], [5.42, -52.832], [5.42, 0], [19.531, 0], [19.531, -34.57], [30.029, -39.99], [35.107, -39.6]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "r",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "r",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "Q", "size": 40, "style": "Bold", "w": 69.04, "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [2.522, 5.322], [4.606, 2.849], [5.924, 0], [4.606, -2.848], [2.522, -5.322], [0, -6.998], [0, 0], [-2.539, -5.257], [-4.623, -2.832], [-5.892, 0], [-1.726, 0.293], [0, 0], [0, 0], [0, 0], [-2.148, 4.9], [0, 6.641]],
                            "o": [[0, -6.966], [-2.523, -5.322], [-4.607, -2.848], [-5.925, 0], [-4.607, 2.849], [-2.523, 5.322], [0, 0], [0.032, 6.836], [2.539, 5.257], [4.622, 2.832], [1.855, 0], [0, 0], [0, 0], [0, 0], [3.809, -2.962], [2.148, -4.899], [0, 0]],
                            "v": [[64.648, -37.109], [60.864, -55.542], [50.171, -67.798], [34.375, -72.07], [18.579, -67.798], [7.886, -55.542], [4.102, -37.061], [4.102, -33.545], [7.959, -15.405], [18.701, -3.271], [34.473, 0.977], [39.844, 0.537], [54.98, 12.695], [64.307, 4.443], [52.49, -4.834], [61.426, -16.626], [64.648, -33.936]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Q",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [2.637, -3.857], [4.915, 0], [2.669, 4.004], [0, 7.259], [0, 0], [-2.67, 3.825], [-4.916, 0], [-2.67, -3.873], [0, -7.454]],
                            "o": [[-0.033, 7.39], [-2.637, 3.857], [-5.013, 0], [-2.67, -4.004], [0, 0], [0.032, -7.389], [2.669, -3.825], [4.948, 0], [2.669, 3.874], [0, 0]],
                            "v": [[49.805, -33.691], [45.801, -16.821], [34.473, -11.035], [22.949, -17.041], [18.945, -33.936], [18.945, -37.402], [22.998, -54.224], [34.375, -59.961], [45.801, -54.15], [49.805, -37.158]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Q",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "Q",
                "np": 5,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        }, "fFamily": "Roboto"
    }, {
        "ch": "p", "size": 40, "style": "Bold", "w": 56.3, "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [3.613, 4.818], [6.51, 0], [3.418, -4.102], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-5.339, 0], [-3.695, 4.9], [0, 8.138]],
                            "o": [[0, -8.463], [-3.613, -4.817], [-5.502, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [3.288, 3.711], [6.282, 0], [3.694, -4.899], [0, 0]],
                            "v": [[52.979, -26.66], [47.559, -46.582], [32.373, -53.809], [18.994, -47.656], [18.506, -52.832], [5.42, -52.832], [5.42, 20.312], [19.531, 20.312], [19.531, -4.59], [32.471, 0.977], [47.437, -6.372], [52.979, -25.928]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "p",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[6.738, 0], [1.725, 3.484], [0, 0], [-4.427, 0], [-1.742, -2.669], [0, -4.915]],
                            "o": [[-4.427, 0], [0, 0], [1.66, -3.385], [3.32, 0], [1.741, 2.67], [0, 11.035]],
                            "v": [[28.76, -10.4], [19.531, -15.625], [19.531, -37.256], [28.662, -42.334], [36.255, -38.33], [38.867, -26.953]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "p",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "p",
                "np": 5,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        }, "fFamily": "Roboto"
    }, {
        "ch": "L",
        "size": 40,
        "style": "Bold",
        "w": 54.15,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[20.996, -71.094], [6.348, -71.094], [6.348, 0], [52.1, 0], [52.1, -11.768], [20.996, -11.768]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "L",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "L",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "B", "size": 40, "style": "Bold", "w": 63.82, "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [-4.362, 3.516], [0, 6.836], [2.1, 2.767], [3.645, 0.912], [-1.791, 2.654], [0, 3.484], [4.459, 3.304], [8.626, 0], [0, 0], [0, 0]],
                            "o": [[8.073, -0.065], [4.362, -3.516], [0, -4.004], [-2.1, -2.766], [3.19, -1.237], [1.79, -2.653], [0, -6.38], [-4.46, -3.304], [0, 0], [0, 0], [0, 0]],
                            "v": [[33.984, 0], [52.637, -5.371], [59.18, -20.898], [56.03, -31.055], [47.412, -36.572], [54.883, -42.407], [57.568, -51.611], [50.879, -66.138], [31.25, -71.094], [6.348, -71.094], [6.348, 0]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "B",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, -6.51], [1.936, -1.643], [3.45, 0], [0, 0], [0, 0]],
                            "o": [[6.738, 0.098], [0, 2.898], [-1.937, 1.644], [0, 0], [0, 0], [0, 0]],
                            "v": [[34.424, -30.957], [44.531, -21.045], [41.626, -14.233], [33.545, -11.768], [20.996, -11.768], [20.996, -30.957]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "B",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ind": 2,
                    "ty": "sh",
                    "ix": 3,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [-1.872, -1.416], [0, -3.223], [7.389, -0.13], [0, 0]],
                            "o": [[0, 0], [4.036, 0], [1.871, 1.416], [0, 5.762], [0, 0], [0, 0]],
                            "v": [[20.996, -59.229], [31.25, -59.229], [40.112, -57.104], [42.92, -50.146], [31.836, -41.309], [20.996, -41.309]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "B",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "B",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        }, "fFamily": "Roboto"
    }, {
        "ch": "M",
        "size": 40,
        "style": "Bold",
        "w": 87.6,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[6.348, -71.094], [6.348, 0], [20.996, 0], [20.996, -19.434], [19.531, -52.93], [38.672, 0], [48.73, 0], [67.92, -52.979], [66.455, -19.434], [66.455, 0], [81.152, 0], [81.152, -71.094], [61.914, -71.094], [43.75, -19.531], [25.488, -71.094]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "M",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "M",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "m",
        "size": 40,
        "style": "Bold",
        "w": 86.57,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [-4.004, 0], [-1.205, -1.367], [0, -3.059], [0, 0], [0, 0], [0, 0], [-4.232, 0], [-1.172, -1.383], [0, -2.995], [0, 0], [0, 0], [0, 0], [2.799, 3.337], [5.729, 0], [3.711, -5.371], [6.803, 0], [3.743, -4.59], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [1.79, -3.32], [2.897, 0], [1.204, 1.367], [0, 0], [0, 0], [0, 0], [1.627, -4.036], [2.962, 0], [1.172, 1.384], [0, 0], [0, 0], [0, 0], [0, -6.705], [-2.8, -3.336], [-6.869, 0], [-2.539, -5.371], [-6.38, 0], [0, 0], [0, 0]],
                            "v": [[5.42, -52.832], [5.42, 0], [19.531, 0], [19.531, -37.354], [28.223, -42.334], [34.375, -40.283], [36.182, -33.643], [36.182, 0], [50.293, 0], [50.244, -36.279], [59.033, -42.334], [65.234, -40.259], [66.992, -33.691], [66.992, 0], [81.152, 0], [81.152, -33.74], [76.953, -48.804], [64.16, -53.809], [48.291, -45.752], [34.277, -53.809], [19.092, -46.924], [18.652, -52.832]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "m",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "m",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "U",
        "size": 36,
        "style": "Bold",
        "w": 65.82,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [8.235, 0], [2.229, 2.132], [0, 4.655], [0, 0], [0, 0], [0, 0], [-4.883, -4.395], [-8.301, 0], [-4.867, 4.525], [0, 7.78], [0, 0]],
                            "o": [[0, 0], [-0.13, 8.659], [-3.939, 0], [-2.23, -2.132], [0, 0], [0, 0], [0, 0], [0.098, 7.683], [4.883, 4.395], [8.43, 0], [4.866, -4.524], [0, 0], [0, 0]],
                            "v": [[45.459, -71.094], [45.459, -23.779], [32.91, -10.791], [23.657, -13.989], [20.312, -24.17], [20.312, -71.094], [5.664, -71.094], [5.664, -23.73], [13.135, -5.615], [32.91, 0.977], [52.856, -5.811], [60.156, -24.268], [60.156, -71.094]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "U",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "U",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "5", "size": 40, "style": "Bold", "w": 57.37, "data": {
            "shapes": [{
                "ty": "gr", "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [-3.353, 0], [-1.986, -2.148], [0, -4.036], [1.725, -2.295], [3.19, 0], [1.774, 1.644], [0.293, 2.962], [0, 0], [-2.132, -3.157], [-3.679, -1.741], [-4.297, 0], [-3.613, 2.002], [-1.937, 3.63], [0, 4.59], [3.841, 4.199], [6.77, 0], [3.352, -1.79], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [2.083, -1.758], [3.645, 0], [1.985, 2.148], [0, 4.199], [-1.726, 2.295], [-2.865, 0], [-1.775, -1.643], [0, 0], [0.13, 4.037], [2.132, 3.158], [3.678, 1.741], [4.915, 0], [3.613, -2.002], [1.936, -3.629], [0, -7.552], [-3.841, -4.199], [-3.777, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[18.164, -32.178], [19.531, -33.447], [27.686, -36.084], [36.133, -32.861], [39.111, -23.584], [36.523, -13.843], [29.15, -10.4], [22.192, -12.866], [19.092, -19.775], [5.127, -19.775], [8.521, -8.984], [17.236, -1.636], [29.199, 0.977], [41.992, -2.026], [50.317, -10.474], [53.223, -22.803], [47.461, -40.43], [31.543, -46.729], [20.85, -44.043], [22.607, -59.326], [50.879, -59.326], [50.879, -71.094], [11.035, -71.094], [6.934, -34.961]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "5",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }], "nm": "5", "np": 3, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
            }]
        }, "fFamily": "Roboto"
    }, {
        "ch": "d",
        "size": 40,
        "style": "Bold",
        "w": 56.35,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-3.76, -4.899], [-6.218, 0], [-3.516, 4.395], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [5.143, 0], [3.694, -4.883], [0, -8.235]],
                            "o": [[3.76, 4.9], [5.534, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-3.353, -3.841], [-6.413, 0], [-3.695, 4.883], [0, 8.724]],
                            "v": [[8.862, -6.372], [23.828, 0.977], [37.402, -5.615], [38.086, 0], [50.83, 0], [50.83, -75], [36.67, -75], [36.67, -48.047], [23.926, -53.809], [8.765, -46.484], [3.223, -26.807]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "d",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-6.804, 0], [-1.758, -3.683], [0, 0], [4.362, 0], [1.725, 2.641], [0, 4.956]],
                            "o": [[4.329, 0], [0, 0], [-1.791, 3.684], [-3.288, 0], [-1.726, -2.641], [0, -11.052]],
                            "v": [[27.539, -42.334], [36.67, -36.808], [36.67, -15.926], [27.441, -10.4], [19.922, -14.362], [17.334, -25.756]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "d",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "d",
                "np": 5,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "v",
        "size": 40,
        "style": "Bold",
        "w": 50.54,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[15.381, -52.832], [0.635, -52.832], [18.457, 0], [31.934, 0], [49.756, -52.832], [35.01, -52.832], [25.195, -17.236]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "v",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "v",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "h",
        "size": 40,
        "style": "Bold",
        "w": 55.96,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-4.134, 0], [-1.302, -1.448], [0, -3.027], [0, 0], [0, 0], [0, 0], [11.458, 0], [3.743, -4.492]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [1.855, -3.19], [3.027, 0], [1.302, 1.449], [0, 0], [0, 0], [0, 0], [-0.163, -13.313], [-5.664, 0], [0, 0]],
                            "v": [[19.189, -75], [5.078, -75], [5.078, 0], [19.189, 0], [19.189, -37.549], [28.174, -42.334], [34.668, -40.161], [36.621, -33.447], [36.621, 0], [50.732, 0], [50.732, -33.838], [33.301, -53.809], [19.189, -47.07]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "h",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "h",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }, {
        "ch": "w",
        "size": 40,
        "style": "Bold",
        "w": 73.49,
        "data": {
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[41.748, -52.832], [31.543, -52.832], [21.875, -19.238], [14.99, -52.832], [1.367, -52.832], [14.844, 0], [26.611, 0], [36.621, -33.252], [46.631, 0], [58.447, 0], [71.924, -52.832], [58.301, -52.832], [51.367, -19.189]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "w",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }],
                "nm": "w",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }]
        },
        "fFamily": "Roboto"
    }]
}